import {
  e as CoroutineScope,
  a as CoroutineStart_UNDISPATCHED_getInstance,
  j as async,
  f as CoroutineScope_0,
  b as withContext,
  g as Job,
  d as CompletableDeferred,
  k as completeWith,
  h as get_MODE_CANCELLABLE,
  c as CancellableContinuationImpl,
} from './kotlinx.coroutines-kotlinx-coroutines-core-js-ir.mjs';
import {
  d5 as CoroutineImpl,
  ga as VOID,
  a1 as Unit_getInstance,
  s9 as THROW_CCE,
  e6 as isInterface,
  p4 as get_COROUTINE_SUSPENDED,
  o4 as CancellationException,
  ba as printStackTrace,
  p5 as classMeta,
  o6 as setMetadataFor,
  b7 as KProperty0,
  w5 as getPropertyCallableRef,
  z9 as lazy,
  r6 as toString,
  c6 as isComparable,
  f6 as isNumber,
  j6 as numberToDouble,
  q5 as compareTo,
  a as getKClassFromExpression,
  m6 as objectMeta,
  ea as toString_0,
  q2 as getOrNull,
  l1 as List,
  n1 as Map,
  p9 as NullPointerException,
  b3 as listOf,
  c4 as toList,
  i1 as Iterable,
  h2 as emptyList,
  e1 as ArrayList,
  a2 as collectionSizeOrDefault,
  r8 as toIntOrNull,
  o8 as toDoubleOrNull,
  r as DoubleCompanionObject_getInstance,
  s2 as joinToString,
  k6 as numberToInt,
  l6 as numberToLong,
  s5 as equals,
  m9 as Long,
  y5 as hashCode,
  f9 as Comparable,
  q8 as toIntOrNull_0,
  u8 as toLongOrNull,
  o7 as indexOf,
  f as _Char___init__impl__6a9atx,
  y7 as replace,
  a8 as split,
  b8 as startsWith,
  n5 as charSequenceLength,
  k5 as charArrayOf,
  y8 as trimEnd,
  c9 as trim,
  k8 as substringBefore,
  j7 as contains,
  d8 as substringAfterLast,
  y9 as ensureNotNull,
  s as IntCompanionObject_getInstance,
  q6 as toLong,
  g6 as isObject,
  g9 as Enum,
  x5 as getStringHashCode,
  z4 as get,
  n6 as protoOf,
  y4 as fold,
  a5 as minusKey,
  c5 as plus,
  b5 as Element,
  j1 as LinkedHashMap,
  m7 as endsWith,
  d3 as mapCapacity,
  u6 as coerceAtLeast,
  x6 as until,
  r9 as RuntimeException,
  fa as to,
  v8 as toLongOrNull_0,
  e9 as Char,
  g7 as StringBuilder,
  i6 as numberToChar,
  y6 as until_0,
  w6 as step,
  m5 as charSequenceGet,
  k as Char__toInt_impl_vasixd,
  k9 as IllegalStateException,
  v9 as UnsupportedOperationException,
  i9 as Exception,
  j5 as captureStack,
  h7 as concatToString,
  r7 as get_lastIndex,
  t7 as lastIndexOf,
  f7 as Regex,
  z7 as split_0,
  w2 as get_lastIndex_0,
  k7 as dropLast,
  f8 as substringAfter,
  i8 as substringBeforeLast,
  b9 as trimStart,
  j as Char__toByte_impl_7s7yt0,
  t8 as toInt,
  p6 as toByte,
  c7 as KProperty1,
  c3 as listOf_0,
  f4 as toMap,
  b6 as isCharSequence,
  d9 as trim_0,
  k2 as filterNotNull,
  n4 as compareValues,
  d4 as toList_0,
  n7 as equals_0,
  n2 as first,
  a4 as sortedWith,
  j4 as toSet,
  s3 as plus_0,
  f1 as Collection,
  a3 as linkedMapOf,
  g as Char__compareTo_impl_ypi4mb,
  i5 as boxApply,
  z5 as interfaceMeta,
  t6 as ClosedRange,
  v6 as contains_0,
  c2 as copyOf,
  h as Char__minus_impl_a2frrh,
  y as Companion_getInstance,
  l5 as charArray,
  t as StringCompanionObject_getInstance,
  j9 as IllegalArgumentException,
  t5 as fillArrayVal,
  a6 as isArray,
  e4 as toMap_0,
  o9 as NotImplementedError,
  l2 as firstOrNull,
  z3 as setOf,
  z as Companion_getInstance_0,
  m as _Result___init__impl__xyqfz8,
  x9 as createFailure,
  aa as noWhenBranchMatchedException,
  r4 as intercepted,
  l4 as toTypedArray,
  e as returnIfSuspended,
} from './kotlin-kotlin-stdlib.mjs';
import {
  a as Level_ERROR_getInstance,
  c as Companion_getInstance_1,
  b as Level_INFO_getInstance,
} from './korge-root-klogger.mjs';
import {
  c as Companion_getInstance_2,
  b as Companion_getInstance_3,
  d as DateTime,
  a as DateTime__hashCode_impl_yf0bc9,
} from './korge-root-klock.mjs';
import {
  c as Mixin,
  e as FastStringMap,
  g as linkedHashMapOf,
  f as IntIntMap,
  a as NonRecursiveLock,
  d as FastArrayList,
  b as DoubleArrayList,
} from './korge-root-kds.mjs';
import {
  f as readS16,
  d as extract,
  e as insert,
  c as clamp,
  a as ByteArrayBuilder,
  b as arraycopy,
  g as toIntClamp,
} from './korge-root-kmem.mjs';
import { a as Hex_getInstance } from './korge-root-krypto.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class _async$slambda extends CoroutineImpl {
  constructor($callback, resultContinuation, $box) {
    if ($box === VOID)
      $box = {};
    $box.f37_1 = $callback;
    super(resultContinuation, $box);
  }
  i37($this$async, $completion) {
    var tmp = this.j37($this$async, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  qg(p1, $completion) {
    return this.i37((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 3;
            this.of_1 = 2;
            this.nf_1 = 1;
            suspendResult = this.f37_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.h37_1 = suspendResult;
            this.of_1 = 3;
            this.nf_1 = 4;
            continue $sm;
          case 2:
            this.of_1 = 3;
            var tmp_0 = this.qf_1;
            if (tmp_0 instanceof Error) {
              var e = this.qf_1;
              var tmp_1 = this;
              if (e instanceof CancellationException)
                throw e;
              if (get_DEBUG_ASYNC_LAUNCH_ERRORS()) {
                {
                  var tmp0_error = get_logger();
                  {
                    var tmp0_log = Level_ERROR_getInstance();
                    if (tmp0_error.v36(tmp0_log)) {
                      tmp0_error.w36(tmp0_log, 'CoroutineScope._async.catch:');
                    }
                  }
                }
                printStackTrace(e);
              }
              throw e;
            } else {
              throw this.qf_1;
            }

            break;
          case 3:
            throw this.qf_1;
          case 4:
            this.of_1 = 3;
            return this.h37_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.of_1 === 3) {
          throw e_0;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e_0;
        }
      }
     while (true);
  }
  j37($this$async, completion) {
    var i = new _async$slambda(this.f37_1, completion);
    i.g37_1 = $this$async;
    return i;
  }
}
class AsyncThread$sync$slambda extends CoroutineImpl {
  constructor($oldPromise, $func, resultContinuation, $box) {
    if ($box === VOID)
      $box = {};
    $box.s37_1 = $oldPromise;
    $box.t37_1 = $func;
    super(resultContinuation, $box);
  }
  w37($completion) {
    var tmp = this.x37($completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  y37($completion) {
    return this.w37($completion);
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 4;
            this.u37_1 = this.s37_1;
            if (this.u37_1 == null) {
              this.v37_1 = null;
              this.nf_1 = 2;
              continue $sm;
            } else {
              this.nf_1 = 1;
              suspendResult = this.u37_1.c2t(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

            break;
          case 1:
            this.v37_1 = suspendResult;
            this.nf_1 = 2;
            continue $sm;
          case 2:
            ;
            this.nf_1 = 3;
            suspendResult = this.t37_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 4) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
  x37(completion) {
    var i = new AsyncThread$sync$slambda(this.s37_1, this.t37_1, completion);
    return i;
  }
}
class AsyncThread {
  constructor() {
    this.z37_1 = null;
  }
  a38(func, $completion) {
    var tmp$ret$0;
    // Inline function 'kotlin.js.getCoroutineContext' call
    tmp$ret$0 = $completion.uf();
    var task = this.b38(tmp$ret$0, func);
    var tmp0 = task.c2t($completion);
    return tmp0;
  }
  b38(context, func) {
    var oldPromise = this.z37_1;
    var promise = asyncImmediately_0(context, AsyncThread$sync$slambda_0(oldPromise, func, null));
    this.z37_1 = promise;
    return promise;
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
  }
}
class Dyn {
  constructor(value) {
    Companion_getInstance_4();
    this.c38_1 = value;
  }
  f38(other) {
    return Dyn__compareTo_impl_7znl52(this.c38_1, other);
  }
  d(other) {
    return Dyn__compareTo_impl_7znl52_0(this, other);
  }
  toString() {
    return Dyn__toString_impl_9l0v3s(this.c38_1);
  }
  hashCode() {
    return Dyn__hashCode_impl_vc6rwn(this.c38_1);
  }
  equals(other) {
    return Dyn__equals_impl_sp125n(this.c38_1, other);
  }
}
class VfsNamed {
  constructor(pathInfo) {
    this.g38_1 = pathInfo;
  }
  h38() {
    return this.g38_1;
  }
}
class Vfs$Proxy$initOnce$slambda extends CoroutineImpl {
  constructor(this$0, resultContinuation, $box) {
    if ($box === VOID)
      $box = {};
    $box.q38_1 = this$0;
    super(resultContinuation, $box);
  }
  r38($completion) {
    var tmp = this.x37($completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  y37($completion) {
    return this.r38($completion);
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 3;
            this.of_1 = 2;
            this.nf_1 = 1;
            suspendResult = this.q38_1.u38(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.of_1 = 3;
            this.nf_1 = 4;
            continue $sm;
          case 2:
            this.of_1 = 3;
            var tmp_0 = this.qf_1;
            if (tmp_0 instanceof Error) {
              var e = this.qf_1;
              {
                var tmp0_error = this.q38_1.s38_1;
                {
                  var tmp0_log = Level_ERROR_getInstance();
                  if (tmp0_error.v36(tmp0_log)) {
                    tmp0_error.w36(tmp0_log, 'Error initializing ' + this.q38_1);
                  }
                }
              }
              printStackTrace(e);
              this.nf_1 = 4;
              continue $sm;
            } else {
              throw this.qf_1;
            }

            break;
          case 3:
            throw this.qf_1;
          case 4:
            this.of_1 = 3;
            return Unit_getInstance();
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.of_1 === 3) {
          throw e_0;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e_0;
        }
      }
     while (true);
  }
  x37(completion) {
    var i = new Vfs$Proxy$initOnce$slambda(this.q38_1, completion);
    return i;
  }
}
class $initOnceCOROUTINE$44 extends CoroutineImpl {
  constructor(_this__u8e3s4, resultContinuation) {
    super(resultContinuation);
    this.d39_1 = _this__u8e3s4;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 2;
            if (this.d39_1.t38_1 == null) {
              var tmp_0 = this.d39_1;
              var tmp_1 = this.uf();
              tmp_0.t38_1 = async_0(tmp_1, Vfs$Proxy$initOnce$slambda_0(this.d39_1, null));
            }

            this.nf_1 = 1;
            suspendResult = ensureNotNull(this.d39_1.t38_1).c2t(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.d39_1;
          case 2:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 2) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $openCOROUTINE$46 extends CoroutineImpl {
  constructor(_this__u8e3s4, path, mode, resultContinuation) {
    super(resultContinuation);
    this.m39_1 = _this__u8e3s4;
    this.n39_1 = path;
    this.o39_1 = mode;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 4;
            this.nf_1 = 1;
            suspendResult = this.m39_1.r39(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.p39_1 = suspendResult;
            this.nf_1 = 2;
            suspendResult = this.p39_1.s39(this.n39_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.q39_1 = suspendResult;
            this.nf_1 = 3;
            suspendResult = this.q39_1.y39(this.o39_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 4) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $readRangeCOROUTINE$47 extends CoroutineImpl {
  constructor(_this__u8e3s4, path, range, resultContinuation) {
    super(resultContinuation);
    this.h3a_1 = _this__u8e3s4;
    this.i3a_1 = path;
    this.j3a_1 = range;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 4;
            this.nf_1 = 1;
            suspendResult = this.h3a_1.r39(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.k3a_1 = suspendResult;
            this.nf_1 = 2;
            suspendResult = this.k3a_1.s39(this.i3a_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.l3a_1 = suspendResult;
            this.nf_1 = 3;
            suspendResult = this.l3a_1.m3a(this.j3a_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 4) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $statCOROUTINE$50 extends CoroutineImpl {
  constructor(_this__u8e3s4, path, resultContinuation) {
    super(resultContinuation);
    this.v3a_1 = _this__u8e3s4;
    this.w3a_1 = path;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 4;
            this.nf_1 = 1;
            suspendResult = this.v3a_1.r39(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.x3a_1 = suspendResult;
            this.nf_1 = 2;
            suspendResult = this.x3a_1.s39(this.w3a_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.y3a_1 = suspendResult;
            this.nf_1 = 3;
            suspendResult = this.y3a_1.z3a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            return ARGUMENT.q3b(this.v3a_1.a3b(this.w3a_1));
          case 4:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 4) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class Vfs {
  u3b() {
    return '';
  }
  v3b(path) {
    return _PathInfo___get_fullPath__impl__21fx6x(lightCombine(get_pathInfo(this.u3b()), get_pathInfo(path)));
  }
  e2f() {
    return new VfsFile(this, '');
  }
  fc(path) {
    return this.e2f().fc(path);
  }
  a3b(path) {
    return this.e2f().fc(path);
  }
  w3b($completion) {
    return Unit_getInstance();
  }
  x3b(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new VfsStat(this.a3b(path), true, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, VOID, id);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.Vfs.createExistsStat.<anonymous>' call
    if (cache)
      tmp0_also.b3b_1.x39_1 = tmp0_also;
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  }
  y3b(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache, $super) {
    device = device === VOID ? new Long(-1, -1) : device;
    inode = inode === VOID ? new Long(-1, -1) : inode;
    mode = mode === VOID ? 511 : mode;
    owner = owner === VOID ? 'nobody' : owner;
    group = group === VOID ? 'nobody' : group;
    createTime = createTime === VOID ? Companion_getInstance_3().d33_1 : createTime;
    modifiedTime = modifiedTime === VOID ? Companion_getInstance_3().d33_1 : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? modifiedTime : lastAccessTime;
    extraInfo = extraInfo === VOID ? null : extraInfo;
    id = id === VOID ? null : id;
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.x3b(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache) : $super.x3b.call(this, path, isDirectory, size, device, inode, mode, owner, group, new DateTime(createTime), new DateTime(modifiedTime), new DateTime(lastAccessTime), extraInfo, id, cache);
  }
  z3b(path, extraInfo, cache) {
    return new VfsStat(this.a3b(path), false, false, new Long(0, 0), new Long(-1, -1), new Long(-1, -1), 511, 'nobody', 'nobody', Companion_getInstance_3().d33_1, Companion_getInstance_3().d33_1, Companion_getInstance_3().d33_1, extraInfo);
  }
  a3c(path, extraInfo, cache, $super) {
    extraInfo = extraInfo === VOID ? null : extraInfo;
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.z3b(path, extraInfo, cache) : $super.z3b.call(this, path, extraInfo, cache);
  }
  r3b(path, mode, $completion) {
    unsupported(this);
  }
  s3b(path, range, $completion) {
    var tmp = new $readRangeCOROUTINE$34(this, path, range, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  t3b(path, $completion) {
    return this.a3c(path);
  }
  toString() {
    return get_portableSimpleName(getKClassFromExpression(this));
  }
}
class Proxy extends Vfs {
  constructor() {
    super();
    this.s38_1 = Companion_getInstance_1().h36('Proxy');
    this.t38_1 = null;
  }
  u38($completion) {
    return Unit_getInstance();
  }
  r39($completion) {
    var tmp = new $initOnceCOROUTINE$44(this, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  r3b(path, mode, $completion) {
    var tmp = new $openCOROUTINE$46(this, path, mode, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  s3b(path, range, $completion) {
    var tmp = new $readRangeCOROUTINE$47(this, path, range, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  t3b(path, $completion) {
    var tmp = new $statCOROUTINE$50(this, path, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
}
class $readRangeCOROUTINE$34 extends CoroutineImpl {
  constructor(_this__u8e3s4, path, range, resultContinuation) {
    super(resultContinuation);
    this.j3c_1 = _this__u8e3s4;
    this.k3c_1 = path;
    this.l3c_1 = range;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 6;
            this.nf_1 = 1;
            suspendResult = this.j3c_1.r3b(this.k3c_1, VfsOpenMode_READ_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.m3c_1 = suspendResult;
            this.n3c_1 = null;
            this.of_1 = 3;
            this.m3c_1.s3c_1 = this.l3c_1.ub();
            this.nf_1 = 2;
            var tmp0_minus = toLong(IntCompanionObject_getInstance().MAX_VALUE);
            var tmp1_min = tmp0_minus.hd(new Long(1, 0));
            var tmp2_min = this.l3c_1.vb().hd(this.l3c_1.ub());
            suspendResult = readBytesUpTo(this.m3c_1, (tmp1_min.gd(tmp2_min) <= 0 ? tmp1_min : tmp2_min).md() + 1 | 0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o3c_1 = suspendResult;
            this.of_1 = 6;
            this.nf_1 = 4;
            continue $sm;
          case 3:
            this.of_1 = 6;
            var tmp_0 = this.qf_1;
            if (tmp_0 instanceof Error) {
              this.p3c_1 = this.qf_1;
              var tmp_1 = this;
              this.n3c_1 = this.p3c_1;
              tmp_1.o3c_1 = null;
              this.nf_1 = 4;
              continue $sm;
            } else {
              throw this.qf_1;
            }

            break;
          case 4:
            this.of_1 = 6;
            this.q3c_1 = this.o3c_1;
            this.nf_1 = 5;
            suspendResult = this.m3c_1.w3b(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!(this.n3c_1 == null))
              throw this.n3c_1;
            var tmp_2 = this.q3c_1;
            return (tmp_2 == null ? true : isObject(tmp_2)) ? tmp_2 : THROW_CCE();
          case 6:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 6) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class VfsOpenMode extends Enum {
  constructor(name, ordinal, cmode, write, createIfNotExists, truncate) {
    createIfNotExists = createIfNotExists === VOID ? false : createIfNotExists;
    truncate = truncate === VOID ? false : truncate;
    super(name, ordinal);
    this.z3c_1 = cmode;
    this.a3d_1 = write;
    this.b3d_1 = createIfNotExists;
    this.c3d_1 = truncate;
  }
}
class VfsStat {
  constructor(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id) {
    device = device === VOID ? new Long(-1, -1) : device;
    inode = inode === VOID ? new Long(-1, -1) : inode;
    mode = mode === VOID ? 511 : mode;
    owner = owner === VOID ? 'nobody' : owner;
    group = group === VOID ? 'nobody' : group;
    createTime = createTime === VOID ? Companion_getInstance_3().d33_1 : createTime;
    modifiedTime = modifiedTime === VOID ? createTime : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? modifiedTime : lastAccessTime;
    extraInfo = extraInfo === VOID ? null : extraInfo;
    kind = kind === VOID ? null : kind;
    id = id === VOID ? null : id;
    this.b3b_1 = file;
    this.c3b_1 = exists;
    this.d3b_1 = isDirectory;
    this.e3b_1 = size;
    this.f3b_1 = device;
    this.g3b_1 = inode;
    this.h3b_1 = mode;
    this.i3b_1 = owner;
    this.j3b_1 = group;
    this.k3b_1 = createTime;
    this.l3b_1 = modifiedTime;
    this.m3b_1 = lastAccessTime;
    this.n3b_1 = extraInfo;
    this.o3b_1 = kind;
    this.p3b_1 = id;
  }
  h38() {
    return this.b3b_1.h38();
  }
  d3d(showFile) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = ArrayList.f4(16);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.VfsStat.toString.<anonymous>' call
    if (showFile) {
      tmp0_also.e1('file=' + this.b3b_1);
    } else {
      tmp0_also.e1('file=' + this.b3b_1.u3b());
    }
    tmp0_also.e1('exists=' + this.c3b_1);
    tmp0_also.e1('isDirectory=' + this.d3b_1);
    tmp0_also.e1('size=' + toString(this.e3b_1));
    tmp0_also.e1('device=' + toString(this.f3b_1));
    tmp0_also.e1('inode=' + toString(this.g3b_1));
    tmp0_also.e1('mode=' + this.h3b_1);
    tmp0_also.e1('owner=' + this.i3b_1);
    tmp0_also.e1('group=' + this.j3b_1);
    tmp0_also.e1('createTime=' + new DateTime(this.k3b_1));
    tmp0_also.e1('modifiedTime=' + new DateTime(this.l3b_1));
    tmp0_also.e1('lastAccessTime=' + new DateTime(this.m3b_1));
    tmp0_also.e1('extraInfo=' + toString_0(this.n3b_1));
    if (!(this.o3b_1 == null)) {
      tmp0_also.e1('kind=' + this.o3b_1);
    }
    tmp0_also.e1('id=' + this.p3b_1);
    tmp$ret$0 = tmp0_also;
    return 'VfsStat(' + joinToString(tmp$ret$0, ', ') + ')';
  }
  toString() {
    return this.d3d(true);
  }
  e3d(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id) {
    return new VfsStat(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id);
  }
  q3b(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, $super) {
    file = file === VOID ? this.b3b_1 : file;
    exists = exists === VOID ? this.c3b_1 : exists;
    isDirectory = isDirectory === VOID ? this.d3b_1 : isDirectory;
    size = size === VOID ? this.e3b_1 : size;
    device = device === VOID ? this.f3b_1 : device;
    inode = inode === VOID ? this.g3b_1 : inode;
    mode = mode === VOID ? this.h3b_1 : mode;
    owner = owner === VOID ? this.i3b_1 : owner;
    group = group === VOID ? this.j3b_1 : group;
    createTime = createTime === VOID ? this.k3b_1 : createTime;
    modifiedTime = modifiedTime === VOID ? this.l3b_1 : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? this.m3b_1 : lastAccessTime;
    extraInfo = extraInfo === VOID ? this.n3b_1 : extraInfo;
    kind = kind === VOID ? this.o3b_1 : kind;
    id = id === VOID ? this.p3b_1 : id;
    return $super === VOID ? this.e3d(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id) : $super.e3d.call(this, file, exists, isDirectory, size, device, inode, mode, owner, group, new DateTime(createTime), new DateTime(modifiedTime), new DateTime(lastAccessTime), extraInfo, kind, id);
  }
  hashCode() {
    var result = this.b3b_1.hashCode();
    result = imul(result, 31) + (this.c3b_1 | 0) | 0;
    result = imul(result, 31) + (this.d3b_1 | 0) | 0;
    result = imul(result, 31) + this.e3b_1.hashCode() | 0;
    result = imul(result, 31) + this.f3b_1.hashCode() | 0;
    result = imul(result, 31) + this.g3b_1.hashCode() | 0;
    result = imul(result, 31) + this.h3b_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.i3b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j3b_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.k3b_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.l3b_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.m3b_1) | 0;
    result = imul(result, 31) + (this.n3b_1 == null ? 0 : hashCode(this.n3b_1)) | 0;
    result = imul(result, 31) + (this.o3b_1 == null ? 0 : hashCode(this.o3b_1)) | 0;
    result = imul(result, 31) + (this.p3b_1 == null ? 0 : getStringHashCode(this.p3b_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsStat))
      return false;
    var tmp0_other_with_cast = other instanceof VfsStat ? other : THROW_CCE();
    if (!this.b3b_1.equals(tmp0_other_with_cast.b3b_1))
      return false;
    if (!(this.c3b_1 === tmp0_other_with_cast.c3b_1))
      return false;
    if (!(this.d3b_1 === tmp0_other_with_cast.d3b_1))
      return false;
    if (!this.e3b_1.equals(tmp0_other_with_cast.e3b_1))
      return false;
    if (!this.f3b_1.equals(tmp0_other_with_cast.f3b_1))
      return false;
    if (!this.g3b_1.equals(tmp0_other_with_cast.g3b_1))
      return false;
    if (!(this.h3b_1 === tmp0_other_with_cast.h3b_1))
      return false;
    if (!(this.i3b_1 === tmp0_other_with_cast.i3b_1))
      return false;
    if (!(this.j3b_1 === tmp0_other_with_cast.j3b_1))
      return false;
    if (!equals(this.k3b_1, tmp0_other_with_cast.k3b_1))
      return false;
    if (!equals(this.l3b_1, tmp0_other_with_cast.l3b_1))
      return false;
    if (!equals(this.m3b_1, tmp0_other_with_cast.m3b_1))
      return false;
    if (!equals(this.n3b_1, tmp0_other_with_cast.n3b_1))
      return false;
    if (!equals(this.o3b_1, tmp0_other_with_cast.o3b_1))
      return false;
    if (!(this.p3b_1 == tmp0_other_with_cast.p3b_1))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
  }
}
class VfsCachedStatContext {
  constructor(stat) {
    Companion_getInstance_5();
    this.f3d_1 = stat;
  }
  o3() {
    return Companion_getInstance_5();
  }
}
class $readStringCOROUTINE$65 extends CoroutineImpl {
  constructor(_this__u8e3s4, charset, resultContinuation) {
    super(resultContinuation);
    this.o3d_1 = _this__u8e3s4;
    this.p3d_1 = charset;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 2;
            this.nf_1 = 1;
            suspendResult = this.o3d_1.q3d(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return toString_2(ARGUMENT, this.p3d_1);
          case 2:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 2) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $statCOROUTINE$68 extends CoroutineImpl {
  constructor(_this__u8e3s4, resultContinuation) {
    super(resultContinuation);
    this.z3d_1 = _this__u8e3s4;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 3;
            this.a3e_1 = this.z3d_1.x39_1;
            if (this.a3e_1 == null) {
              this.nf_1 = 1;
              suspendResult = this.z3d_1.u39_1.t3b(this.z3d_1.v39_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.b3e_1 = this.a3e_1;
              this.nf_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this.b3e_1 = suspendResult;
            this.nf_1 = 2;
            continue $sm;
          case 2:
            return this.b3e_1;
          case 3:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 3) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class VfsFile extends VfsNamed {
  constructor(vfs, path) {
    super(get_pathInfo(path));
    this.u39_1 = vfs;
    this.v39_1 = path;
    this.w39_1 = new Mixin();
    this.x39_1 = null;
  }
  e2f() {
    return this.u39_1.e2f();
  }
  u3b() {
    return this.u39_1.v3b(this.v39_1);
  }
  fc(path) {
    return new VfsFile(this.u39_1, _PathInfo___get_fullPath__impl__21fx6x(combine(get_pathInfo(this.v39_1), get_pathInfo(path))));
  }
  y39(mode, $completion) {
    var tmp0 = this.u39_1.r3b(this.v39_1, mode, $completion);
    return tmp0;
  }
  m3a(range, $completion) {
    var tmp0 = this.u39_1.s3b(this.v39_1, range, $completion);
    return tmp0;
  }
  c3e($completion) {
    var tmp0 = this.u39_1.s3b(this.v39_1, get_LONG_ZERO_TO_MAX_RANGE(), $completion);
    return tmp0;
  }
  q3d($completion) {
    var tmp0 = this.c3e($completion);
    return tmp0;
  }
  d3e(charset, $completion) {
    var tmp = new $readStringCOROUTINE$65(this, charset, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  e3e(charset, $completion, $super) {
    charset = charset === VOID ? get_UTF8() : charset;
    return $super === VOID ? this.d3e(charset, $completion) : $super.d3e.call(this, charset, $completion);
  }
  z3a($completion) {
    var tmp = new $statCOROUTINE$68(this, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  f3e() {
    return Companion_getInstance_6().g3e(this);
  }
  toString() {
    return '' + this.u39_1 + '[' + this.v39_1 + ']';
  }
  hashCode() {
    var result = hashCode(this.u39_1);
    result = imul(result, 31) + getStringHashCode(this.v39_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsFile))
      return false;
    var tmp0_other_with_cast = other instanceof VfsFile ? other : THROW_CCE();
    if (!equals(this.u39_1, tmp0_other_with_cast.u39_1))
      return false;
    if (!(this.v39_1 === tmp0_other_with_cast.v39_1))
      return false;
    return true;
  }
}
class $getLengthCOROUTINE$88 extends CoroutineImpl {
  constructor(_this__u8e3s4, resultContinuation) {
    super(resultContinuation);
    this.p3e_1 = _this__u8e3s4;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 3;
            var tmp0_safe_receiver = this.p3e_1.s3e_1;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c3b_1) === true) {
              this.q3e_1 = this.p3e_1.s3e_1.e3b_1;
              this.nf_1 = 2;
              continue $sm;
            } else {
              this.nf_1 = 1;
              suspendResult = this.p3e_1.r3e_1.t3e(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

            break;
          case 1:
            this.q3e_1 = suspendResult;
            this.nf_1 = 2;
            continue $sm;
          case 2:
            return this.q3e_1;
          case 3:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 3) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class CatalogVfs$open$slambda extends CoroutineImpl {
  constructor(this$0, $path, $mode, resultContinuation, $box) {
    if ($box === VOID)
      $box = {};
    $box.c3f_1 = this$0;
    $box.d3f_1 = $path;
    $box.e3f_1 = $mode;
    super(resultContinuation, $box);
  }
  g3f($this$withContext, $completion) {
    var tmp = this.j37($this$withContext, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  qg(p1, $completion) {
    return this.g3f((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 2;
            this.nf_1 = 1;
            suspendResult = protoOf(Proxy).r3b.call(this.c3f_1, this.d3f_1, this.e3f_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.r3c_1;
          case 2:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 2) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
  j37($this$withContext, completion) {
    var i = new CatalogVfs$open$slambda(this.c3f_1, this.d3f_1, this.e3f_1, completion);
    i.f3f_1 = $this$withContext;
    return i;
  }
}
class AsyncGetLengthStream {}
function hasLength($completion) {
  var tmp = new $hasLengthCOROUTINE$158(this, $completion);
  tmp.pf_1 = Unit_getInstance();
  tmp.qf_1 = null;
  return tmp.ag();
}
function getLength($completion) {
  throw UnsupportedOperationException.o4();
}
class AsyncStreamBase {
  constructor($box) {
    boxApply(this, $box);
  }
  h3f(position, buffer, offset, len, $completion) {
    throw UnsupportedOperationException.o4();
  }
  t3e($completion) {
    throw UnsupportedOperationException.o4();
  }
  w3b($completion) {
    return Unit_getInstance();
  }
}
class CatalogVfs$open$2 extends AsyncStreamBase {
  constructor($base, $fstat, $box) {
    if ($box === VOID)
      $box = {};
    $box.r3e_1 = $base;
    $box.s3e_1 = $fstat;
    super($box);
  }
  h3f(position, buffer, offset, len, $completion) {
    var tmp0 = this.r3e_1.h3f(position, buffer, offset, len, $completion);
    return tmp0;
  }
  t3e($completion) {
    var tmp = new $getLengthCOROUTINE$88(this, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  w3b($completion) {
    var tmp0 = this.r3e_1.w3b($completion);
    return tmp0;
  }
}
class $openCOROUTINE$81 extends CoroutineImpl {
  constructor(_this__u8e3s4, path, mode, resultContinuation) {
    super(resultContinuation);
    this.r3f_1 = _this__u8e3s4;
    this.s3f_1 = path;
    this.t3f_1 = mode;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 3;
            this.nf_1 = 1;
            suspendResult = this.r3f_1.b3g(this.s3f_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.u3f_1 = suspendResult;
            this.nf_1 = 2;
            var tmp_0 = new VfsCachedStatContext(this.u3f_1);
            suspendResult = withContext(tmp_0, CatalogVfs$open$slambda_0(this.r3f_1, this.s3f_1, this.t3f_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var base = suspendResult;
            return buffered(toAsyncStream(new CatalogVfs$open$2(base, this.u3f_1)));
          case 3:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 3) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $statCOROUTINE$82 extends CoroutineImpl {
  constructor(_this__u8e3s4, path, resultContinuation) {
    super(resultContinuation);
    this.k3g_1 = _this__u8e3s4;
    this.l3g_1 = path;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 2;
            this.nf_1 = 1;
            suspendResult = this.k3g_1.b3g(this.l3g_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            return tmp0_elvis_lhs == null ? this.k3g_1.a3c(normalize(_PathInfo___init__impl__vpw96a(this.l3g_1)), VOID, true) : tmp0_elvis_lhs;
          case 2:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 2) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $statOrNullCOROUTINE$83 extends CoroutineImpl {
  constructor(_this__u8e3s4, path, resultContinuation) {
    super(resultContinuation);
    this.u3g_1 = _this__u8e3s4;
    this.v3g_1 = path;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 5;
            this.w3g_1 = normalize(_PathInfo___init__impl__vpw96a(this.v3g_1));
            if (this.w3g_1 === '/' ? true : this.w3g_1 === '') {
              return this.u3g_1.y3b('/', true, new Long(0, 0), VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
            }

            this.x3g_1 = get_baseName_0(_PathInfo___init__impl__vpw96a(this.w3g_1));
            this.nf_1 = 1;
            suspendResult = this.u3g_1.d3h(_PathInfo___get_fullPath__impl__21fx6x(get_parent(_PathInfo___init__impl__vpw96a(this.w3g_1))), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y3g_1 = suspendResult;
            if (this.y3g_1 == null) {
              var tmp_0 = this;
              tmp_0.a3h_1 = this.u3g_1.z3f_1;
              this.b3h_1 = this.a3h_1.u3(this.v3g_1);
              if (this.b3h_1 == null) {
                this.nf_1 = 2;
                suspendResult = this.u3g_1.x3f_1.fc(this.v3g_1).z3a(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_1 = this;
                tmp_1.c3h_1 = this.b3h_1;
                this.nf_1 = 3;
                continue $sm;
              }
            } else {
              this.z3g_1 = this.y3g_1;
              this.nf_1 = 4;
              continue $sm;
            }

            break;
          case 2:
            var answer = suspendResult;
            this.a3h_1.m3(this.v3g_1, answer);
            ;
            this.c3h_1 = answer;
            this.nf_1 = 3;
            continue $sm;
          case 3:
            var tmp_2 = this;
            return this.c3h_1;
          case 4:
            var info = this.z3g_1;
            var tmp1_elvis_lhs = info.u3(this.x3g_1);
            return tmp1_elvis_lhs == null ? this.u3g_1.a3c(this.w3g_1, VOID, true) : tmp1_elvis_lhs;
          case 5:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 5) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $cachedListSimpleStatsOrNullCOROUTINE$86 extends CoroutineImpl {
  constructor(_this__u8e3s4, path, resultContinuation) {
    super(resultContinuation);
    this.m3h_1 = _this__u8e3s4;
    this.n3h_1 = path;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 5;
            this.o3h_1 = normalize(_PathInfo___init__impl__vpw96a(this.n3h_1));
            this.nf_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0.q3h_1 = this.m3h_1.a3g_1;
            var tmp_1 = this;
            tmp_1.r3h_1 = this.q3h_1.get(this.o3h_1);
            if (!(this.r3h_1 == null)) {
              this.p3h_1 = this.r3h_1;
              this.nf_1 = 4;
              continue $sm;
            } else {
              this.nf_1 = 2;
              continue $sm;
            }

            break;
          case 2:
            this.nf_1 = 3;
            suspendResult = this.m3h_1.s3h(this.o3h_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var out = suspendResult;
            {
              {
                {
                }
                {
                  this.q3h_1.set(this.o3h_1, out);
                }
              }
            }

            this.p3h_1 = out;
            if (false) {
              this.nf_1 = 1;
              continue $sm;
            }

            this.nf_1 = 4;
            continue $sm;
          case 4:
            return this.p3h_1;
          case 5:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 5) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $listSimpleStatsOrNullCOROUTINE$87 extends CoroutineImpl {
  constructor(_this__u8e3s4, path, resultContinuation) {
    super(resultContinuation);
    this.b3i_1 = _this__u8e3s4;
    this.c3i_1 = path;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 3;
            this.of_1 = 2;
            this.nf_1 = 1;
            suspendResult = this.b3i_1.x3f_1.fc(this.c3i_1).fc('$catalog.json').e3e(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.d3i_1 = suspendResult;
            this.of_1 = 3;
            this.nf_1 = 4;
            continue $sm;
          case 2:
            this.of_1 = 3;
            var tmp_0 = this.qf_1;
            if (tmp_0 instanceof Error) {
              var e = this.qf_1;
              var tmp_1 = this;
              if (!(e instanceof FileNotFoundException)) {
                {
                  var tmp0_error = this.b3i_1.y3f_1;
                  {
                    var tmp0_log = Level_ERROR_getInstance();
                    if (tmp0_error.v36(tmp0_log)) {
                      tmp0_error.w36(tmp0_log, e);
                    }
                  }
                }
              }
              return null;
            } else {
              throw this.qf_1;
            }

            break;
          case 3:
            throw this.qf_1;
          case 4:
            this.of_1 = 3;
            var catalogJsonString = this.d3i_1;
            var data = get_dyn(Json_getInstance().e3i(catalogJsonString));
            var tmp0_subject = _Dyn___get_value__impl__bemnlg(data);
            if (!(tmp0_subject == null) ? isInterface(tmp0_subject, List) : false) {
              var tmp1_map = _Dyn___get_list__impl__qpwjp(data);
              var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp1_map, 10));
              var tmp0_iterator = tmp1_map.u();
              while (tmp0_iterator.h1()) {
                var item = tmp0_iterator.j1().c38_1;
                var localName = get_baseName_0(_PathInfo___init__impl__vpw96a(_Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80_0(item, 'name'))));
                tmp0_mapTo.e1(this.b3i_1.y3b(this.c3i_1 + '/' + localName, _Dyn___get_bool__impl__nv3iun(Dyn__get_impl_6l2p80_0(item, 'isDirectory')), _Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(item, 'size')), VOID, VOID, VOID, VOID, VOID, Companion_getInstance_3().g33(_Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(item, 'createTime'))), Companion_getInstance_3().g33(_Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(item, 'modifiedTime'))), VOID, VOID, VOID, true));
              }
              var tmp2_associateBy = tmp0_mapTo;
              var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp2_associateBy, 10)), 16);
              var tmp0_associateByTo = LinkedHashMap.o8(capacity);
              var tmp0_iterator_0 = tmp2_associateBy.u();
              while (tmp0_iterator_0.h1()) {
                var element = tmp0_iterator_0.j1();
                tmp0_associateByTo.m3(get_baseName(element), element);
              }
              return tmp0_associateByTo;
            } else {
              var out = LinkedHashMap.n8();
              var tmp1_iterator = _Dyn___get_keys__impl__o4xmor(data).u();
              while (tmp1_iterator.h1()) {
                var key = tmp1_iterator.j1().c38_1;
                var fileName = _Dyn___get_str__impl__dup4cs(key);
                var info = Dyn__get_impl_6l2p80(data, key);
                var tmp2_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 0));
                var size = tmp2_elvis_lhs == null ? new Long(0, 0) : tmp2_elvis_lhs;
                var tmp3_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 1));
                var creationTime = tmp3_elvis_lhs == null ? new Long(0, 0) : tmp3_elvis_lhs;
                var tmp4_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 2));
                var modifiedTime = tmp4_elvis_lhs == null ? creationTime : tmp4_elvis_lhs;
                var isDirectory = endsWith(fileName, '/');
                var baseName = trimEnd(fileName, charArrayOf([_Char___init__impl__6a9atx(47)]));
                {
                  var tmp3_set = this.b3i_1.y3b(this.c3i_1 + '/' + baseName, isDirectory, size, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_3().g33(creationTime), Companion_getInstance_3().g33(modifiedTime), VOID, VOID, VOID, true);
                  out.m3(baseName, tmp3_set);
                }
              }
              return out;
            }

            return Unit_getInstance();
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.of_1 === 3) {
          throw e_0;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e_0;
        }
      }
     while (true);
  }
}
class CatalogVfs extends Proxy {
  constructor(parent) {
    super();
    this.x3f_1 = parent;
    this.y3f_1 = Companion_getInstance_1().h36('CatalogVfs');
    this.z3f_1 = LinkedHashMap.n8();
    this.a3g_1 = FastStringMap();
  }
  r3b(path, mode, $completion) {
    var tmp = new $openCOROUTINE$81(this, path, mode, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  s39(path, $completion) {
    return this.x3f_1.fc(path);
  }
  t3b(path, $completion) {
    var tmp = new $statCOROUTINE$82(this, path, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  b3g(path, $completion) {
    var tmp = new $statOrNullCOROUTINE$83(this, path, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  d3h(path, $completion) {
    var tmp = new $cachedListSimpleStatsOrNullCOROUTINE$86(this, path, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  s3h(path, $completion) {
    var tmp = new $listSimpleStatsOrNullCOROUTINE$87(this, path, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
  }
  g3e(jailRoot) {
    return (new JailVfs(jailRoot, Unit_getInstance())).e2f();
  }
}
class JailVfs extends Proxy {
  constructor(jailRoot, dummy) {
    Companion_getInstance_6();
    super();
    this.h3i_1 = jailRoot;
    this.i3i_1 = normalize(this.h3i_1.h38());
  }
  s39(path, $completion) {
    return this.h3i_1.fc(trim(normalize(get_pathInfo(path)), charArrayOf([_Char___init__impl__6a9atx(47)])));
  }
  u3b() {
    return this.h3i_1.u3b();
  }
  toString() {
    return 'JailVfs(' + this.h3i_1 + ')';
  }
}
class StandardVfs {}
class Companion_2 {
  constructor() {
    Companion_instance_2 = this;
  }
}
class LocalVfs extends Vfs {
  constructor() {
    Companion_getInstance_7();
    super();
  }
  toString() {
    return 'LocalVfs';
  }
}
class $readCOROUTINE$113 extends CoroutineImpl {
  constructor(_this__u8e3s4, position, buffer, offset, len, resultContinuation) {
    super(resultContinuation);
    this.e3j_1 = _this__u8e3s4;
    this.f3j_1 = position;
    this.g3j_1 = buffer;
    this.h3j_1 = offset;
    this.i3j_1 = len;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 6;
            if (this.i3j_1 === 0)
              return 0;
            this.nf_1 = 1;
            suspendResult = _readRangeBase(this.e3j_1.o3j_1, this.e3j_1.p3j_1, until(this.f3j_1, this.f3j_1.bf(toLong(this.i3j_1))), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.j3j_1 = suspendResult;
            this.k3j_1 = this.j3j_1.v3j_1;
            this.l3j_1 = this.h3j_1;
            this.m3j_1 = this.i3j_1;
            this.n3j_1 = 0;
            this.nf_1 = 2;
            continue $sm;
          case 2:
            if (!(this.m3j_1 > 0)) {
              this.nf_1 = 5;
              continue $sm;
            }

            this.nf_1 = 3;
            suspendResult = this.k3j_1.y3j(this.g3j_1, this.l3j_1, this.m3j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var read = suspendResult;
            if (read < 0 ? this.n3j_1 === 0 : false)
              return read;
            if (read <= 0) {
              this.nf_1 = 5;
              continue $sm;
            } else {
              this.nf_1 = 4;
              continue $sm;
            }

            break;
          case 4:
            this.m3j_1 = this.m3j_1 - read | 0;
            this.n3j_1 = this.n3j_1 + read | 0;
            this.l3j_1 = this.l3j_1 + read | 0;
            this.nf_1 = 2;
            continue $sm;
          case 5:
            return this.n3j_1;
          case 6:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 6) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $getLengthCOROUTINE$114 extends CoroutineImpl {
  constructor(_this__u8e3s4, resultContinuation) {
    super(resultContinuation);
    this.h3k_1 = _this__u8e3s4;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 3;
            this.nf_1 = 1;
            suspendResult = this.h3k_1.i3f(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              this.i3k_1 = this.h3k_1.q3j_1.e3b_1;
              this.nf_1 = 2;
              continue $sm;
            } else {
              var tmp_0 = this;
              unsupported_0();
            }

            break;
          case 2:
            return this.i3k_1;
          case 3:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 3) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class UrlVfs$open$2 extends AsyncStreamBase {
  constructor(this$0, $fullUrl, $stat, $box) {
    if ($box === VOID)
      $box = {};
    $box.o3j_1 = this$0;
    $box.p3j_1 = $fullUrl;
    $box.q3j_1 = $stat;
    super($box);
  }
  h3f(position, buffer, offset, len, $completion) {
    var tmp = new $readCOROUTINE$113(this, position, buffer, offset, len, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  i3f($completion) {
    return this.q3j_1.e3b_1.gd(new Long(0, 0)) >= 0;
  }
  t3e($completion) {
    var tmp = new $getLengthCOROUTINE$114(this, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
}
class $openCOROUTINE$107 extends CoroutineImpl {
  constructor(_this__u8e3s4, path, mode, resultContinuation) {
    super(resultContinuation);
    this.d3l_1 = _this__u8e3s4;
    this.e3l_1 = path;
    this.f3l_1 = mode;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 6;
            this.of_1 = 5;
            this.g3l_1 = this.d3l_1.o3l(this.e3l_1);
            if (startsWith(this.g3l_1, 'file:')) {
              this.nf_1 = 4;
              suspendResult = this.d3l_1.l3l_1.q3l(this.g3l_1, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.nf_1 = 1;
              continue $sm;
            }

            break;
          case 1:
            var tmp_0 = this;
            var tmp0_safe_receiver = this.uf().vf(Companion_getInstance_5());
            tmp_0.h3l_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f3d_1;
            if (this.h3l_1 == null) {
              this.nf_1 = 2;
              suspendResult = this.d3l_1.t3b(this.e3l_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.i3l_1 = this.h3l_1;
              this.nf_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            this.i3l_1 = suspendResult;
            this.nf_1 = 3;
            continue $sm;
          case 3:
            var stat = this.i3l_1;
            var tmp_1 = stat.n3b_1;
            var response = tmp_1 instanceof Response ? tmp_1 : null;
            if (!stat.c3b_1) {
              throw FileNotFoundException.u3l('Unexistant ' + this.g3l_1 + ' : ' + response);
            }

            return buffered(toAsyncStream(new UrlVfs$open$2(this.d3l_1, this.g3l_1, stat)));
          case 4:
            var ARGUMENT = suspendResult;
            return openAsync(ARGUMENT);
          case 5:
            this.of_1 = 6;
            var tmp_2 = this.qf_1;
            if (tmp_2 instanceof RuntimeException) {
              var e = this.qf_1;
              var tmp2_elvis_lhs = e.message;
              throw FileNotFoundException.u3l(tmp2_elvis_lhs == null ? 'error' : tmp2_elvis_lhs);
            } else {
              throw this.qf_1;
            }

            break;
          case 6:
            throw this.qf_1;
          case 7:
            this.of_1 = 6;
            return Unit_getInstance();
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.of_1 === 6) {
          throw e_0;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e_0;
        }
      }
     while (true);
  }
}
class $_readRangeBaseCOROUTINE$109 extends CoroutineImpl {
  constructor(_this__u8e3s4, fullUrl, range, resultContinuation) {
    super(resultContinuation);
    this.r3k_1 = _this__u8e3s4;
    this.s3k_1 = fullUrl;
    this.t3k_1 = range;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 4;
            this.nf_1 = 1;
            suspendResult = this.r3k_1.l3l_1.i3m(Companion_getInstance_11().w3l_1, this.s3k_1, Headers.h3m(this.t3k_1.equals(get_LONG_ZERO_TO_MAX_RANGE()) ? LinkedHashMap.n8() : linkedHashMapOf([to('range', 'bytes=' + toString(this.t3k_1.ub()) + '-' + toString(this.t3k_1.vb()))])), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.u3k_1 = suspendResult;
            {
            }

            if (this.r3k_1.m3l_1) {
              if (this.u3k_1.r3j_1 === 404)
                throw FileNotFoundException.u3l(this.s3k_1 + ' not found');
              this.nf_1 = 2;
              suspendResult = this.u3k_1.j3m(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.nf_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            ;
            this.nf_1 = 3;
            continue $sm;
          case 3:
            return this.u3k_1;
          case 4:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 4) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $readRangeCOROUTINE$110 extends CoroutineImpl {
  constructor(_this__u8e3s4, path, range, resultContinuation) {
    super(resultContinuation);
    this.s3m_1 = _this__u8e3s4;
    this.t3m_1 = path;
    this.u3m_1 = range;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 3;
            this.nf_1 = 1;
            suspendResult = _readRangeBase(this.s3m_1, this.s3m_1.o3l(this.t3m_1), this.u3m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.v3m_1 = suspendResult;
            this.w3m_1 = this.v3m_1.v3j_1;
            this.nf_1 = 2;
            suspendResult = readAll(this.w3m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 3) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $statCOROUTINE$112 extends CoroutineImpl {
  constructor(_this__u8e3s4, path, resultContinuation) {
    super(resultContinuation);
    this.f3n_1 = _this__u8e3s4;
    this.g3n_1 = path;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 6;
            this.h3n_1 = this.f3n_1.o3l(this.g3n_1);
            if (startsWith(this.h3n_1, 'file:')) {
              this.of_1 = 3;
              this.nf_1 = 2;
              suspendResult = this.f3n_1.l3l_1.q3l(this.h3n_1, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.nf_1 = 1;
              suspendResult = this.f3n_1.l3l_1.i3m(Companion_getInstance_11().x3l_1, this.h3n_1, VOID, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

            break;
          case 1:
            var result = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (result.w3j_1) {
              var tmp0_safe_receiver = result.t3j_1.fc(Companion_getInstance_13().k3n_1);
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toLongOrNull_0(tmp0_safe_receiver);
              tmp_1 = this.f3n_1.y3b(this.g3n_1, false, tmp1_elvis_lhs == null ? new Long(-1, -1) : tmp1_elvis_lhs, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, result);
            } else {
              tmp_1 = this.f3n_1.a3c(this.g3n_1, result);
            }

            tmp_0.i3n_1 = tmp_1;
            this.nf_1 = 5;
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = ARGUMENT.length;
            var size = toLong(ARGUMENT_0);
            this.j3n_1 = this.f3n_1.y3b(this.g3n_1, false, size, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null);
            this.of_1 = 6;
            this.nf_1 = 4;
            continue $sm;
          case 3:
            this.of_1 = 6;
            var tmp_2 = this.qf_1;
            if (tmp_2 instanceof Error) {
              var e = this.qf_1;
              var tmp_3 = this;
              printStackTrace(e);
              tmp_3.j3n_1 = this.f3n_1.a3c(this.g3n_1);
              this.nf_1 = 4;
              continue $sm;
            } else {
              throw this.qf_1;
            }

            break;
          case 4:
            this.of_1 = 6;
            this.i3n_1 = this.j3n_1;
            this.nf_1 = 5;
            continue $sm;
          case 5:
            return this.i3n_1;
          case 6:
            throw this.qf_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.of_1 === 6) {
          throw e_0;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e_0;
        }
      }
     while (true);
  }
}
class UrlVfs extends Vfs {
  constructor(url, dummy, client, failFromStatus) {
    client = client === VOID ? createHttpClient() : client;
    failFromStatus = failFromStatus === VOID ? true : failFromStatus;
    super();
    this.j3l_1 = url;
    this.k3l_1 = dummy;
    this.l3l_1 = client;
    this.m3l_1 = failFromStatus;
    this.n3l_1 = this.j3l_1;
  }
  u3b() {
    return this.n3l_1;
  }
  o3l(path) {
    var result = trim(this.j3l_1, charArrayOf([_Char___init__impl__6a9atx(47)])) + new Char(_Char___init__impl__6a9atx(47)) + trim(path, charArrayOf([_Char___init__impl__6a9atx(47)]));
    return result;
  }
  r3b(path, mode, $completion) {
    var tmp = new $openCOROUTINE$107(this, path, mode, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  s3b(path, range, $completion) {
    var tmp = new $readRangeCOROUTINE$110(this, path, range, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  t3b(path, $completion) {
    var tmp = new $statCOROUTINE$112(this, path, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  toString() {
    return 'UrlVfs';
  }
}
class Charset {
  constructor(name) {
    Companion_getInstance_8();
    this.x3n_1 = name;
  }
  t3n(nbytes) {
    return imul(nbytes, 2);
  }
}
class BaseSingleByteCharset extends Charset {
  t3n(nbytes) {
    return nbytes;
  }
}
class SingleByteCharset extends BaseSingleByteCharset {
  constructor(name, conv) {
    super(name);
    this.p3n_1 = conv;
    var tmp = this;
    var tmp$ret$1;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = IntIntMap.n34();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.lang.SingleByteCharset.v.<anonymous>' call
    var inductionVariable = 0;
    var last = this.p3n_1.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$0;
        // Inline function 'kotlin.code' call
        var tmp0_get_code_gknlva = charSequenceGet(this.p3n_1, n);
        tmp$ret$0 = Char__toInt_impl_vasixd(tmp0_get_code_gknlva);
        tmp0_apply.l34(tmp$ret$0, n);
      }
       while (inductionVariable < last);
    tmp$ret$1 = tmp0_apply;
    tmp.q3n_1 = tmp$ret$1;
  }
  r3n(out, src, start, end) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out.b8(charSequenceGet(this.p3n_1, src[n] & 255));
      }
       while (inductionVariable < end);
    return end - start | 0;
  }
}
class ISO_8859_1 extends SingleByteCharset {
  constructor() {
    ISO_8859_1_instance = null;
    var tmp$ret$1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder.qa();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.lang.ISO_8859_1.<init>.<anonymous>' call
    var inductionVariable = 0;
    if (inductionVariable < 256)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_apply.b8(numberToChar(n));
      }
       while (inductionVariable < 256);
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.toString();
    super('ISO-8859-1', tmp$ret$1);
    ISO_8859_1_instance = this;
  }
}
class UTF16Charset extends Charset {
  constructor(le) {
    super('UTF-16-' + (le ? 'LE' : 'BE'));
    this.v3n_1 = le;
  }
  t3n(nbytes) {
    return imul(nbytes, 2);
  }
  r3n(out, src, start, end) {
    var consumed = 0;
    var progression = step(until_0(start, end), 2);
    var inductionVariable = progression.sc_1;
    var last = progression.tc_1;
    var step_0 = progression.uc_1;
    if ((step_0 > 0 ? inductionVariable <= last : false) ? true : step_0 < 0 ? last <= inductionVariable : false)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var char = numberToChar(readS16(src, n, this.v3n_1));
        out.b8(char);
        consumed = consumed + 2 | 0;
      }
       while (!(n === last));
    return consumed;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_3 = this;
  }
  w3n(_this__u8e3s4, codePoint) {
    if ((55296 <= codePoint ? codePoint <= 57343 : false) ? true : codePoint > 65535) {
      var U0 = codePoint - 65536 | 0;
      var hs = extract(U0, 10, 10);
      var ls = extract(U0, 0, 10);
      _this__u8e3s4.b8(numberToChar(55296 | hs));
      _this__u8e3s4.b8(numberToChar(56320 | ls));
    } else {
      _this__u8e3s4.b8(numberToChar(codePoint));
    }
  }
}
class UTC8CharsetBase extends Charset {
  t3n(nbytes) {
    return imul(nbytes, 2);
  }
  r3n(out, src, start, end) {
    if ((start < 0 ? true : start > src.length) ? true : end < 0 ? true : end > src.length) {
      // Inline function 'kotlin.error' call
      throw IllegalStateException.y1('Out of bounds');
    }
    var i = start;
    loop: while (i < end) {
      var c = src[i] & 255;
      var tmp0_subject = c >> 4;
      if (0 <= tmp0_subject ? tmp0_subject <= 7 : false) {
        Companion_getInstance_8().w3n(out, c);
        i = i + 1 | 0;
      } else if (12 <= tmp0_subject ? tmp0_subject <= 13 : false) {
        if ((i + 1 | 0) >= end)
          break loop;
        Companion_getInstance_8().w3n(out, (c & 31) << 6 | src[i + 1 | 0] & 63);
        i = i + 2 | 0;
      } else if (tmp0_subject === 14) {
        if ((i + 2 | 0) >= end)
          break loop;
        Companion_getInstance_8().w3n(out, (c & 15) << 12 | (src[i + 1 | 0] & 63) << 6 | src[i + 2 | 0] & 63);
        i = i + 3 | 0;
      } else if (tmp0_subject === 15) {
        if ((i + 3 | 0) >= end)
          break loop;
        Companion_getInstance_8().w3n(out, insert(insert(insert(insert(0, extract(src[i + 0 | 0], 0, 3), 18, 3), extract(src[i + 1 | 0], 0, 6), 12, 6), extract(src[i + 2 | 0], 0, 6), 6, 6), extract(src[i + 3 | 0], 0, 6), 0, 6));
        i = i + 4 | 0;
      } else {
        out.b8(_Char___init__impl__6a9atx(65533));
        i = i + 1 | 0;
      }
    }
    return i - start | 0;
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
  }
  fc(key) {
    var tmp0_safe_receiver = customEnvironments;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fc(key);
    return tmp1_elvis_lhs == null ? EnvironmentInternal_getInstance().fc(key) : tmp1_elvis_lhs;
  }
}
class InvalidOperationException extends Exception {
  static e3o(str) {
    str = str === VOID ? 'Invalid Operation' : str;
    var $this = super.kf(str);
    captureStack($this, $this.d3o_1);
    return $this;
  }
}
class IOException extends Exception {
  static l3o(msg) {
    var $this = super.kf(msg);
    captureStack($this, $this.k3o_1);
    return $this;
  }
}
class FileAlreadyExistsException extends IOException {
  static i3o(msg) {
    var $this = super.l3o(msg);
    captureStack($this, $this.h3o_1);
    return $this;
  }
}
class QueryString {
  constructor() {
    QueryString_instance = this;
  }
  m3o(str) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.linkedMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    var out = tmp$ret$0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = split_0(str, charArrayOf([_Char___init__impl__6a9atx(38)]));
    var n = 0;
    while (n < tmp0_fastForEach.o()) {
      // Inline function 'korlibs.io.net.QueryString.decode.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1_anonymous = tmp0_fastForEach.p(tmp0);
      var parts = split_0(tmp1_anonymous, charArrayOf([_Char___init__impl__6a9atx(61)]), VOID, 2);
      var key = Companion_getInstance_10().n3o(parts.p(0), get_UTF8(), true);
      var tmp = Companion_getInstance_10();
      var tmp$ret$2;
      // Inline function 'kotlin.collections.getOrElse' call
      var tmp_0;
      if (1 <= get_lastIndex_0(parts)) {
        tmp_0 = parts.p(1);
      } else {
        var tmp$ret$1;
        // Inline function 'korlibs.io.net.QueryString.decode.<anonymous>.<anonymous>' call
        tmp$ret$1 = key;
        tmp_0 = tmp$ret$1;
      }
      tmp$ret$2 = tmp_0;
      var value = tmp.n3o(tmp$ret$2, get_UTF8(), true);
      var tmp$ret$5;
      // Inline function 'kotlin.collections.getOrPut' call
      var value_0 = out.u3(key);
      var tmp_1;
      if (value_0 == null) {
        var tmp$ret$4;
        // Inline function 'korlibs.io.net.QueryString.decode.<anonymous>.<anonymous>' call
        var tmp$ret$3;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp$ret$3 = ArrayList.i4();
        tmp$ret$4 = tmp$ret$3;
        var answer = tmp$ret$4;
        out.m3(key, answer);
        tmp_1 = answer;
      } else {
        tmp_1 = value_0;
      }
      tmp$ret$5 = tmp_1;
      var list = tmp$ret$5;
      // Inline function 'kotlin.collections.plusAssign' call
      list.e1(value);
    }
    return out;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_5 = this;
    this.m3n_1 = 0;
    this.n3n_1 = Regex.hb('\\w+:');
  }
  o3o(scheme) {
    var tmp0_subject = scheme;
    switch (tmp0_subject) {
      case 'ftp':
        return 21;
      case 'ftps':
        return 990;
      case 'http':
      case 'ws':
        return 80;
      case 'https':
      case 'wss':
        return 443;
      default:
        return -1;
    }
  }
  p3o(scheme, userInfo, host, path, query, fragment, opaque, port) {
    return new URL(opaque, scheme, userInfo, host, path, query, fragment, port);
  }
  q3o(scheme, userInfo, host, path, query, fragment, opaque, port, $super) {
    opaque = opaque === VOID ? false : opaque;
    port = port === VOID ? this.m3n_1 : port;
    return $super === VOID ? this.p3o(scheme, userInfo, host, path, query, fragment, opaque, port) : $super.p3o.call(this, scheme, userInfo, host, path, query, fragment, opaque, port);
  }
  h36(url) {
    var r = new StrReader(url);
    var schemeColon = r.w3o(this.n3n_1);
    var tmp;
    if (!(schemeColon == null)) {
      var isHierarchical = !(r.x3o('//') == null);
      var nonScheme = r.y3o();
      var scheme = dropLast(schemeColon, 1);
      var nonFragment = substringBefore(nonScheme, _Char___init__impl__6a9atx(35));
      var fragment = substringAfterOrNull(nonScheme, _Char___init__impl__6a9atx(35));
      var nonQuery = substringBefore(nonFragment, _Char___init__impl__6a9atx(63));
      var query = substringAfterOrNull(nonFragment, _Char___init__impl__6a9atx(63));
      var authority = substringBefore(nonQuery, _Char___init__impl__6a9atx(47));
      var path = substringAfterOrNull(nonQuery, _Char___init__impl__6a9atx(47));
      var hostWithPort = substringAfter(authority, _Char___init__impl__6a9atx(64));
      var userInfo = substringBeforeOrNull(authority, _Char___init__impl__6a9atx(64));
      var host = substringBefore(hostWithPort, _Char___init__impl__6a9atx(58));
      var port = substringAfterOrNull(hostWithPort, _Char___init__impl__6a9atx(58));
      var tmp2_$this = Companion_getInstance_10();
      var tmp3_opaque = !isHierarchical;
      var tmp$ret$2;
      // Inline function 'kotlin.takeIf' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      var tmp$ret$1;
      // Inline function 'korlibs.io.net.Companion.invoke.<anonymous>' call
      var tmp$ret$0;
      // Inline function 'kotlin.text.isNotEmpty' call
      tmp$ret$0 = charSequenceLength(host) > 0;
      tmp$ret$1 = tmp$ret$0;
      if (tmp$ret$1) {
        tmp_0 = host;
      } else {
        tmp_0 = null;
      }
      tmp$ret$2 = tmp_0;
      var tmp4_host = tmp$ret$2;
      var tmp5_path = !(path == null) ? '/' + path : '';
      var tmp0_safe_receiver = port;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toIntOrNull(tmp0_safe_receiver);
      var tmp6_port = tmp1_elvis_lhs == null ? this.m3n_1 : tmp1_elvis_lhs;
      tmp = tmp2_$this.p3o(scheme, userInfo, tmp4_host, tmp5_path, query, fragment, tmp3_opaque, tmp6_port);
    } else {
      var nonFragment_0 = substringBefore(url, _Char___init__impl__6a9atx(35));
      var fragment_0 = substringAfterOrNull(url, _Char___init__impl__6a9atx(35));
      var path_0 = substringBefore(nonFragment_0, _Char___init__impl__6a9atx(63));
      var query_0 = substringAfterOrNull(nonFragment_0, _Char___init__impl__6a9atx(63));
      tmp = Companion_getInstance_10().q3o(null, null, null, path_0, query_0, fragment_0, false);
    }
    return tmp;
  }
  z3o(url) {
    return !((new StrReader(url)).w3o(this.n3n_1) == null);
  }
  a3p(base, access) {
    var tmp;
    if (this.z3o(access)) {
      tmp = access;
    } else if (startsWith(access, '/')) {
      tmp = Companion_getInstance_10().h36(base).u3i(VOID, VOID, VOID, VOID, access).v3i();
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.run' call
      var tmp0_run = Companion_getInstance_10().h36(base);
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'korlibs.io.net.Companion.resolve.<anonymous>' call
      tmp$ret$0 = tmp0_run.u3i(VOID, VOID, VOID, VOID, '/' + trimStart(normalize(get_pathInfo(substringBeforeLast(tmp0_run.n3i_1, _Char___init__impl__6a9atx(47)) + '/' + access)), charArrayOf([_Char___init__impl__6a9atx(47)]))).v3i();
      tmp$ret$1 = tmp$ret$0;
      tmp = tmp$ret$1;
    }
    return tmp;
  }
  n3o(s, charset, formUrlEncoded) {
    var bos = ByteArrayBuilder.c35();
    var len = s.length;
    var n = 0;
    while (n < len) {
      var c = charSequenceGet(s, n);
      var tmp0_subject = c;
      if (tmp0_subject === _Char___init__impl__6a9atx(37)) {
        var tmp$ret$0;
        // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
        var tmp0_append = toByte(toInt(substr(s, n + 1 | 0, 2), 16));
        bos.e35(tmp0_append);
        tmp$ret$0 = bos;
        n = n + 2 | 0;
      } else if (tmp0_subject === _Char___init__impl__6a9atx(43))
        if (formUrlEncoded) {
          var tmp$ret$1;
          // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
          var tmp1_append = 32;
          bos.e35(tmp1_append);
          tmp$ret$1 = bos;
        } else {
          var tmp$ret$2;
          // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
          var tmp2_append = 43;
          bos.e35(tmp2_append);
          tmp$ret$2 = bos;
        }
       else {
        var tmp$ret$3;
        // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
        var tmp3_append = Char__toByte_impl_7s7yt0(c);
        bos.e35(tmp3_append);
        tmp$ret$3 = bos;
      }
      var tmp1 = n;
      n = tmp1 + 1 | 0;
    }
    return toString_2(bos.f35(), charset);
  }
}
class URL {
  constructor(isOpaque, scheme, userInfo, host, path, query, fragment, defaultPort) {
    Companion_getInstance_10();
    this.j3i_1 = isOpaque;
    this.k3i_1 = scheme;
    this.l3i_1 = userInfo;
    this.m3i_1 = host;
    this.n3i_1 = path;
    this.o3i_1 = query;
    this.p3i_1 = fragment;
    this.q3i_1 = defaultPort;
    var tmp = this;
    tmp.r3i_1 = lazy(URL$fullUrl$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.s3i_1 = lazy(URL$fullUrlWithoutScheme$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.t3i_1 = lazy(URL$pathWithQuery$delegate$lambda(this));
  }
  c3p() {
    return Companion_getInstance_10().o3o(this.k3i_1);
  }
  d3p() {
    return this.q3i_1 === Companion_getInstance_10().m3n_1 ? this.c3p() : this.q3i_1;
  }
  v3i() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = fullUrl$factory();
    tmp$ret$0 = this.r3i_1.p3();
    return tmp$ret$0;
  }
  e3p(includeScheme, out) {
    if (includeScheme ? !(this.k3i_1 == null) : false) {
      out.a8('' + this.k3i_1 + ':');
      if (!this.j3i_1) {
        out.a8('//');
      }
    }
    if (!(this.l3i_1 == null)) {
      out.a8('' + this.l3i_1 + '@');
    }
    if (!(this.m3i_1 == null)) {
      out.a8(this.m3i_1);
    }
    if (!(this.d3p() === Companion_getInstance_10().m3n_1) ? !(this.d3p() === this.c3p()) : false) {
      out.b8(_Char___init__impl__6a9atx(58)).z7(this.d3p());
    }
    out.a8(this.n3i_1);
    if (!(this.o3i_1 == null)) {
      out.a8('?' + this.o3i_1);
    }
    if (!(this.p3i_1 == null)) {
      out.a8('#' + this.p3i_1);
    }
    return out;
  }
  b3p(includeScheme, out, $super) {
    includeScheme = includeScheme === VOID ? true : includeScheme;
    out = out === VOID ? StringBuilder.qa() : out;
    return $super === VOID ? this.e3p(includeScheme, out) : $super.e3p.call(this, includeScheme, out);
  }
  toString() {
    return this.v3i();
  }
  f3p(isOpaque, scheme, userInfo, host, path, query, fragment, defaultPort) {
    return new URL(isOpaque, scheme, userInfo, host, path, query, fragment, defaultPort);
  }
  u3i(isOpaque, scheme, userInfo, host, path, query, fragment, defaultPort, $super) {
    isOpaque = isOpaque === VOID ? this.j3i_1 : isOpaque;
    scheme = scheme === VOID ? this.k3i_1 : scheme;
    userInfo = userInfo === VOID ? this.l3i_1 : userInfo;
    host = host === VOID ? this.m3i_1 : host;
    path = path === VOID ? this.n3i_1 : path;
    query = query === VOID ? this.o3i_1 : query;
    fragment = fragment === VOID ? this.p3i_1 : fragment;
    defaultPort = defaultPort === VOID ? this.q3i_1 : defaultPort;
    return $super === VOID ? this.f3p(isOpaque, scheme, userInfo, host, path, query, fragment, defaultPort) : $super.f3p.call(this, isOpaque, scheme, userInfo, host, path, query, fragment, defaultPort);
  }
  hashCode() {
    var result = this.j3i_1 | 0;
    result = imul(result, 31) + (this.k3i_1 == null ? 0 : getStringHashCode(this.k3i_1)) | 0;
    result = imul(result, 31) + (this.l3i_1 == null ? 0 : getStringHashCode(this.l3i_1)) | 0;
    result = imul(result, 31) + (this.m3i_1 == null ? 0 : getStringHashCode(this.m3i_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.n3i_1) | 0;
    result = imul(result, 31) + (this.o3i_1 == null ? 0 : getStringHashCode(this.o3i_1)) | 0;
    result = imul(result, 31) + (this.p3i_1 == null ? 0 : getStringHashCode(this.p3i_1)) | 0;
    result = imul(result, 31) + this.q3i_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof URL))
      return false;
    var tmp0_other_with_cast = other instanceof URL ? other : THROW_CCE();
    if (!(this.j3i_1 === tmp0_other_with_cast.j3i_1))
      return false;
    if (!(this.k3i_1 == tmp0_other_with_cast.k3i_1))
      return false;
    if (!(this.l3i_1 == tmp0_other_with_cast.l3i_1))
      return false;
    if (!(this.m3i_1 == tmp0_other_with_cast.m3i_1))
      return false;
    if (!(this.n3i_1 === tmp0_other_with_cast.n3i_1))
      return false;
    if (!(this.o3i_1 == tmp0_other_with_cast.o3i_1))
      return false;
    if (!(this.p3i_1 == tmp0_other_with_cast.p3i_1))
      return false;
    if (!(this.q3i_1 === tmp0_other_with_cast.q3i_1))
      return false;
    return true;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_6 = this;
    this.v3l_1 = Methods_OPTIONS_getInstance();
    this.w3l_1 = Methods_GET_getInstance();
    this.x3l_1 = Methods_HEAD_getInstance();
    this.y3l_1 = Methods_POST_getInstance();
    this.z3l_1 = Methods_PUT_getInstance();
    this.a3m_1 = Methods_DELETE_getInstance();
    this.b3m_1 = Methods_TRACE_getInstance();
    this.c3m_1 = Methods_CONNECT_getInstance();
    this.d3m_1 = Methods_PATCH_getInstance();
    this.e3m_1 = listOf_0([this.v3l_1, this.w3l_1, this.x3l_1, this.y3l_1, this.z3l_1, this.a3m_1, this.b3m_1, this.c3m_1, this.d3m_1]);
    var tmp = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.e3m_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'korlibs.io.net.http.Companion.valuesMap.<anonymous>' call
      tmp$ret$0 = to(item.ac_1, item);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    tmp.f3m_1 = toMap(tmp$ret$2);
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_7 = this;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_8 = this;
    this.k3n_1 = 'Content-Length';
    this.l3n_1 = 'Content-Type';
  }
  g3p(str) {
    if (str == null)
      return Headers.h3p([]);
    var tmp$ret$5;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = split(str, ['\n']);
    var tmp$ret$4;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$3;
      // Inline function 'korlibs.io.net.http.Companion.parse.<anonymous>' call
      var tmp$ret$0;
      // Inline function 'kotlin.text.trim' call
      tmp$ret$0 = toString(trim_0(isCharSequence(item) ? item : THROW_CCE()));
      var parts = split_0(tmp$ret$0, charArrayOf([_Char___init__impl__6a9atx(58)]), VOID, 2);
      var tmp;
      if (parts.o() >= 2) {
        var tmp$ret$1;
        // Inline function 'kotlin.text.trim' call
        var tmp0_trim = parts.p(0);
        tmp$ret$1 = toString(trim_0(isCharSequence(tmp0_trim) ? tmp0_trim : THROW_CCE()));
        var tmp_0 = tmp$ret$1;
        var tmp$ret$2;
        // Inline function 'kotlin.text.trim' call
        var tmp1_trim = parts.p(1);
        tmp$ret$2 = toString(trim_0(isCharSequence(tmp1_trim) ? tmp1_trim : THROW_CCE()));
        tmp = to(tmp_0, tmp$ret$2);
      } else {
        tmp = null;
      }
      tmp$ret$3 = tmp;
      tmp0_mapTo.e1(tmp$ret$3);
    }
    tmp$ret$4 = tmp0_mapTo;
    tmp$ret$5 = tmp$ret$4;
    return new Headers(filterNotNull(tmp$ret$5));
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.i3p_1 = function_0;
  }
  rc(a, b) {
    return this.i3p_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class Methods extends Enum {}
class HttpException extends IOException {
  static q3p(statusCode, msg, statusText, headers) {
    Companion_getInstance_12();
    msg = msg === VOID ? 'Error' + statusCode : msg;
    var tmp;
    if (statusText === VOID) {
      var tmp0_elvis_lhs = HttpStatusMessage_getInstance().r3p_1.u3(statusCode);
      tmp = tmp0_elvis_lhs == null ? 'Error' + statusCode : tmp0_elvis_lhs;
    } else {
      tmp = statusText;
    }
    statusText = tmp;
    headers = headers === VOID ? Headers.h3p([]) : headers;
    var $this = super.l3o('' + statusCode + ' ' + statusText + ' - ' + msg);
    captureStack($this, $this.p3p_1);
    $this.l3p_1 = statusCode;
    $this.m3p_1 = msg;
    $this.n3p_1 = statusText;
    $this.o3p_1 = headers;
    return $this;
  }
}
class Headers {
  constructor(items) {
    Companion_getInstance_13();
    this.g3m_1 = items;
  }
  static h3p(items) {
    Companion_getInstance_13();
    var $this = new Headers(toList_0(items));
    return $this;
  }
  static h3m(map) {
    Companion_getInstance_13();
    var tmp$ret$3;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(map.o());
    var tmp$ret$0;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$0 = map.l3().u();
    var tmp0_iterator = tmp$ret$0;
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$1;
      // Inline function 'korlibs.io.net.http.Headers.<init>.<anonymous>' call
      tmp$ret$1 = to(item.o3(), item.p3());
      tmp0_mapTo.e1(tmp$ret$1);
    }
    tmp$ret$2 = tmp0_mapTo;
    tmp$ret$3 = tmp$ret$2;
    var $this = new Headers(tmp$ret$3);
    return $this;
  }
  static s3p(str) {
    Companion_getInstance_13();
    var $this = new Headers(Companion_getInstance_13().g3p(str).g3m_1);
    return $this;
  }
  u() {
    return this.g3m_1.u();
  }
  fc(key) {
    return this.t3p(key);
  }
  t3p(key) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_firstOrNull = this.g3m_1;
      var tmp0_iterator = tmp0_firstOrNull.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'korlibs.io.net.http.Headers.getFirst.<anonymous>' call
        tmp$ret$0 = equals_0(element.ri_1, key, true);
        if (tmp$ret$0) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.si_1;
  }
  u3p() {
    var tmp$ret$15;
    // Inline function 'kotlin.collections.sortedBy' call
    var tmp$ret$13;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$6;
    // Inline function 'kotlin.collections.groupBy' call
    var tmp0_groupBy = this.g3m_1;
    var tmp$ret$5;
    // Inline function 'kotlin.collections.groupByTo' call
    var tmp0_groupByTo = LinkedHashMap.n8();
    var tmp0_iterator = tmp0_groupBy.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$2;
      // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
      var tmp$ret$1;
      // Inline function 'kotlin.text.toLowerCase' call
      var tmp0_toLowerCase = element.ri_1;
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_toLowerCase;
      tmp$ret$1 = tmp$ret$0.toLowerCase();
      tmp$ret$2 = tmp$ret$1;
      var key = tmp$ret$2;
      var tmp$ret$4;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = tmp0_groupByTo.u3(key);
      var tmp;
      if (value == null) {
        var tmp$ret$3;
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        tmp$ret$3 = ArrayList.i4();
        var answer = tmp$ret$3;
        tmp0_groupByTo.m3(key, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      tmp$ret$4 = tmp;
      var list = tmp$ret$4;
      list.e1(element);
    }
    tmp$ret$5 = tmp0_groupByTo;
    tmp$ret$6 = tmp$ret$5;
    var tmp1_map = tmp$ret$6;
    var tmp$ret$12;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(tmp1_map.o());
    var tmp$ret$7;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$7 = tmp1_map.l3().u();
    var tmp0_iterator_0 = tmp$ret$7;
    while (tmp0_iterator_0.h1()) {
      var item = tmp0_iterator_0.j1();
      var tmp$ret$11;
      // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
      var tmp_0 = first(item.p3()).ri_1;
      var tmp$ret$10;
      // Inline function 'kotlin.collections.map' call
      var tmp0_map = item.p3();
      var tmp$ret$9;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
      var tmp0_iterator_1 = tmp0_map.u();
      while (tmp0_iterator_1.h1()) {
        var item_0 = tmp0_iterator_1.j1();
        var tmp$ret$8;
        // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>.<anonymous>' call
        tmp$ret$8 = item_0.si_1;
        tmp0_mapTo_0.e1(tmp$ret$8);
      }
      tmp$ret$9 = tmp0_mapTo_0;
      tmp$ret$10 = tmp$ret$9;
      tmp$ret$11 = to(tmp_0, tmp$ret$10);
      tmp0_mapTo.e1(tmp$ret$11);
    }
    tmp$ret$12 = tmp0_mapTo;
    tmp$ret$13 = tmp$ret$12;
    var tmp2_sortedBy = tmp$ret$13;
    var tmp$ret$14;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_1 = Http$Headers$toListGrouped$lambda;
    tmp$ret$14 = new sam$kotlin_Comparator$0(tmp_1);
    tmp$ret$15 = sortedWith(tmp2_sortedBy, tmp$ret$14);
    return tmp$ret$15;
  }
  v3p(newHeaders) {
    var tmp$ret$4;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(newHeaders, 10));
    var tmp0_iterator = newHeaders.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$2;
      // Inline function 'korlibs.io.net.http.Headers.withReplaceHeaders.<anonymous>' call
      var tmp$ret$1;
      // Inline function 'kotlin.text.toLowerCase' call
      var tmp0_toLowerCase = item.ri_1;
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_toLowerCase;
      tmp$ret$1 = tmp$ret$0.toLowerCase();
      tmp$ret$2 = tmp$ret$1;
      tmp0_mapTo.e1(tmp$ret$2);
    }
    tmp$ret$3 = tmp0_mapTo;
    tmp$ret$4 = tmp$ret$3;
    var replaceKeys = toSet(tmp$ret$4);
    var tmp$ret$9;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this.g3m_1;
    var tmp$ret$8;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator_0 = tmp0_filter.u();
    while (tmp0_iterator_0.h1()) {
      var element = tmp0_iterator_0.j1();
      var tmp$ret$7;
      // Inline function 'korlibs.io.net.http.Headers.withReplaceHeaders.<anonymous>' call
      var tmp$ret$6;
      // Inline function 'kotlin.text.toLowerCase' call
      var tmp0_toLowerCase_0 = element.ri_1;
      var tmp$ret$5;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$5 = tmp0_toLowerCase_0;
      tmp$ret$6 = tmp$ret$5.toLowerCase();
      tmp$ret$7 = !replaceKeys.w(tmp$ret$6);
      if (tmp$ret$7) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$8 = tmp0_filterTo;
    tmp$ret$9 = tmp$ret$8;
    return new Headers(plus_0(tmp$ret$9, toList(newHeaders)));
  }
  w3p(newHeaders) {
    return this.v3p(toList_0(newHeaders));
  }
  x3p(newHeaders) {
    return this.v3p(toList(newHeaders));
  }
  toString() {
    return 'Headers(' + joinToString(this.u3p(), ', ') + ')';
  }
  hashCode() {
    return hashCode(this.g3m_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Headers))
      return false;
    var tmp0_other_with_cast = other instanceof Headers ? other : THROW_CCE();
    if (!equals(this.g3m_1, tmp0_other_with_cast.g3m_1))
      return false;
    return true;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_9 = this;
  }
}
class $readAllBytesCOROUTINE$118 extends CoroutineImpl {
  constructor(_this__u8e3s4, resultContinuation) {
    super(resultContinuation);
    this.g3q_1 = _this__u8e3s4;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 2;
            this.nf_1 = 1;
            suspendResult = readAll(this.g3q_1.v3j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var allContent = suspendResult;
            return allContent;
          case 2:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 2) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $readAllStringCOROUTINE$119 extends CoroutineImpl {
  constructor(_this__u8e3s4, charset, resultContinuation) {
    super(resultContinuation);
    this.p3q_1 = _this__u8e3s4;
    this.q3q_1 = charset;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 2;
            this.nf_1 = 1;
            suspendResult = this.p3q_1.r3q(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var bytes = suspendResult;
            return toString_2(bytes, this.q3q_1);
          case 2:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 2) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $checkErrorsCOROUTINE$120 extends CoroutineImpl {
  constructor(_this__u8e3s4, resultContinuation) {
    super(resultContinuation);
    this.a3r_1 = _this__u8e3s4;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 3;
            {
            }

            if (!this.a3r_1.w3j_1) {
              this.b3r_1 = this.a3r_1.r3j_1;
              this.nf_1 = 2;
              suspendResult = this.a3r_1.c3r(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.nf_1 = 1;
              continue $sm;
            }

            break;
          case 1:
            return this.a3r_1;
          case 2:
            var ARGUMENT = suspendResult;
            throw HttpException.q3p(this.b3r_1, ARGUMENT, this.a3r_1.s3j_1);
          case 3:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 3) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_10 = this;
    this.d3r_1 = new RequestConfig();
  }
}
class Response {
  constructor(status, statusText, headers, rawContent, content) {
    Companion_getInstance_14();
    this.r3j_1 = status;
    this.s3j_1 = statusText;
    this.t3j_1 = headers;
    this.u3j_1 = rawContent;
    this.v3j_1 = content;
    this.w3j_1 = this.r3j_1 < 400;
    var tmp = this;
    tmp.x3j_1 = lazy(HttpClient$Response$responseCharset$delegate$lambda);
  }
  r3q($completion) {
    var tmp = new $readAllBytesCOROUTINE$118(this, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  e3r() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = responseCharset$factory();
    tmp$ret$0 = this.x3j_1.p3();
    return tmp$ret$0;
  }
  f3r(charset, $completion) {
    var tmp = new $readAllStringCOROUTINE$119(this, charset, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  c3r(charset, $completion, $super) {
    charset = charset === VOID ? this.e3r() : charset;
    return $super === VOID ? this.f3r(charset, $completion) : $super.f3r.call(this, charset, $completion);
  }
  j3m($completion) {
    var tmp = new $checkErrorsCOROUTINE$120(this, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  g3r(content) {
    return new CompletedResponse(this.r3j_1, this.s3j_1, this.t3j_1, content);
  }
  toString() {
    return 'Response(status=' + this.r3j_1 + ', statusText=' + this.s3j_1 + ', headers=' + this.t3j_1 + ', rawContent=' + this.u3j_1 + ', content=' + this.v3j_1 + ')';
  }
  hashCode() {
    var result = this.r3j_1;
    result = imul(result, 31) + getStringHashCode(this.s3j_1) | 0;
    result = imul(result, 31) + this.t3j_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.u3j_1) | 0;
    result = imul(result, 31) + hashCode(this.v3j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Response))
      return false;
    var tmp0_other_with_cast = other instanceof Response ? other : THROW_CCE();
    if (!(this.r3j_1 === tmp0_other_with_cast.r3j_1))
      return false;
    if (!(this.s3j_1 === tmp0_other_with_cast.s3j_1))
      return false;
    if (!this.t3j_1.equals(tmp0_other_with_cast.t3j_1))
      return false;
    if (!equals(this.u3j_1, tmp0_other_with_cast.u3j_1))
      return false;
    if (!equals(this.v3j_1, tmp0_other_with_cast.v3j_1))
      return false;
    return true;
  }
}
class CompletedResponse {
  constructor(status, statusText, headers, content) {
    this.h3r_1 = status;
    this.i3r_1 = statusText;
    this.j3r_1 = headers;
    this.k3r_1 = content;
    this.l3r_1 = this.h3r_1 < 400;
  }
  toString() {
    return 'CompletedResponse(status=' + this.h3r_1 + ', statusText=' + this.i3r_1 + ', headers=' + this.j3r_1 + ', content=' + this.k3r_1 + ')';
  }
  hashCode() {
    var result = this.h3r_1;
    result = imul(result, 31) + getStringHashCode(this.i3r_1) | 0;
    result = imul(result, 31) + this.j3r_1.hashCode() | 0;
    result = imul(result, 31) + (this.k3r_1 == null ? 0 : hashCode(this.k3r_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedResponse))
      return false;
    var tmp0_other_with_cast = other instanceof CompletedResponse ? other : THROW_CCE();
    if (!(this.h3r_1 === tmp0_other_with_cast.h3r_1))
      return false;
    if (!(this.i3r_1 === tmp0_other_with_cast.i3r_1))
      return false;
    if (!this.j3r_1.equals(tmp0_other_with_cast.j3r_1))
      return false;
    if (!equals(this.k3r_1, tmp0_other_with_cast.k3r_1))
      return false;
    return true;
  }
}
class RequestConfig {
  constructor(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) {
    Companion_getInstance_15();
    followRedirects = followRedirects === VOID ? true : followRedirects;
    throwErrors = throwErrors === VOID ? false : throwErrors;
    maxRedirects = maxRedirects === VOID ? 10 : maxRedirects;
    referer = referer === VOID ? null : referer;
    simulateBrowser = simulateBrowser === VOID ? false : simulateBrowser;
    this.m3r_1 = followRedirects;
    this.n3r_1 = throwErrors;
    this.o3r_1 = maxRedirects;
    this.p3r_1 = referer;
    this.q3r_1 = simulateBrowser;
  }
  r3r(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) {
    return new RequestConfig(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
  }
  s3r(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser, $super) {
    followRedirects = followRedirects === VOID ? this.m3r_1 : followRedirects;
    throwErrors = throwErrors === VOID ? this.n3r_1 : throwErrors;
    maxRedirects = maxRedirects === VOID ? this.o3r_1 : maxRedirects;
    referer = referer === VOID ? this.p3r_1 : referer;
    simulateBrowser = simulateBrowser === VOID ? this.q3r_1 : simulateBrowser;
    return $super === VOID ? this.r3r(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) : $super.r3r.call(this, followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
  }
  toString() {
    return 'RequestConfig(followRedirects=' + this.m3r_1 + ', throwErrors=' + this.n3r_1 + ', maxRedirects=' + this.o3r_1 + ', referer=' + this.p3r_1 + ', simulateBrowser=' + this.q3r_1 + ')';
  }
  hashCode() {
    var result = this.m3r_1 | 0;
    result = imul(result, 31) + (this.n3r_1 | 0) | 0;
    result = imul(result, 31) + this.o3r_1 | 0;
    result = imul(result, 31) + (this.p3r_1 == null ? 0 : getStringHashCode(this.p3r_1)) | 0;
    result = imul(result, 31) + (this.q3r_1 | 0) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestConfig))
      return false;
    var tmp0_other_with_cast = other instanceof RequestConfig ? other : THROW_CCE();
    if (!(this.m3r_1 === tmp0_other_with_cast.m3r_1))
      return false;
    if (!(this.n3r_1 === tmp0_other_with_cast.n3r_1))
      return false;
    if (!(this.o3r_1 === tmp0_other_with_cast.o3r_1))
      return false;
    if (!(this.p3r_1 == tmp0_other_with_cast.p3r_1))
      return false;
    if (!(this.q3r_1 === tmp0_other_with_cast.q3r_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_11 = this;
    this.t3r_1 = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.81 Safari/537.36';
    this.u3r_1 = 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8';
    this.v3r_1 = 'en-us';
    this.w3r_1 = 'gzip, deflate';
    this.x3r_1 = 'Close';
  }
  y3r(headers, host) {
    var out = Headers.h3p([to('User-Agent', this.t3r_1), to('Accept', this.u3r_1), to('Accept-Language', this.v3r_1), to('Accept-Encoding', this.w3r_1), to('Connection', this.x3r_1)]).x3p(headers);
    return !(host == null) ? out.w3p([to('Host', host)]) : out;
  }
}
class $requestCOROUTINE$123 extends CoroutineImpl {
  constructor(_this__u8e3s4, method, url, headers, content, config, resultContinuation) {
    super(resultContinuation);
    this.h3s_1 = _this__u8e3s4;
    this.i3s_1 = method;
    this.j3s_1 = url;
    this.k3s_1 = headers;
    this.l3s_1 = content;
    this.m3s_1 = config;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 9;
            this.n3s_1 = this.l3s_1;
            if (this.n3s_1 == null) {
              this.o3s_1 = null;
              this.nf_1 = 2;
              continue $sm;
            } else {
              this.nf_1 = 1;
              suspendResult = this.n3s_1.t3e(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

            break;
          case 1:
            this.o3s_1 = suspendResult;
            this.nf_1 = 2;
            continue $sm;
          case 2:
            this.p3s_1 = this.o3s_1;
            this.q3s_1 = this.p3s_1 == null ? new Long(0, 0) : this.p3s_1;
            this.r3s_1 = this.k3s_1;
            var tmp_0;
            if (!(this.l3s_1 == null)) {
              var tmp$ret$0;
              l$ret$1: do {
                {
                  var tmp_1;
                  var tmp_2 = this.k3s_1;
                  if (isInterface(tmp_2, Collection)) {
                    tmp_1 = this.k3s_1.y();
                  } else {
                    tmp_1 = false;
                  }
                  if (tmp_1) {
                    tmp$ret$0 = false;
                    break l$ret$1;
                  }
                  var tmp0_iterator = this.k3s_1.u();
                  while (tmp0_iterator.h1()) {
                    var element = tmp0_iterator.j1();
                    if (equals_0(element.ri_1, Companion_getInstance_13().k3n_1, true)) {
                      tmp$ret$0 = true;
                      break l$ret$1;
                    }
                  }
                  tmp$ret$0 = false;
                }
              }
               while (false);
              tmp_0 = !tmp$ret$0;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              this.r3s_1 = this.r3s_1.w3p([to(Companion_getInstance_13().k3n_1, toString(this.q3s_1))]);
            }

            if (this.m3s_1.q3r_1) {
              this.r3s_1 = Companion_getInstance_16().y3r(this.r3s_1, null);
            }

            this.nf_1 = 3;
            suspendResult = this.h3s_1.v3s(this.i3s_1, this.j3s_1, this.r3s_1, this.l3s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.s3s_1 = suspendResult;
            {
            }

            if (this.m3s_1.n3r_1) {
              this.nf_1 = 4;
              suspendResult = this.s3s_1.j3m(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.nf_1 = 5;
              continue $sm;
            }

            break;
          case 4:
            ;
            this.nf_1 = 5;
            continue $sm;
          case 5:
            this.t3s_1 = this.s3s_1;
            if (this.m3s_1.m3r_1 ? this.m3s_1.o3r_1 >= 0 : false) {
              this.u3s_1 = this.t3s_1.t3j_1.fc('location');
              if (!(this.u3s_1 == null)) {
                this.nf_1 = 8;
                suspendResult = this.h3s_1.w3s(this.i3s_1, mergeUrls(this.h3s_1, this.j3s_1, this.u3s_1), this.k3s_1.w3p([to('Referer', this.j3s_1)]), this.l3s_1, this.m3s_1.s3r(VOID, VOID, this.m3s_1.o3r_1 - 1 | 0), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.nf_1 = 6;
                continue $sm;
              }
            } else {
              this.nf_1 = 7;
              continue $sm;
            }

            break;
          case 6:
            this.nf_1 = 7;
            continue $sm;
          case 7:
            return this.t3s_1;
          case 8:
            return suspendResult;
          case 9:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 9) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $requestAsBytesCOROUTINE$125 extends CoroutineImpl {
  constructor(_this__u8e3s4, method, url, headers, content, config, resultContinuation) {
    super(resultContinuation);
    this.f3t_1 = _this__u8e3s4;
    this.g3t_1 = method;
    this.h3t_1 = url;
    this.i3t_1 = headers;
    this.j3t_1 = content;
    this.k3t_1 = config;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 3;
            this.nf_1 = 1;
            suspendResult = this.f3t_1.w3s(this.g3t_1, this.h3t_1, this.i3t_1, this.j3t_1, this.k3t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.l3t_1 = suspendResult;
            this.nf_1 = 2;
            suspendResult = this.l3t_1.r3q(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return this.l3t_1.g3r(ARGUMENT);
          case 3:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 3) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $readBytesCOROUTINE$126 extends CoroutineImpl {
  constructor(_this__u8e3s4, url, config, resultContinuation) {
    super(resultContinuation);
    this.u3t_1 = _this__u8e3s4;
    this.v3t_1 = url;
    this.w3t_1 = config;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 2;
            this.nf_1 = 1;
            suspendResult = this.u3t_1.x3t(Companion_getInstance_11().w3l_1, this.v3t_1, VOID, VOID, this.w3t_1.s3r(VOID, true), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.k3r_1;
          case 2:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 2) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class HttpClient {
  constructor() {
    Companion_getInstance_16();
    this.p3l_1 = false;
  }
  w3s(method, url, headers, content, config, $completion) {
    var tmp = new $requestCOROUTINE$123(this, method, url, headers, content, config, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  i3m(method, url, headers, content, config, $completion, $super) {
    headers = headers === VOID ? Headers.h3p([]) : headers;
    content = content === VOID ? null : content;
    config = config === VOID ? Companion_getInstance_15().d3r_1 : config;
    return $super === VOID ? this.w3s(method, url, headers, content, config, $completion) : $super.w3s.call(this, method, url, headers, content, config, $completion);
  }
  y3t(method, url, headers, content, config, $completion) {
    var tmp = new $requestAsBytesCOROUTINE$125(this, method, url, headers, content, config, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  x3t(method, url, headers, content, config, $completion, $super) {
    headers = headers === VOID ? Headers.h3p([]) : headers;
    content = content === VOID ? null : content;
    config = config === VOID ? new RequestConfig() : config;
    return $super === VOID ? this.y3t(method, url, headers, content, config, $completion) : $super.y3t.call(this, method, url, headers, content, config, $completion);
  }
  z3t(url, config, $completion) {
    var tmp = new $readBytesCOROUTINE$126(this, url, config, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  q3l(url, config, $completion, $super) {
    config = config === VOID ? new RequestConfig() : config;
    return $super === VOID ? this.z3t(url, config, $completion) : $super.z3t.call(this, url, config, $completion);
  }
}
class HttpStatusMessage {
  constructor() {
    HttpStatusMessage_instance = this;
    this.r3p_1 = linkedMapOf([to(100, 'Continue'), to(101, 'Switching Protocols'), to(200, 'OK'), to(201, 'Created'), to(202, 'Accepted'), to(203, 'Non-Authoritative Information'), to(204, 'No Content'), to(205, 'Reset Content'), to(206, 'Partial Content'), to(300, 'Multiple Choices'), to(301, 'Moved Permanently'), to(302, 'Found'), to(303, 'See Other'), to(304, 'Not Modified'), to(305, 'Use Proxy'), to(307, 'Temporary Redirect'), to(400, 'Bad Request'), to(401, 'Unauthorized'), to(402, 'Payment Required'), to(403, 'Forbidden'), to(404, 'Not Found'), to(405, 'Method Not Allowed'), to(406, 'Not Acceptable'), to(407, 'Proxy Authentication Required'), to(408, 'Request Timeout'), to(409, 'Conflict'), to(410, 'Gone'), to(411, 'Length Required'), to(412, 'Precondition Failed'), to(413, 'Request Entity Too Large'), to(414, 'Request-URI Too Long'), to(415, 'Unsupported Media Type'), to(416, 'Requested Range Not Satisfiable'), to(417, 'Expectation Failed'), to(418, "I'm a teapot"), to(422, 'Unprocessable Entity (WebDAV - RFC 4918)'), to(423, 'Locked (WebDAV - RFC 4918)'), to(424, 'Failed Dependency (WebDAV) (RFC 4918)'), to(425, 'Unassigned'), to(426, 'Upgrade Required (RFC 7231)'), to(428, 'Precondition Required'), to(429, 'Too Many Requests'), to(431, 'Request Header Fileds Too Large)'), to(449, 'Error449'), to(451, 'Unavailable for Legal Reasons'), to(500, 'Internal Server Error'), to(501, 'Not Implemented'), to(502, 'Bad Gateway'), to(503, 'Service Unavailable'), to(504, 'Gateway Timeout'), to(505, 'HTTP Version Not Supported'), to(506, 'Variant Also Negotiates (RFC 2295)'), to(507, 'Insufficient Storage (WebDAV - RFC 4918)'), to(508, 'Loop Detected (WebDAV)'), to(509, 'Bandwidth Limit Exceeded'), to(510, 'Not Extended (RFC 2774)'), to(511, 'Network Authentication Required')]);
  }
}
class ProxiedHttpFactory {
  constructor(parent) {
    this.b3u_1 = parent;
    this.c3u_1 = parent;
  }
  a3u() {
    return this.c3u_1.a3u();
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_12 = this;
    this.d3u_1 = new Context(false, false);
    this.e3u_1 = new Context(true, true);
  }
}
class Context {
  constructor(optimizedNumericLists, useFastArrayList) {
    Companion_getInstance_17();
    useFastArrayList = useFastArrayList === VOID ? false : useFastArrayList;
    this.f3u_1 = optimizedNumericLists;
    this.g3u_1 = useFastArrayList;
  }
  h3u() {
    return this.g3u_1 ? FastArrayList.y34() : ArrayList.i4();
  }
  toString() {
    return 'Context(optimizedNumericLists=' + this.f3u_1 + ', useFastArrayList=' + this.g3u_1 + ')';
  }
  hashCode() {
    var result = this.f3u_1 | 0;
    result = imul(result, 31) + (this.g3u_1 | 0) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Context))
      return false;
    var tmp0_other_with_cast = other instanceof Context ? other : THROW_CCE();
    if (!(this.f3u_1 === tmp0_other_with_cast.f3u_1))
      return false;
    if (!(this.g3u_1 === tmp0_other_with_cast.g3u_1))
      return false;
    return true;
  }
}
class Json {
  constructor() {
    Json_instance = this;
  }
  s3u(s, context) {
    return this.n3u(new StrReader(s), context);
  }
  e3i(s, context, $super) {
    context = context === VOID ? Companion_getInstance_17().d3u_1 : context;
    return $super === VOID ? this.s3u(s, context) : $super.s3u.call(this, s, context);
  }
  n3u(s, context) {
    var ic = s.k3u().o3u();
    var tmp;
    if (ic === _Char___init__impl__6a9atx(123)) {
      tmp = parseObject(this, s, context);
    } else if (ic === _Char___init__impl__6a9atx(91)) {
      tmp = parseArray(this, s, context);
    } else if (((((((((((ic === _Char___init__impl__6a9atx(45) ? true : ic === _Char___init__impl__6a9atx(43)) ? true : ic === _Char___init__impl__6a9atx(48)) ? true : ic === _Char___init__impl__6a9atx(49)) ? true : ic === _Char___init__impl__6a9atx(50)) ? true : ic === _Char___init__impl__6a9atx(51)) ? true : ic === _Char___init__impl__6a9atx(52)) ? true : ic === _Char___init__impl__6a9atx(53)) ? true : ic === _Char___init__impl__6a9atx(54)) ? true : ic === _Char___init__impl__6a9atx(55)) ? true : ic === _Char___init__impl__6a9atx(56)) ? true : ic === _Char___init__impl__6a9atx(57)) {
      var dres = parseNumber(this, s);
      tmp = numberToInt(dres) === dres ? numberToInt(dres) : dres;
    } else if ((ic === _Char___init__impl__6a9atx(116) ? true : ic === _Char___init__impl__6a9atx(102)) ? true : ic === _Char___init__impl__6a9atx(110)) {
      tmp = parseBooleanOrNull(this, s, context);
    } else if (ic === _Char___init__impl__6a9atx(34)) {
      tmp = s.t3u();
    } else {
      invalidJson(this, "Not expected '" + new Char(ic) + "'");
    }
    return tmp;
  }
}
class AsyncStream$read$slambda extends CoroutineImpl {
  constructor(this$0, $buffer, $offset, $len, resultContinuation, $box) {
    if ($box === VOID)
      $box = {};
    $box.o3v_1 = this$0;
    $box.p3v_1 = $buffer;
    $box.q3v_1 = $offset;
    $box.r3v_1 = $len;
    super(resultContinuation, $box);
  }
  s3v($completion) {
    var tmp = this.x37($completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  y37($completion) {
    return this.s3v($completion);
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 2;
            this.nf_1 = 1;
            suspendResult = readInternal(this.o3v_1, this.p3v_1, this.q3v_1, this.r3v_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 2) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
  x37(completion) {
    var i = new AsyncStream$read$slambda(this.o3v_1, this.p3v_1, this.q3v_1, this.r3v_1, completion);
    return i;
  }
}
class $readCOROUTINE$147 extends CoroutineImpl {
  constructor(_this__u8e3s4, buffer, offset, len, resultContinuation) {
    super(resultContinuation);
    this.b3w_1 = _this__u8e3s4;
    this.c3w_1 = buffer;
    this.d3w_1 = offset;
    this.e3w_1 = len;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 4;
            if (this.b3w_1.t3c_1) {
              this.nf_1 = 2;
              suspendResult = this.b3w_1.v3c_1.a38(AsyncStream$read$slambda_0(this.b3w_1, this.c3w_1, this.d3w_1, this.e3w_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.nf_1 = 1;
              suspendResult = readInternal(this.b3w_1, this.c3w_1, this.d3w_1, this.e3w_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

            break;
          case 1:
            this.f3w_1 = suspendResult;
            this.nf_1 = 3;
            continue $sm;
          case 2:
            this.f3w_1 = suspendResult;
            this.nf_1 = 3;
            continue $sm;
          case 3:
            return this.f3w_1;
          case 4:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 4) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $readInternalCOROUTINE$149 extends CoroutineImpl {
  constructor(_this__u8e3s4, buffer, offset, len, resultContinuation) {
    super(resultContinuation);
    this.c3v_1 = _this__u8e3s4;
    this.d3v_1 = buffer;
    this.e3v_1 = offset;
    this.f3v_1 = len;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 2;
            this.nf_1 = 1;
            suspendResult = this.c3v_1.r3c_1.h3f(this.c3v_1.s3c_1, this.d3v_1, this.e3v_1, this.f3v_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var read = suspendResult;
            if (read >= 0) {
              var tmp0_this = this.c3v_1;
              var tmp_0 = tmp0_this;
              var tmp0_plus = tmp0_this.s3c_1;
              tmp_0.s3c_1 = tmp0_plus.bf(toLong(read));
            }

            return read;
          case 2:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 2) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $getAvailableCOROUTINE$151 extends CoroutineImpl {
  constructor(_this__u8e3s4, resultContinuation) {
    super(resultContinuation);
    this.o3w_1 = _this__u8e3s4;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 3;
            this.nf_1 = 1;
            suspendResult = this.o3w_1.t3e(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.p3w_1 = suspendResult;
            this.nf_1 = 2;
            suspendResult = this.o3w_1.q3w(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return this.p3w_1.hd(ARGUMENT);
          case 3:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 3) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class AsyncGetPositionStream {}
function getPosition($completion) {
  throw UnsupportedOperationException.o4();
}
class AsyncPositionLengthStream {}
class AsyncStream {
  constructor(base, position, queue) {
    position = position === VOID ? new Long(0, 0) : position;
    queue = queue === VOID ? false : queue;
    this.r3c_1 = base;
    this.s3c_1 = position;
    this.t3c_1 = queue;
    this.u3c_1 = new Mixin();
    this.v3c_1 = new AsyncThread();
    this.w3c_1 = new AsyncThread();
  }
  toString() {
    return 'AsyncStream(' + this.r3c_1 + ', position=' + toString(this.s3c_1) + ')';
  }
  y3j(buffer, offset, len, $completion) {
    var tmp = new $readCOROUTINE$147(this, buffer, offset, len, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  q3w($completion) {
    return this.s3c_1;
  }
  t3e($completion) {
    var tmp0 = this.r3c_1.t3e($completion);
    return tmp0;
  }
  r3w($completion) {
    var tmp0 = this.i3f($completion);
    return tmp0;
  }
  s3w($completion) {
    var tmp = new $getAvailableCOROUTINE$151(this, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  w3b($completion) {
    var tmp0 = this.r3c_1.w3b($completion);
    return tmp0;
  }
}
class $hasLengthCOROUTINE$158 extends CoroutineImpl {
  constructor(_this__u8e3s4, resultContinuation) {
    super(resultContinuation);
    this.i3y_1 = _this__u8e3s4;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 3;
            this.of_1 = 2;
            this.nf_1 = 1;
            suspendResult = this.i3y_1.t3e(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.j3y_1 = ARGUMENT.gd(new Long(0, 0)) >= 0;
            this.of_1 = 3;
            this.nf_1 = 4;
            continue $sm;
          case 2:
            this.of_1 = 3;
            var tmp_0 = this.qf_1;
            if (tmp_0 instanceof UnsupportedOperationException) {
              var t = this.qf_1;
              var tmp_1 = this;
              tmp_1.j3y_1 = false;
              this.nf_1 = 4;
              continue $sm;
            } else {
              throw this.qf_1;
            }

            break;
          case 3:
            throw this.qf_1;
          case 4:
            this.of_1 = 3;
            return this.j3y_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 3) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $_readCOROUTINE$162 extends CoroutineImpl {
  constructor(_this__u8e3s4, position, buffer, offset, len, resultContinuation) {
    super(resultContinuation);
    this.s3y_1 = _this__u8e3s4;
    this.t3y_1 = position;
    this.u3y_1 = buffer;
    this.v3y_1 = offset;
    this.w3y_1 = len;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 7;
            this.nf_1 = 1;
            suspendResult = this.s3y_1.a3z_1.i3f(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              this.nf_1 = 2;
              suspendResult = this.s3y_1.a3z_1.t3e(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.x3y_1 = false;
              this.nf_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            this.y3y_1 = suspendResult;
            this.x3y_1 = this.t3y_1.gd(this.y3y_1) >= 0;
            this.nf_1 = 3;
            continue $sm;
          case 3:
            if (this.x3y_1) {
              return -1;
            } else {
              this.nf_1 = 4;
              continue $sm;
            }

            ;
            break;
          case 4:
            var tmp_0 = this;
            var tmp0_div = this.s3y_1.d3z_1;
            tmp_0.z3y_1 = this.t3y_1.df(toLong(tmp0_div));
            if (!this.s3y_1.f3z_1.equals(this.z3y_1)) {
              this.nf_1 = 5;
              var tmp1_times = this.s3y_1.d3z_1;
              suspendResult = readBytes(this.s3y_1.a3z_1, this.z3y_1.cf(toLong(tmp1_times)), this.s3y_1.d3z_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.nf_1 = 6;
              continue $sm;
            }

            break;
          case 5:
            var ARGUMENT = suspendResult;
            this.s3y_1.e3z_1 = ARGUMENT;
            this.s3y_1.f3z_1 = this.z3y_1;
            this.nf_1 = 6;
            continue $sm;
          case 6:
            var tmp2_rem = this.s3y_1.d3z_1;
            var soffset = this.t3y_1.ef(toLong(tmp2_rem)).md();
            var available = this.s3y_1.e3z_1.length - soffset | 0;
            var toRead = Math.min(available, this.w3y_1);
            arraycopy(this.s3y_1.e3z_1, soffset, this.u3y_1, this.v3y_1, toRead);
            return toRead;
          case 7:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 7) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class BufferedStreamBase extends AsyncStreamBase {
  constructor(base, blockSize, blocksToRead) {
    blockSize = blockSize === VOID ? 2048 : blockSize;
    blocksToRead = blocksToRead === VOID ? 16 : blocksToRead;
    super();
    this.a3z_1 = base;
    this.b3z_1 = blockSize;
    this.c3z_1 = blocksToRead;
    this.d3z_1 = imul(this.b3z_1, this.c3z_1);
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.byteArrayOf' call
    tmp$ret$0 = new Int8Array([]);
    tmp.e3z_1 = tmp$ret$0;
    this.f3z_1 = new Long(-1, -1);
  }
  h3f(position, buffer, offset, len, $completion) {
    var tmp0 = this.g3z(position, buffer, offset, len, $completion);
    return tmp0;
  }
  g3z(position, buffer, offset, len, $completion) {
    var tmp = new $_readCOROUTINE$162(this, position, buffer, offset, len, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  t3e($completion) {
    var tmp0 = this.a3z_1.t3e($completion);
    return tmp0;
  }
  w3b($completion) {
    var tmp0 = this.a3z_1.w3b($completion);
    return tmp0;
  }
}
class MemoryAsyncStreamBase extends AsyncStreamBase {
  constructor(data) {
    super();
    this.w3z_1 = data;
  }
  x3z() {
    return this.w3z_1.o();
  }
  t3e($completion) {
    return toLong(this.x3z());
  }
  y3z(position) {
    if (position.gd(new Long(0, 0)) < 0) {
      invalidOp('Invalid position ' + toString(position));
    }
  }
  h3f(position, buffer, offset, len, $completion) {
    this.y3z(position);
    var tmp$ret$0;
    // Inline function 'kotlin.ranges.contains' call
    var tmp0_contains = until_0(0, this.x3z());
    tmp$ret$0 = contains_0(isInterface(tmp0_contains, ClosedRange) ? tmp0_contains : THROW_CCE(), position);
    if (!tmp$ret$0)
      return 0;
    var tmp$ret$2;
    // Inline function 'kotlin.math.min' call
    var tmp1_min = toLong(this.x3z());
    var tmp$ret$1;
    // Inline function 'kotlin.Long.plus' call
    tmp$ret$1 = position.bf(toLong(len));
    var tmp2_min = tmp$ret$1;
    tmp$ret$2 = tmp1_min.gd(tmp2_min) <= 0 ? tmp1_min : tmp2_min;
    var end = tmp$ret$2;
    var tmp$ret$3;
    // Inline function 'kotlin.math.max' call
    var tmp3_max = end.hd(position).md();
    tmp$ret$3 = Math.max(tmp3_max, 0);
    var actualLen = tmp$ret$3;
    arraycopy(this.w3z_1.z34_1, position.md(), buffer, offset, actualLen);
    return actualLen;
  }
  w3b($completion) {
    return Unit_getInstance();
  }
  toString() {
    return 'MemoryAsyncStreamBase(' + this.w3z_1.o() + ')';
  }
}
class $readAllCOROUTINE$154 extends CoroutineImpl {
  constructor(_this__u8e3s4, resultContinuation) {
    super(resultContinuation);
    this.b3x_1 = _this__u8e3s4;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 18;
            this.nf_1 = 1;
            continue $sm;
          case 1:
            this.of_1 = 16;
            var tmp_0;
            var tmp_1 = this.b3x_1;
            if (isInterface(tmp_1, AsyncGetPositionStream)) {
              var tmp_2 = this.b3x_1;
              tmp_0 = isInterface(tmp_2, AsyncGetLengthStream);
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              this.nf_1 = 10;
              suspendResult = this.b3x_1.t3e(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_3 = this.b3x_1;
              if (tmp_3 instanceof AsyncStream) {
                this.nf_1 = 2;
                suspendResult = this.b3x_1.r3w(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.e3x_1 = false;
                this.nf_1 = 3;
                continue $sm;
              }
            }

            break;
          case 2:
            this.e3x_1 = suspendResult;
            this.nf_1 = 3;
            continue $sm;
          case 3:
            if (this.e3x_1) {
              this.nf_1 = 8;
              suspendResult = this.b3x_1.s3w(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f3x_1 = ByteArrayBuilder.c35();
              this.g3x_1 = new Int8Array(4096);
              this.nf_1 = 4;
              continue $sm;
            }

            ;
            break;
          case 4:
            if (false) {
              this.nf_1 = 7;
              continue $sm;
            }

            this.nf_1 = 5;
            suspendResult = this.b3x_1.y3j(this.g3x_1, 0, this.g3x_1.length, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.h3x_1 = suspendResult;
            if (this.h3x_1 <= 0) {
              this.nf_1 = 7;
              continue $sm;
            } else {
              this.nf_1 = 6;
              continue $sm;
            }

            break;
          case 6:
            this.f3x_1.d35(this.g3x_1, 0, this.h3x_1);
            this.nf_1 = 4;
            continue $sm;
          case 7:
            this.d3x_1 = this.f3x_1.f35();
            this.nf_1 = 13;
            continue $sm;
          case 8:
            this.i3x_1 = suspendResult;
            this.j3x_1 = this.i3x_1.md();
            this.nf_1 = 9;
            suspendResult = readBytesExact(this.b3x_1, this.j3x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            this.d3x_1 = suspendResult;
            this.nf_1 = 13;
            continue $sm;
          case 10:
            this.k3x_1 = suspendResult;
            this.nf_1 = 11;
            suspendResult = this.b3x_1.q3w(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            this.l3x_1 = suspendResult;
            this.m3x_1 = this.k3x_1.hd(this.l3x_1);
            this.nf_1 = 12;
            suspendResult = readBytesExact(this.b3x_1, this.m3x_1.md(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            this.d3x_1 = suspendResult;
            this.nf_1 = 13;
            continue $sm;
          case 13:
            this.c3x_1 = this.d3x_1;
            this.of_1 = 18;
            this.nf_1 = 14;
            continue $sm;
          case 14:
            this.n3x_1 = this.c3x_1;
            this.nf_1 = 15;
            suspendResult = this.b3x_1.w3b(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 15:
            return this.n3x_1;
          case 16:
            this.of_1 = 18;
            this.o3x_1 = this.qf_1;
            this.nf_1 = 17;
            suspendResult = this.b3x_1.w3b(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 17:
            throw this.o3x_1;
          case 18:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 18) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $readBytesExactCOROUTINE$157 extends CoroutineImpl {
  constructor(_this__u8e3s4, len, resultContinuation) {
    super(resultContinuation);
    this.x3x_1 = _this__u8e3s4;
    this.y3x_1 = len;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 2;
            var tmp_0 = this;
            tmp_0.z3x_1 = new Int8Array(this.y3x_1);
            {
            }

            this.nf_1 = 1;
            suspendResult = readExact(this.x3x_1, this.z3x_1, 0, this.y3x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.z3x_1;
          case 2:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 2) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $readExactCOROUTINE$163 extends CoroutineImpl {
  constructor(_this__u8e3s4, buffer, offset, len, resultContinuation) {
    super(resultContinuation);
    this.p3z_1 = _this__u8e3s4;
    this.q3z_1 = buffer;
    this.r3z_1 = offset;
    this.s3z_1 = len;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 5;
            this.t3z_1 = this.s3z_1;
            this.u3z_1 = this.r3z_1;
            this.v3z_1 = this.p3z_1;
            this.nf_1 = 1;
            continue $sm;
          case 1:
            if (!(this.t3z_1 > 0)) {
              this.nf_1 = 4;
              continue $sm;
            }

            this.nf_1 = 2;
            suspendResult = this.v3z_1.y3j(this.q3z_1, this.u3z_1, this.t3z_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var read = suspendResult;
            if (read < 0) {
              this.nf_1 = 4;
              continue $sm;
            } else {
              this.nf_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            if (read === 0)
              throw EOFException.q42('Not enough data. Expected=' + this.s3z_1 + ', Read=' + (this.s3z_1 - this.t3z_1 | 0) + ', Remaining=' + this.t3z_1);
            this.u3z_1 = this.u3z_1 + read | 0;
            this.t3z_1 = this.t3z_1 - read | 0;
            this.nf_1 = 1;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 5) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $readBytesCOROUTINE$167 extends CoroutineImpl {
  constructor(_this__u8e3s4, position, count, resultContinuation) {
    super(resultContinuation);
    this.h40_1 = _this__u8e3s4;
    this.i40_1 = position;
    this.j40_1 = count;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 2;
            this.k40_1 = new Int8Array(this.j40_1);
            this.nf_1 = 1;
            suspendResult = this.h40_1.h3f(this.i40_1, this.k40_1, 0, this.k40_1.length, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var readLen = suspendResult;
            return copyOf(this.k40_1, readLen);
          case 2:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 2) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $readBytesUpToCOROUTINE$169 extends CoroutineImpl {
  constructor(_this__u8e3s4, len, resultContinuation) {
    super(resultContinuation);
    this.t40_1 = _this__u8e3s4;
    this.u40_1 = len;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 10;
            this.v40_1 = 4096;
            if (this.u40_1 <= this.v40_1) {
              this.nf_1 = 9;
              suspendResult = readBytesUpToCopy(this.t40_1, new Int8Array(this.u40_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.nf_1 = 1;
              continue $sm;
            }

            break;
          case 1:
            var tmp_0 = this.t40_1;
            if (isInterface(tmp_0, AsyncPositionLengthStream)) {
              this.nf_1 = 7;
              suspendResult = getAvailable(this.t40_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.nf_1 = 2;
              continue $sm;
            }

            break;
          case 2:
            this.w40_1 = this.u40_1;
            this.x40_1 = new Int8Array(this.v40_1);
            this.y40_1 = ByteArrayBuilder.c35();
            this.nf_1 = 3;
            continue $sm;
          case 3:
            if (!(this.w40_1 > 0)) {
              this.nf_1 = 6;
              continue $sm;
            }

            this.nf_1 = 4;
            var tmp1_min = this.x40_1.length;
            var tmp2_min = this.w40_1;
            suspendResult = this.t40_1.y3j(this.x40_1, 0, Math.min(tmp1_min, tmp2_min), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.z40_1 = suspendResult;
            if (this.z40_1 <= 0) {
              this.nf_1 = 6;
              continue $sm;
            } else {
              this.nf_1 = 5;
              continue $sm;
            }

            break;
          case 5:
            this.y40_1.d35(this.x40_1, 0, this.z40_1);
            this.w40_1 = this.w40_1 - this.z40_1 | 0;
            this.nf_1 = 3;
            continue $sm;
          case 6:
            return this.y40_1.f35();
          case 7:
            this.a41_1 = suspendResult;
            this.b41_1 = toIntClamp(this.a41_1);
            this.c41_1 = Math.min(this.u40_1, this.b41_1);
            this.d41_1 = new Int8Array(this.c41_1);
            this.nf_1 = 8;
            suspendResult = readBytesUpToCopy(this.t40_1, this.d41_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            return suspendResult;
          case 9:
            return suspendResult;
          case 10:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 10) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $readBytesUpToCopyCOROUTINE$174 extends CoroutineImpl {
  constructor(_this__u8e3s4, out, resultContinuation) {
    super(resultContinuation);
    this.m41_1 = _this__u8e3s4;
    this.n41_1 = out;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 2;
            this.nf_1 = 1;
            suspendResult = readBytesUpTo_0(this.m41_1, this.n41_1, 0, this.n41_1.length, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var pos = suspendResult;
            return this.n41_1.length === pos ? this.n41_1 : copyOf(this.n41_1, pos);
          case 2:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 2) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $getAvailableCOROUTINE$175 extends CoroutineImpl {
  constructor(_this__u8e3s4, resultContinuation) {
    super(resultContinuation);
    this.w41_1 = _this__u8e3s4;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 3;
            this.nf_1 = 1;
            suspendResult = this.w41_1.t3e(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.x41_1 = suspendResult;
            this.nf_1 = 2;
            suspendResult = this.w41_1.q3w(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return this.x41_1.hd(ARGUMENT);
          case 3:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 3) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class $readBytesUpToCOROUTINE$176 extends CoroutineImpl {
  constructor(_this__u8e3s4, out, offset, len, resultContinuation) {
    super(resultContinuation);
    this.g42_1 = _this__u8e3s4;
    this.h42_1 = out;
    this.i42_1 = offset;
    this.j42_1 = len;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 4;
            this.k42_1 = 0;
            this.l42_1 = this.j42_1;
            this.m42_1 = this.i42_1;
            this.nf_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this.nf_1 = 5;
              continue $sm;
            }

            this.nf_1 = 2;
            suspendResult = this.g42_1.y3j(this.h42_1, this.m42_1, this.l42_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var result = suspendResult;
            if (result <= 0) {
              this.nf_1 = 5;
              continue $sm;
            } else {
              this.nf_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            this.m42_1 = this.m42_1 + result | 0;
            this.l42_1 = this.l42_1 - result | 0;
            this.k42_1 = this.k42_1 + result | 0;
            this.nf_1 = 1;
            continue $sm;
          case 4:
            throw this.qf_1;
          case 5:
            return this.k42_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 4) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class NumberParser {
  constructor() {
    NumberParser_instance = this;
  }
  r42(str, start, end, radix) {
    var positive = true;
    var out = 0;
    var inductionVariable = start;
    if (inductionVariable < end)
      loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(str, n);
        if (c === _Char___init__impl__6a9atx(45) ? true : c === _Char___init__impl__6a9atx(43)) {
          positive = c === _Char___init__impl__6a9atx(43);
        } else {
          var value = ctypeAsInt(c);
          if (value < 0)
            break loop;
          out = imul(out, radix);
          out = out + value | 0;
        }
      }
       while (inductionVariable < end);
    return positive ? out : -out | 0;
  }
  r3u(str, start, end) {
    var out = 0.0;
    var frac = 1.0;
    var pointSeen = false;
    var eSeen = false;
    var negate = false;
    var negateExponent = false;
    var exponent = 0;
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(str, n);
        var tmp1_subject = c;
        if (tmp1_subject === _Char___init__impl__6a9atx(101) ? true : tmp1_subject === _Char___init__impl__6a9atx(69))
          eSeen = true;
        else if (tmp1_subject === _Char___init__impl__6a9atx(45)) {
          if (eSeen)
            negateExponent = true;
          else
            negate = true;
        } else if (tmp1_subject === _Char___init__impl__6a9atx(46))
          pointSeen = true;
        else {
          if (eSeen) {
            exponent = imul(exponent, 10);
            exponent = exponent + ctypeAsInt(c) | 0;
          } else {
            if (pointSeen)
              frac = frac / 10;
            out = out * 10;
            out = out + ctypeAsInt(c);
          }
        }
      }
       while (inductionVariable < end);
    var tmp = out * frac;
    var tmp$ret$0;
    // Inline function 'kotlin.math.pow' call
    var tmp0_pow = negateExponent ? -exponent | 0 : exponent;
    tmp$ret$0 = Math.pow(10.0, tmp0_pow);
    var res = tmp * tmp$ret$0;
    return negate ? -res : res;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_13 = this;
  }
}
class BaseStrReader {
  p3u() {
    return !this.u42();
  }
  o3u() {
    return this.b43(0);
  }
  q3u() {
    var out = this.o3u();
    this.x42(1);
    return out;
  }
  j3u(expected) {
    var readed = this.q3u();
    if (!(readed === expected))
      throw IllegalArgumentException.b4("Expected '" + new Char(expected) + "' but found '" + new Char(readed) + "' at " + this.s42());
  }
  x3o(lit, consume, $super) {
    consume = consume === VOID ? true : consume;
    return $super === VOID ? this.y42(lit, consume) : $super.y42.call(this, lit, consume);
  }
  k3u() {
    // Inline function 'korlibs.io.util.BaseStrReader.skipWhile' call
    $l$loop: while (true) {
      var tmp;
      if (this.p3u()) {
        var tmp$ret$0;
        // Inline function 'korlibs.io.util.BaseStrReader.skipSpaces.<anonymous>' call
        var tmp0_anonymous = this.o3u();
        tmp$ret$0 = isWhitespaceFast(tmp0_anonymous);
        tmp = tmp$ret$0;
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      this.q3u();
    }
    return this;
  }
  i3u(str) {
    return !(this.y42(str, true) == null);
  }
  w42(count) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = this.u2g(count);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.BaseStrReader.read.<anonymous>' call
    this.x42(count);
    tmp$ret$0 = tmp0_apply;
    return tmp$ret$0;
  }
}
class StrReader extends BaseStrReader {
  constructor(str, file, pos) {
    Companion_getInstance_18();
    file = file === VOID ? 'file' : file;
    pos = pos === VOID ? 0 : pos;
    super();
    this.r3o_1 = str;
    this.s3o_1 = file;
    this.t3o_1 = pos;
    this.u3o_1 = charArray(this.r3o_1.length);
    this.v3o_1 = this.r3o_1.length;
  }
  s42() {
    return this.t3o_1;
  }
  t42() {
    return this.v3o_1 - this.t3o_1 | 0;
  }
  u42() {
    return this.t3o_1 >= this.r3o_1.length;
  }
  k3u() {
    super.k3u();
    return this;
  }
  u2g(count) {
    return substr_0(this, this.t3o_1, count);
  }
  o3u() {
    return this.p3u() ? charSequenceGet(this.r3o_1, this.t3o_1) : _Char___init__impl__6a9atx(0);
  }
  v42(count) {
    var tmp0_this = this;
    tmp0_this.t3o_1 = tmp0_this.t3o_1 - count | 0;
    return this;
  }
  m3u(count, $super) {
    count = count === VOID ? 1 : count;
    return $super === VOID ? this.v42(count) : $super.v42.call(this, count);
  }
  q3u() {
    return this.p3u() ? charSequenceGet(this.r3o_1, posSkip(this, 1)) : _Char___init__impl__6a9atx(0);
  }
  l3u() {
    return this.p3u() ? charSequenceGet(this.r3o_1, posSkip(this, 1)) : _Char___init__impl__6a9atx(0);
  }
  y3o() {
    return this.w42(this.t42());
  }
  x42(count) {
    var tmp0_this = this;
    tmp0_this.t3o_1 = tmp0_this.t3o_1 + count | 0;
    return this;
  }
  y42(lit, consume) {
    if (!substringEquals(StringCompanionObject_getInstance(), this.r3o_1, this.t3o_1, lit, 0, lit.length))
      return null;
    if (consume) {
      var tmp0_this = this;
      tmp0_this.t3o_1 = tmp0_this.t3o_1 + lit.length | 0;
    }
    return lit;
  }
  w3o(v) {
    var tmp$ret$1;
    // Inline function 'kotlin.text.substring' call
    var tmp0_substring = this.r3o_1;
    var tmp1_substring = this.t3o_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_substring;
    tmp$ret$1 = tmp$ret$0.substring(tmp1_substring);
    var tmp0_elvis_lhs = v.kb(tmp$ret$1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var result = tmp;
    var m = ensureNotNull(result.ec().p(0)).dc_1;
    var tmp1_this = this;
    tmp1_this.t3o_1 = tmp1_this.t3o_1 + m.length | 0;
    return m;
  }
  z42(count, radix) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.t42();
    tmp$ret$0 = Math.min(tmp0_min, count);
    var readCount = tmp$ret$0;
    this.x42(readCount);
    return NumberParser_getInstance().r42(this.r3o_1, this.t3o_1 - readCount | 0, this.t3o_1, radix);
  }
  a43(reportErrors) {
    var out = this.u3o_1;
    var outp = 0;
    var quotec = this.l3u();
    var tmp0_subject = quotec;
    if (tmp0_subject === _Char___init__impl__6a9atx(34) ? true : tmp0_subject === _Char___init__impl__6a9atx(39))
    ;
    else {
      invalidOp('Invalid string literal');
    }
    var closed = false;
    loop: while (this.p3u()) {
      var c = this.l3u();
      if (c === _Char___init__impl__6a9atx(92)) {
        var cc = this.l3u();
        var tmp2 = outp;
        outp = tmp2 + 1 | 0;
        var tmp1_subject = cc;
        var tmp;
        if (tmp1_subject === _Char___init__impl__6a9atx(92)) {
          tmp = _Char___init__impl__6a9atx(92);
        } else if (tmp1_subject === _Char___init__impl__6a9atx(47)) {
          tmp = _Char___init__impl__6a9atx(47);
        } else if (tmp1_subject === _Char___init__impl__6a9atx(39)) {
          tmp = _Char___init__impl__6a9atx(39);
        } else if (tmp1_subject === _Char___init__impl__6a9atx(34)) {
          tmp = _Char___init__impl__6a9atx(34);
        } else if (tmp1_subject === _Char___init__impl__6a9atx(98)) {
          tmp = _Char___init__impl__6a9atx(8);
        } else if (tmp1_subject === _Char___init__impl__6a9atx(102)) {
          tmp = _Char___init__impl__6a9atx(12);
        } else if (tmp1_subject === _Char___init__impl__6a9atx(110)) {
          tmp = _Char___init__impl__6a9atx(10);
        } else if (tmp1_subject === _Char___init__impl__6a9atx(114)) {
          tmp = _Char___init__impl__6a9atx(13);
        } else if (tmp1_subject === _Char___init__impl__6a9atx(116)) {
          tmp = _Char___init__impl__6a9atx(9);
        } else if (tmp1_subject === _Char___init__impl__6a9atx(117)) {
          tmp = numberToChar(this.z42(4, 16));
        } else {
          throw IOException.l3o("Invalid char '" + new Char(cc) + "'");
        }
        out[tmp2] = tmp;
      } else if (c === quotec) {
        closed = true;
        break loop;
      } else {
        var tmp3 = outp;
        outp = tmp3 + 1 | 0;
        out[tmp3] = c;
      }
    }
    if (!closed ? reportErrors : false) {
      throw RuntimeException.u6("String literal not closed! '" + this.r3o_1 + "'");
    }
    return String_fromCharArray(out, 0, outp);
  }
  t3u(reportErrors, $super) {
    reportErrors = reportErrors === VOID ? true : reportErrors;
    return $super === VOID ? this.a43(reportErrors) : $super.a43.call(this, reportErrors);
  }
  b43(offset) {
    var tmp$ret$1;
    // Inline function 'kotlin.text.getOrElse' call
    var tmp0_getOrElse = this.r3o_1;
    var tmp1_getOrElse = this.t3o_1 + offset | 0;
    var tmp;
    if (tmp1_getOrElse >= 0 ? tmp1_getOrElse <= get_lastIndex(tmp0_getOrElse) : false) {
      tmp = charSequenceGet(tmp0_getOrElse, tmp1_getOrElse);
    } else {
      var tmp$ret$0;
      // Inline function 'korlibs.io.util.StrReader.peekOffset.<anonymous>' call
      tmp$ret$0 = _Char___init__impl__6a9atx(0);
      tmp = tmp$ret$0;
    }
    tmp$ret$1 = tmp;
    return tmp$ret$1;
  }
}
class DynamicInternal {
  constructor() {
    DynamicInternal_instance = this;
  }
  d38(instance, key) {
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = instance;
    return tmp$ret$0[key];
  }
}
class standardVfs$1 extends StandardVfs {
  constructor() {
    super();
    var tmp = this;
    tmp.h43_1 = lazy(standardVfs$o$resourcesVfs$delegate$lambda);
    var tmp_0 = this;
    tmp_0.i43_1 = lazy(standardVfs$o$rootLocalVfs$delegate$lambda);
  }
}
class EnvironmentInternal {
  constructor() {
    EnvironmentInternal_instance = this;
  }
  fc(key) {
    return get_jsRuntime().j43(key);
  }
}
class FileNotFoundException extends IOException {
  static u3l(msg) {
    var $this = super.l3o(msg);
    captureStack($this, $this.t3l_1);
    return $this;
  }
}
class EOFException extends IOException {
  static q42(msg) {
    var $this = super.l3o(msg);
    captureStack($this, $this.p42_1);
    return $this;
  }
}
class JS_UTF8$1 extends UTC8CharsetBase {
  constructor() {
    super('UTF-8');
    var tmp = this;
    var tmp_0;
    try {
      tmp_0 = new TextDecoder('utf-8');
    } catch ($p) {
      var tmp_1;
      {
        var e = $p;
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    }
    tmp.l43_1 = tmp_0;
    var tmp_2 = this;
    var tmp_3;
    try {
      tmp_3 = new TextEncoder('utf-8');
    } catch ($p) {
      var tmp_4;
      {
        var e_0 = $p;
        tmp_4 = null;
      }
      tmp_3 = tmp_4;
    }
    tmp_2.m43_1 = tmp_3;
  }
  r3n(out, src, start, end) {
    if (!(this.l43_1 == null)) {
      var tmp$ret$1;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = src;
      tmp$ret$1 = tmp$ret$0;
      var srcBuffer = tmp$ret$1;
      out.a8(this.l43_1.decode(new Int8Array(srcBuffer.buffer, start, end - start | 0)));
    } else {
      protoOf(UTC8CharsetBase).r3n.call(this, out, src, start, end);
    }
    return end - start | 0;
  }
}
class httpFactory$2$1 {
  a3u() {
    return get_jsRuntime().n43();
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_14 = this;
    this.o43_1 = Companion_getInstance_1().h36('JsRuntime');
  }
}
class JsRuntime {
  constructor() {
    Companion_getInstance_19();
    this.c43_1 = 'unknown';
    this.d43_1 = get_isDenoJs() ? 'deno.js' : get_isWeb() ? 'web.js' : get_isNodeJs() ? 'node.js' : get_isWorker() ? 'worker.js' : get_isShell() ? 'shell.js' : 'js';
    var tmp = this;
    tmp.e43_1 = lazy(JsRuntime$_envs$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.f43_1 = lazy(JsRuntime$_envsUC$delegate$lambda(this));
  }
  r43() {
    return '.';
  }
  j43(key) {
    var tmp = _get__envsUC__n5sgyq(this);
    var tmp$ret$1;
    // Inline function 'kotlin.text.uppercase' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = key;
    tmp$ret$1 = tmp$ret$0.toUpperCase();
    return tmp.u3(tmp$ret$1);
  }
  g43(path) {
    throw NotImplementedError.eg();
  }
  n43() {
    throw NotImplementedError.eg();
  }
}
class JsRuntimeBrowser extends JsRuntime {
  constructor() {
    JsRuntimeBrowser_instance = null;
    super();
    JsRuntimeBrowser_instance = this;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = navigator.platform;
    tmp$ret$0 = tmp0_unsafeCast;
    tmp.w43_1 = tmp$ret$0;
    var tmp_0 = this;
    tmp_0.x43_1 = lazy(JsRuntimeBrowser$href$delegate$lambda);
    var tmp_1 = this;
    tmp_1.y43_1 = lazy(JsRuntimeBrowser$baseUrl$delegate$lambda);
  }
  z43() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = href$factory();
    tmp$ret$0 = this.x43_1.p3();
    return tmp$ret$0;
  }
  a44() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = baseUrl$factory();
    tmp$ret$0 = this.y43_1.p3();
    return tmp$ret$0;
  }
  q43(path) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.eg('An operation is not implemented: Not yet implemented');
  }
  r43() {
    return this.a44();
  }
  p43() {
    var tmp$ret$3;
    // Inline function 'kotlin.collections.map' call
    var tmp = QueryString_getInstance();
    var tmp0_safe_receiver = document.location;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.search;
    var tmp0_map = tmp.m3o(trimStart(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs, charArrayOf([_Char___init__impl__6a9atx(63)])));
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(tmp0_map.o());
    var tmp$ret$0;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$0 = tmp0_map.l3().u();
    var tmp0_iterator = tmp$ret$0;
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$1;
      // Inline function 'korlibs.io.runtime.browser.JsRuntimeBrowser.envs.<anonymous>' call
      var tmp_0 = item.o3();
      var tmp0_elvis_lhs = firstOrNull(item.p3());
      tmp$ret$1 = to(tmp_0, tmp0_elvis_lhs == null ? item.o3() : tmp0_elvis_lhs);
      tmp0_mapTo.e1(tmp$ret$1);
    }
    tmp$ret$2 = tmp0_mapTo;
    tmp$ret$3 = tmp$ret$2;
    return toMap(tmp$ret$3);
  }
  g43(path) {
    var tmp$ret$2;
    // Inline function 'kotlin.also' call
    var tmp0_also = withCatalogJail(UrlVfs_1(this.r43()).fc(path)).e2f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.runtime.browser.JsRuntimeBrowser.openVfs.<anonymous>' call
    var tmp$ret$1;
    // Inline function 'korlibs.logger.Logger.info' call
    var tmp0_info = Companion_getInstance_19().o43_1;
    var tmp0_log = Level_INFO_getInstance();
    var tmp;
    if (tmp0_info.v36(tmp0_log)) {
      var tmp$ret$0;
      // Inline function 'korlibs.io.runtime.browser.JsRuntimeBrowser.openVfs.<anonymous>.<anonymous>' call
      tmp$ret$0 = 'BROWSER openVfs: currentDir=' + JsRuntimeBrowser_getInstance().r43() + ', path=' + path + ', urlVfs=' + tmp0_also;
      tmp0_info.w36(tmp0_log, tmp$ret$0);
      tmp = Unit_getInstance();
    }
    tmp$ret$1 = tmp;
    tmp$ret$2 = tmp0_also;
    return tmp$ret$2;
  }
  n43() {
    return new HttpClientBrowserJs();
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_15 = this;
    var tmp = this;
    var tmp$ret$1;
    // Inline function 'kotlin.text.lowercase' call
    var tmp0_lowercase = Companion_getInstance_13().k3n_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_lowercase;
    tmp$ret$1 = tmp$ret$0.toLowerCase();
    tmp.b44_1 = setOf(['connection', tmp$ret$1]);
  }
}
class $requestInternalCOROUTINE$179 extends CoroutineImpl {
  constructor(_this__u8e3s4, method, url, headers, content, resultContinuation) {
    super(resultContinuation);
    this.k44_1 = _this__u8e3s4;
    this.l44_1 = method;
    this.m44_1 = url;
    this.n44_1 = headers;
    this.o44_1 = content;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 6;
            this.p44_1 = CompletableDeferred(Job());
            this.q44_1 = new XMLHttpRequest();
            this.q44_1.open(this.l44_1.be(), this.m44_1, true);
            var tmp0_get_ARRAYBUFFER_cp9qbo = null;
            var tmp0_unsafeCast = 'arraybuffer';
            this.q44_1.responseType = tmp0_unsafeCast;
            this.q44_1.onload = HttpClientBrowserJs$requestInternal$lambda(this.q44_1, this.p44_1);
            this.q44_1.onerror = HttpClientBrowserJs$requestInternal$lambda_0(this.p44_1, this.q44_1, this.m44_1);
            var tmp0_iterator = this.n44_1.u();
            while (tmp0_iterator.h1()) {
              var header = tmp0_iterator.j1();
              var tmp1_lowercase = header.ri_1;
              var tmp2_trim = tmp1_lowercase.toLowerCase();
              var hnname = toString(trim_0(isCharSequence(tmp2_trim) ? tmp2_trim : THROW_CCE()));
              if (!Companion_getInstance_20().b44_1.w(hnname)) {
                this.q44_1.setRequestHeader(header.ri_1, header.si_1);
              }
            }

            this.p44_1.t2r(HttpClientBrowserJs$requestInternal$lambda_1(this.p44_1, this.q44_1));
            ;
            if (!(this.o44_1 == null)) {
              this.nf_1 = 1;
              suspendResult = readAll(this.o44_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.q44_1.send();
              this.nf_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this.r44_1 = suspendResult;
            this.q44_1.send(this.r44_1);
            this.nf_1 = 2;
            continue $sm;
          case 2:
            this.s44_1 = this.o44_1;
            if (this.s44_1 == null) {
              this.t44_1 = null;
              this.nf_1 = 4;
              continue $sm;
            } else {
              this.nf_1 = 3;
              suspendResult = this.s44_1.w3b(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

            break;
          case 3:
            var tmp_0 = this;
            tmp_0.t44_1 = Unit_getInstance();
            this.nf_1 = 4;
            continue $sm;
          case 4:
            ;
            this.nf_1 = 5;
            suspendResult = this.p44_1.c2t(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            return suspendResult;
          case 6:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 6) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class HttpClientBrowserJs extends HttpClient {
  constructor() {
    Companion_getInstance_20();
    super();
  }
  v3s(method, url, headers, content, $completion) {
    var tmp = new $requestInternalCOROUTINE$179(this, method, url, headers, content, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
}
class JsRuntimeDeno extends JsRuntime {
  constructor() {
    JsRuntimeDeno_instance = null;
    super();
    JsRuntimeDeno_instance = this;
  }
  q43(path) {
    var tmp;
    try {
      Deno.statSync(path);
      tmp = true;
    } catch ($p) {
      var tmp_0;
      {
        var e = $p;
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  r43() {
    return Deno.cwd();
  }
  j43(key) {
    return Deno.env.get(key);
  }
  p43() {
    return jsObjectToMap(Deno.env.toObject());
  }
}
class JsRuntimeNode extends JsRuntime {
  constructor() {
    JsRuntimeNode_instance = null;
    super();
    JsRuntimeNode_instance = this;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = process.platform;
    tmp$ret$0 = tmp0_unsafeCast;
    tmp.d45_1 = tmp$ret$0;
    var tmp_0 = this;
    tmp_0.e45_1 = lazy(JsRuntimeNode$fs$delegate$lambda);
    var tmp_1 = this;
    tmp_1.f45_1 = lazy(JsRuntimeNode$path$delegate$lambda);
  }
  q43(path) {
    return _get_fs__ndc19a(this).existsSync(path);
  }
  r43() {
    return _get_path__dbvv7q(this).resolve('.');
  }
  j43(key) {
    return process.env[key];
  }
  p43() {
    return jsObjectToMap(process.env);
  }
  g43(path) {
    var tmp;
    if (path === '.') {
      var path_0 = get_jsRuntime().r43();
      tmp = ((get_jsRuntime().q43(path_0 + '/node_modules') ? get_jsRuntime().q43(path_0 + '/kotlin') : false) ? get_jsRuntime().q43(path_0 + '/package.json') : false) ? path_0 + '/kotlin' : path_0;
    } else {
      tmp = path;
    }
    var rpath = tmp;
    return (new NodeJsLocalVfs()).fc(rpath);
  }
  n43() {
    return new HttpClientNodeJs();
  }
}
class $openCOROUTINE$183 extends CoroutineImpl {
  constructor(_this__u8e3s4, path, mode, resultContinuation) {
    super(resultContinuation);
    this.p45_1 = _this__u8e3s4;
    this.q45_1 = path;
    this.r45_1 = mode;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 5;
            this.s45_1 = this.r45_1;
            this.t45_1 = this.s45_1.bc_1;
            if (this.t45_1 === 0) {
              this.u45_1 = 'r';
              this.nf_1 = 3;
              continue $sm;
            } else {
              if (this.t45_1 === 1) {
                this.u45_1 = 'r+';
                this.nf_1 = 3;
                continue $sm;
              } else {
                if (this.t45_1 === 3) {
                  this.u45_1 = 'w+';
                  this.nf_1 = 3;
                  continue $sm;
                } else {
                  if (this.t45_1 === 5) {
                    this.nf_1 = 1;
                    suspendResult = this.p45_1.t3b(this.q45_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (this.t45_1 === 4) {
                      this.u45_1 = 'wx+';
                      this.nf_1 = 3;
                      continue $sm;
                    } else {
                      if (this.t45_1 === 2) {
                        this.u45_1 = 'a';
                        this.nf_1 = 3;
                        continue $sm;
                      } else {
                        var tmp_0 = this;
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }

            break;
          case 1:
            this.v45_1 = suspendResult;
            if (this.v45_1.c3b_1) {
              throw FileAlreadyExistsException.i3o(this.q45_1);
            } else {
              this.nf_1 = 2;
              continue $sm;
            }

            break;
          case 2:
            this.u45_1 = 'w+';
            this.nf_1 = 3;
            continue $sm;
          case 3:
            this.w45_1 = this.u45_1;
            this.nf_1 = 4;
            suspendResult = this.p45_1.x45(this.q45_1, this.w45_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return suspendResult;
          case 5:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 5) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class NodeJsLocalVfs extends LocalVfs {
  g45(_this__u8e3s4, path) {
    var tmp0_elvis_lhs = _this__u8e3s4;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this.a3c(path);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var stats = tmp;
    return this.y3b(path, stats.isDirectory(), numberToLong(stats.size), numberToLong(stats.dev), numberToLong(stats.ino), numberToInt(stats.mode), VOID, VOID, Companion_getInstance_3().f33(stats.ctimeMs), Companion_getInstance_3().f33(stats.mtimeMs), Companion_getInstance_3().f33(stats.atimeMs));
  }
  t3b(path, $completion) {
    var deferred = CompletableDeferred();
    var tmp = get_nodeFS();
    tmp.stat(path, NodeJsLocalVfs$stat$lambda(deferred, this, path));
    var tmp0 = deferred.c2t($completion);
    return tmp0;
  }
  r3b(path, mode, $completion) {
    var tmp = new $openCOROUTINE$183(this, path, mode, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  x45(path, cmode, $completion) {
    var file = this.a3b(path);
    var tmp$ret$0;
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var tmp0_anonymous = $completion;
    var cancellable = new CancellableContinuationImpl(intercepted(tmp0_anonymous), get_MODE_CANCELLABLE());
    cancellable.z2u();
    // Inline function 'korlibs.io.runtime.node.NodeJsLocalVfs._open.<anonymous>' call
    var tmp = get_nodeFS();
    var tmp_0 = getFullPath(this, path);
    tmp.open(tmp_0, cmode, NodeJsLocalVfs$_open$lambda(path, cmode, cancellable, file));
    cancellable.l2t(NodeJsLocalVfs$_open$lambda_0);
    tmp$ret$0 = cancellable.o2s();
    var tmp0 = tmp$ret$0;
    return tmp0;
  }
  toString() {
    return 'NodeJsLocalVfs';
  }
}
class $requestInternalCOROUTINE$188 extends CoroutineImpl {
  constructor(_this__u8e3s4, method, url, headers, content, resultContinuation) {
    super(resultContinuation);
    this.g46_1 = _this__u8e3s4;
    this.h46_1 = method;
    this.i46_1 = url;
    this.j46_1 = headers;
    this.k46_1 = content;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 6;
            this.l46_1 = CompletableDeferred(Job());
            this.m46_1 = require_node('http');
            this.n46_1 = require_node('url');
            this.o46_1 = this.n46_1.parse(this.i46_1);
            this.p46_1 = jsEmptyObj();
            var tmp0_iterator = this.j46_1.u();
            while (tmp0_iterator.h1()) {
              var header = tmp0_iterator.j1();
              this.p46_1[header.ri_1] = header.si_1;
            }

            this.q46_1 = jsEmptyObj();
            this.q46_1.method = this.h46_1.be();
            this.q46_1.host = this.o46_1['hostname'];
            this.q46_1.port = this.o46_1['port'];
            this.q46_1.path = this.o46_1['path'];
            this.q46_1.agent = false;
            this.q46_1.encoding = null;
            this.q46_1.headers = this.p46_1;
            var tmp_0 = this;
            tmp_0.r46_1 = this.m46_1.request(this.q46_1, HttpClientNodeJs$requestInternal$lambda(this.l46_1)).on('error', HttpClientNodeJs$requestInternal$lambda_0(this.l46_1));
            this.l46_1.t2r(HttpClientNodeJs$requestInternal$lambda_1(this.l46_1, this.r46_1));
            ;
            if (!(this.k46_1 == null)) {
              this.nf_1 = 1;
              suspendResult = readAll(this.k46_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.r46_1.end();
              this.nf_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this.s46_1 = suspendResult;
            this.t46_1 = toTypedArray(this.s46_1);
            this.r46_1.end(this.t46_1);
            this.nf_1 = 2;
            continue $sm;
          case 2:
            this.u46_1 = this.k46_1;
            if (this.u46_1 == null) {
              this.v46_1 = null;
              this.nf_1 = 4;
              continue $sm;
            } else {
              this.nf_1 = 3;
              suspendResult = this.u46_1.w3b(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

            break;
          case 3:
            var tmp_1 = this;
            tmp_1.v46_1 = Unit_getInstance();
            this.nf_1 = 4;
            continue $sm;
          case 4:
            ;
            this.nf_1 = 5;
            suspendResult = this.l46_1.c2t(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            return suspendResult;
          case 6:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 6) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class HttpClientNodeJs extends HttpClient {
  v3s(method, url, headers, content, $completion) {
    var tmp = new $requestInternalCOROUTINE$188(this, method, url, headers, content, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
}
class $closeCOROUTINE$191 extends CoroutineImpl {
  constructor(_this__u8e3s4, resultContinuation) {
    super(resultContinuation);
    this.h47_1 = _this__u8e3s4;
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 3;
            if (!(this.h47_1.y46_1 == null)) {
              this.nf_1 = 2;
              var tmp0_anonymous = this;
              var cancellable = new CancellableContinuationImpl(intercepted(tmp0_anonymous), get_MODE_CANCELLABLE());
              cancellable.z2u();
              {
                var tmp_0 = get_nodeFS();
                var tmp_1 = this.h47_1.y46_1;
                tmp_0.close(tmp_1, NodeFDStream$close$lambda(this.h47_1, cancellable));
                cancellable.l2t(NodeFDStream$close$lambda_0);
              }
              suspendResult = returnIfSuspended(cancellable.o2s(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.nf_1 = 1;
              continue $sm;
            }

            break;
          case 1:
            return Unit_getInstance();
          case 2:
            return Unit_getInstance();
          case 3:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 3) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
}
class NodeFDStream extends AsyncStreamBase {
  constructor(file, fd) {
    super();
    this.x46_1 = file;
    this.y46_1 = fd;
  }
  h3f(position, buffer, offset, len, $completion) {
    var tmp$ret$0;
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var tmp0_anonymous = $completion;
    var cancellable = new CancellableContinuationImpl(intercepted(tmp0_anonymous), get_MODE_CANCELLABLE());
    cancellable.z2u();
    // Inline function 'korlibs.io.runtime.node.NodeFDStream.read.<anonymous>' call
    checkFd(this);
    var tmp = get_nodeFS();
    var tmp_0 = this.y46_1;
    var tmp_1 = toNodeJsBuffer(buffer);
    var tmp_2 = position.fe();
    tmp.read(tmp_0, tmp_1, offset, len, tmp_2, NodeFDStream$read$lambda(this, cancellable));
    cancellable.l2t(NodeFDStream$read$lambda_0);
    tmp$ret$0 = cancellable.o2s();
    var tmp0 = tmp$ret$0;
    return tmp0;
  }
  t3e($completion) {
    var tmp$ret$0;
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var tmp0_anonymous = $completion;
    var cancellable = new CancellableContinuationImpl(intercepted(tmp0_anonymous), get_MODE_CANCELLABLE());
    cancellable.z2u();
    // Inline function 'korlibs.io.runtime.node.NodeFDStream.getLength.<anonymous>' call
    checkFd(this);
    var tmp = get_nodeFS();
    var tmp_0 = this.y46_1;
    tmp.fstat(tmp_0, NodeFDStream$getLength$lambda(this, cancellable));
    cancellable.l2t(NodeFDStream$getLength$lambda_0);
    tmp$ret$0 = cancellable.o2s();
    var tmp0 = tmp$ret$0;
    return tmp0;
  }
  w3b($completion) {
    var tmp = new $closeCOROUTINE$191(this, $completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
}
//endregion
function get_logger() {
  _init_properties_AsyncExt_kt__ahev1h();
  return logger;
}
var logger;
var DEFAULT_SUSPEND_TEST_TIMEOUT;
function get_DEBUG_ASYNC_LAUNCH_ERRORS() {
  _init_properties_AsyncExt_kt__ahev1h();
  // Inline function 'kotlin.getValue' call
  DEBUG_ASYNC_LAUNCH_ERRORS$factory();
  return DEBUG_ASYNC_LAUNCH_ERRORS$delegate.p3();
}
var DEBUG_ASYNC_LAUNCH_ERRORS$delegate;
function async_0(context, callback) {
  _init_properties_AsyncExt_kt__ahev1h();
  return asyncImmediately(CoroutineScope(context), callback);
}
function asyncImmediately(_this__u8e3s4, callback) {
  _init_properties_AsyncExt_kt__ahev1h();
  return _async(_this__u8e3s4, CoroutineStart_UNDISPATCHED_getInstance(), callback);
}
function _async(_this__u8e3s4, start, callback) {
  _init_properties_AsyncExt_kt__ahev1h();
  var tmp = _this__u8e3s4.t2q();
  return async(_this__u8e3s4, tmp, start, _async$slambda_0(callback, null));
}
function asyncImmediately_0(context, callback) {
  _init_properties_AsyncExt_kt__ahev1h();
  return asyncImmediately(CoroutineScope(context), callback);
}
function DEBUG_ASYNC_LAUNCH_ERRORS$delegate$lambda() {
  _init_properties_AsyncExt_kt__ahev1h();
  return Companion_getInstance_9().fc('DEBUG_ASYNC_LAUNCH_ERRORS') === 'true';
}
function _async$slambda_0($callback, resultContinuation) {
  var i = new _async$slambda($callback, resultContinuation);
  var l = function ($this$async, $completion) {
    return i.i37($this$async, $completion);
  };
  l.$arity = 1;
  return l;
}
function DEBUG_ASYNC_LAUNCH_ERRORS$factory() {
  return getPropertyCallableRef('DEBUG_ASYNC_LAUNCH_ERRORS', 0, KProperty0, function () {
    return get_DEBUG_ASYNC_LAUNCH_ERRORS();
  }, null);
}
var properties_initialized_AsyncExt_kt_7k2grr;
function _init_properties_AsyncExt_kt__ahev1h() {
  if (!properties_initialized_AsyncExt_kt_7k2grr) {
    properties_initialized_AsyncExt_kt_7k2grr = true;
    logger = Companion_getInstance_1().h36('AsyncExt');
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_SUSPEND_TEST_TIMEOUT = Companion_getInstance_2().q33(20.0);
    DEBUG_ASYNC_LAUNCH_ERRORS$delegate = lazy(DEBUG_ASYNC_LAUNCH_ERRORS$delegate$lambda);
  }
}
function AsyncThread$sync$slambda_0($oldPromise, $func, resultContinuation) {
  var i = new AsyncThread$sync$slambda($oldPromise, $func, resultContinuation);
  var l = function ($completion) {
    return i.w37($completion);
  };
  l.$arity = 0;
  return l;
}
function _Dyn___init__impl__6cuxxc(value) {
  return value;
}
function _Dyn___get_value__impl__bemnlg($this) {
  return $this;
}
function Dyn__toComparable_impl_pfql3z($this) {
  var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
  var tmp;
  if (tmp0_subject == null) {
    tmp = isComparable(0) ? 0 : THROW_CCE();
  } else {
    if (!(tmp0_subject == null) ? isComparable(tmp0_subject) : false) {
      var tmp_0 = _Dyn___get_value__impl__bemnlg($this);
      tmp = (!(tmp_0 == null) ? isComparable(tmp_0) : false) ? tmp_0 : THROW_CCE();
    } else {
      var tmp_1 = toString(_Dyn___get_value__impl__bemnlg($this));
      tmp = isComparable(tmp_1) ? tmp_1 : THROW_CCE();
    }
  }
  return tmp;
}
function Dyn__compareTo_impl_7znl52($this, other) {
  var l = $this;
  var r = other;
  var tmp;
  var tmp_0 = _Dyn___get_value__impl__bemnlg(l);
  if (isNumber(tmp_0)) {
    var tmp_1 = _Dyn___get_value__impl__bemnlg(r);
    tmp = isNumber(tmp_1);
  } else {
    tmp = false;
  }
  if (tmp) {
    return compareTo(numberToDouble(_Dyn___get_value__impl__bemnlg(l)), numberToDouble(_Dyn___get_value__impl__bemnlg(r)));
  }
  var lc = Dyn__toComparable_impl_pfql3z(l);
  var rc = Dyn__toComparable_impl_pfql3z(r);
  return getKClassFromExpression(lc).o9(rc) ? compareTo(lc, rc) : -1;
}
function Dyn__compareTo_impl_7znl52_0($this, other) {
  var tmp = $this.c38_1;
  return Dyn__compareTo_impl_7znl52(tmp, other instanceof Dyn ? other.c38_1 : THROW_CCE());
}
function Dyn__toString_impl_9l0v3s($this) {
  return toString_1($this, _Dyn___get_value__impl__bemnlg($this));
}
var Companion_instance;
function Companion_getInstance_4() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function Dyn__get_impl_6l2p80($this, key) {
  return Dyn__get_impl_6l2p80_0($this, _Dyn___get_value__impl__bemnlg(key));
}
function Dyn__get_impl_6l2p80_0($this, key) {
  return _getOrThrow($this, key, false);
}
function _getOrThrow($this, key, doThrow) {
  var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
  var tmp;
  if (tmp0_subject == null) {
    var tmp_0;
    if (doThrow) {
      throw NullPointerException.yg("Trying to access '" + toString_0(key) + "'");
    } else {
      tmp_0 = get_dyn(null);
    }
    tmp = tmp_0;
  } else {
    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Map) : false) {
      var tmp_1 = _Dyn___get_value__impl__bemnlg($this);
      tmp = get_dyn(((!(tmp_1 == null) ? isInterface(tmp_1, Map) : false) ? tmp_1 : THROW_CCE()).u3(key));
    } else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, List) : false) {
        tmp = get_dyn(getOrNull(_Dyn___get_value__impl__bemnlg($this), Dyn__toInt_impl_nu3u6q(get_dyn(key))));
      } else {
        tmp = get_dyn(get_dynApi().d38(_Dyn___get_value__impl__bemnlg($this), toString_0(key)));
      }
    }
  }
  return tmp;
}
function _Dyn___get_listAny__impl__vrilgp($this) {
  var tmp;
  if (_Dyn___get_value__impl__bemnlg($this) == null) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    var tmp_0 = _Dyn___get_value__impl__bemnlg($this);
    if (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) {
      tmp = _Dyn___get_value__impl__bemnlg($this);
    } else {
      var tmp_1 = _Dyn___get_value__impl__bemnlg($this);
      if (!(tmp_1 == null) ? isInterface(tmp_1, Iterable) : false) {
        tmp = toList(_Dyn___get_value__impl__bemnlg($this));
      } else {
        tmp = listOf(_Dyn___get_value__impl__bemnlg($this));
      }
    }
  }
  return tmp;
}
function _Dyn___get_keysAny__impl__whx5cj($this) {
  var tmp;
  var tmp_0 = _Dyn___get_value__impl__bemnlg($this);
  if (!(tmp_0 == null) ? isInterface(tmp_0, Map) : false) {
    tmp = toList(_Dyn___get_value__impl__bemnlg($this).j3());
  } else {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  }
  return tmp;
}
function _Dyn___get_list__impl__qpwjp($this) {
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = _Dyn___get_listAny__impl__vrilgp($this);
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'korlibs.io.dynamic.Dyn.<get-list>.<anonymous>' call
    tmp$ret$0 = get_dyn(item);
    tmp0_mapTo.e1(new Dyn(tmp$ret$0));
  }
  return tmp0_mapTo;
}
function _Dyn___get_keys__impl__o4xmor($this) {
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = _Dyn___get_keysAny__impl__whx5cj($this);
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'korlibs.io.dynamic.Dyn.<get-keys>.<anonymous>' call
    tmp$ret$0 = get_dyn(item);
    tmp0_mapTo.e1(new Dyn(tmp$ret$0));
  }
  return tmp0_mapTo;
}
function Dyn__toNumber_impl_rlhtn4($this, $receiver) {
  var tmp = toIntOrNull($receiver);
  var tmp0_elvis_lhs = (tmp == null ? true : isNumber(tmp)) ? tmp : null;
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? toDoubleOrNull($receiver) : tmp0_elvis_lhs;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    DoubleCompanionObject_getInstance();
    tmp_0 = NaN;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  return tmp_0;
}
function Dyn__toNumber_impl_rlhtn4_0($this) {
  var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
  var tmp;
  if (tmp0_subject == null) {
    tmp = 0;
  } else {
    if (isNumber(tmp0_subject)) {
      tmp = _Dyn___get_value__impl__bemnlg($this);
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false) {
        tmp = _Dyn___get_value__impl__bemnlg($this) ? 1 : 0;
      } else {
        if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
          var tmp1_elvis_lhs = toIntSafe(_Dyn___get_value__impl__bemnlg($this));
          var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? toDoubleSafe(_Dyn___get_value__impl__bemnlg($this)) : tmp1_elvis_lhs;
          tmp = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
        } else {
          tmp = Dyn__toNumber_impl_rlhtn4($this, toString(_Dyn___get_value__impl__bemnlg($this)));
        }
      }
    }
  }
  return tmp;
}
function toString_1($this, value) {
  var tmp;
  if (value == null) {
    tmp = '';
  } else {
    if (!(value == null) ? typeof value === 'string' : false) {
      tmp = value;
    } else {
      if (!(value == null) ? typeof value === 'number' : false) {
        var tmp_0;
        if (value === numberToInt(value)) {
          tmp_0 = numberToInt(value).toString();
        } else {
          tmp_0 = toString(value);
        }
        tmp = tmp_0;
      } else {
        if (!(value == null) ? isInterface(value, Iterable) : false) {
          tmp = '[' + joinToString(value, ', ', VOID, VOID, VOID, VOID, Dyn$toString$lambda($this)) + ']';
        } else {
          if (!(value == null) ? isInterface(value, Map) : false) {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var tmp0_mapTo = ArrayList.f4(value.o());
            // Inline function 'kotlin.collections.iterator' call
            var tmp0_iterator = value.l3().u();
            while (tmp0_iterator.h1()) {
              var item = tmp0_iterator.j1();
              var tmp$ret$1;
              // Inline function 'korlibs.io.dynamic.Dyn.toString.<anonymous>' call
              tmp$ret$1 = quote(toString_1($this, item.o3())) + ': ' + toString_1($this, item.p3());
              tmp0_mapTo.e1(tmp$ret$1);
            }
            tmp = '{' + joinToString(tmp0_mapTo, ', ') + '}';
          } else {
            tmp = toString(value);
          }
        }
      }
    }
  }
  return tmp;
}
function Dyn__toInt_impl_nu3u6q($this) {
  return numberToInt(Dyn__toNumber_impl_rlhtn4_0($this));
}
function Dyn__toLong_impl_mq8zcz($this) {
  return numberToLong(Dyn__toNumber_impl_rlhtn4_0($this));
}
function Dyn__toBoolOrNull_impl_2dk92d($this) {
  var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
  var tmp;
  if (!(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false) {
    tmp = _Dyn___get_value__impl__bemnlg($this);
  } else {
    if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
      tmp = (equals(_Dyn___get_value__impl__bemnlg($this), '1') ? true : equals(_Dyn___get_value__impl__bemnlg($this), 'true')) ? true : equals(_Dyn___get_value__impl__bemnlg($this), 'on');
    } else {
      if (isNumber(tmp0_subject)) {
        tmp = !(Dyn__toInt_impl_nu3u6q($this) === 0);
      } else {
        tmp = null;
      }
    }
  }
  return tmp;
}
function Dyn__toLongOrNull_impl_ws7y8j($this) {
  var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
  var tmp;
  if (isNumber(tmp0_subject)) {
    tmp = Dyn__toLong_impl_mq8zcz($this);
  } else {
    if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
      tmp = toLongSafe(_Dyn___get_value__impl__bemnlg($this));
    } else {
      tmp = null;
    }
  }
  return tmp;
}
function Dyn__toLongDefault_impl_auunl0($this, default_0) {
  var tmp0_subject = _Dyn___get_value__impl__bemnlg($this);
  var tmp;
  if (isNumber(tmp0_subject)) {
    tmp = Dyn__toLong_impl_mq8zcz($this);
  } else {
    if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
      var tmp1_elvis_lhs = toLongSafe(_Dyn___get_value__impl__bemnlg($this), 10);
      tmp = tmp1_elvis_lhs == null ? default_0 : tmp1_elvis_lhs;
    } else {
      tmp = default_0;
    }
  }
  return tmp;
}
function Dyn__toLongDefault$default_impl_w5acm9($this, default_0, $super) {
  default_0 = default_0 === VOID ? new Long(0, 0) : default_0;
  return $super === VOID ? Dyn__toLongDefault_impl_auunl0($this, default_0) : $super.e38.call(new Dyn($this), default_0);
}
function _Dyn___get_str__impl__dup4cs($this) {
  return Dyn__toString_impl_9l0v3s($this);
}
function _Dyn___get_bool__impl__nv3iun($this) {
  var tmp0_elvis_lhs = Dyn__toBoolOrNull_impl_2dk92d($this);
  return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
}
function _Dyn___get_long__impl__wdxl7n($this) {
  return Dyn__toLongDefault$default_impl_w5acm9($this);
}
function Dyn__hashCode_impl_vc6rwn($this) {
  return $this == null ? 0 : hashCode($this);
}
function Dyn__equals_impl_sp125n($this, other) {
  if (!(other instanceof Dyn))
    return false;
  var tmp0_other_with_cast = other instanceof Dyn ? other.c38_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function Dyn$toString$lambda(this$0) {
  return function (it) {
    return toString_1(this$0, it);
  };
}
function get_dyn(_this__u8e3s4) {
  return _Dyn___init__impl__6cuxxc(_this__u8e3s4);
}
function toIntSafe(_this__u8e3s4, radix) {
  radix = radix === VOID ? 10 : radix;
  return toIntOrNull_0(_this__u8e3s4, radix);
}
function toDoubleSafe(_this__u8e3s4) {
  return toDoubleOrNull(_this__u8e3s4);
}
function toLongSafe(_this__u8e3s4, radix) {
  radix = radix === VOID ? 10 : radix;
  return toLongOrNull(_this__u8e3s4, radix);
}
function get_dynApi() {
  _init_properties_DynApi_kt__g2fyyp();
  return dynApi;
}
var dynApi;
var properties_initialized_DynApi_kt_kcoydf;
function _init_properties_DynApi_kt__g2fyyp() {
  if (!properties_initialized_DynApi_kt_kcoydf) {
    properties_initialized_DynApi_kt_kcoydf = true;
    dynApi = DynamicInternal_getInstance();
  }
}
function normalize(_this__u8e3s4) {
  var path = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var schemeIndex = indexOf(path, ':');
  var tmp;
  if (schemeIndex >= 0) {
    var tmp_0;
    var tmp$ret$1;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$1 = path.substring(schemeIndex);
    if (startsWith(tmp$ret$1, '://')) {
      tmp_0 = 3;
    } else {
      tmp_0 = 1;
    }
    var take = tmp_0;
    // Inline function 'kotlin.text.substring' call
    var tmp0_substring = schemeIndex + take | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = path.substring(0, tmp0_substring);
    var tmp$ret$5;
    // Inline function 'kotlin.text.substring' call
    var tmp1_substring = schemeIndex + take | 0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$5 = path.substring(tmp1_substring);
    tmp = tmp_1 + normalize(get_pathInfo(tmp$ret$5));
  } else {
    var path2 = replace(path, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47));
    var out = ArrayList.i4();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp2_fastForEach = split(path2, ['/']);
    var n = 0;
    while (n < tmp2_fastForEach.o()) {
      // Inline function 'korlibs.io.file.normalize.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp3_anonymous = tmp2_fastForEach.p(tmp0);
      switch (tmp3_anonymous) {
        case '':
        case '.':
          if (out.y()) {
            // Inline function 'kotlin.collections.plusAssign' call
            out.e1('');
          }

          break;
        case '..':
          // Inline function 'kotlin.collections.isNotEmpty' call

          if (!out.y()) {
            out.a2(out.o() - 1 | 0);
          }

          break;
        default:
          // Inline function 'kotlin.collections.plusAssign' call

          out.e1(tmp3_anonymous);
          break;
      }
    }
    tmp = joinToString(out, '/');
  }
  return tmp;
}
function _PathInfo___init__impl__vpw96a(fullPath) {
  return fullPath;
}
function _PathInfo___get_fullPath__impl__21fx6x($this) {
  return $this;
}
function get_pathInfo(_this__u8e3s4) {
  return _PathInfo___init__impl__vpw96a(_this__u8e3s4);
}
function combine(_this__u8e3s4, access) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var access_0 = _PathInfo___get_fullPath__impl__21fx6x(access);
  return get_pathInfo(isAbsolute(get_pathInfo(access_0)) ? normalize(get_pathInfo(access_0)) : normalize(get_pathInfo(base + '/' + access_0)));
}
function get_baseName(_this__u8e3s4) {
  return get_baseName_0(_this__u8e3s4.h38());
}
function lightCombine(_this__u8e3s4, access) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var access_0 = _PathInfo___get_fullPath__impl__21fx6x(access);
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(base) > 0) {
    tmp = trimEnd(base, charArrayOf([_Char___init__impl__6a9atx(47)])) + '/' + trim(access_0, charArrayOf([_Char___init__impl__6a9atx(47)]));
  } else {
    tmp = access_0;
  }
  var res = tmp;
  return get_pathInfo(res);
}
function get_parent(_this__u8e3s4) {
  return _PathInfo___init__impl__vpw96a(get_folder(_this__u8e3s4));
}
function get_folder(_this__u8e3s4) {
  // Inline function 'kotlin.text.substring' call
  var tmp0_substring = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var tmp0_elvis_lhs = lastIndexOfOrNull(get_fullPathNormalized(_this__u8e3s4), _Char___init__impl__6a9atx(47));
  var tmp1_substring = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  // Inline function 'kotlin.js.asDynamic' call
  return tmp0_substring.substring(0, tmp1_substring);
}
function isAbsolute(_this__u8e3s4) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(base) === 0)
    return false;
  var b = substringBefore(replace(base, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(47));
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(b) === 0)
    return true;
  if (contains(b, _Char___init__impl__6a9atx(58)))
    return true;
  return false;
}
function get_baseName_0(_this__u8e3s4) {
  return substringAfterLast(get_fullPathNormalized(_this__u8e3s4), _Char___init__impl__6a9atx(47));
}
function get_fullPathNormalized(_this__u8e3s4) {
  return replace(_PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4), _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47));
}
function Vfs$Proxy$initOnce$slambda_0(this$0, resultContinuation) {
  var i = new Vfs$Proxy$initOnce$slambda(this$0, resultContinuation);
  var l = function ($completion) {
    return i.r38($completion);
  };
  l.$arity = 0;
  return l;
}
function unsupported($this) {
  unsupported_0('unsupported for ' + getKClassFromExpression($this) + ' : ' + $this);
}
var VfsOpenMode_READ_instance;
var VfsOpenMode_WRITE_instance;
var VfsOpenMode_APPEND_instance;
var VfsOpenMode_CREATE_OR_TRUNCATE_instance;
var VfsOpenMode_CREATE_instance;
var VfsOpenMode_CREATE_NEW_instance;
var VfsOpenMode_entriesInitialized;
function VfsOpenMode_initEntries() {
  if (VfsOpenMode_entriesInitialized)
    return Unit_getInstance();
  VfsOpenMode_entriesInitialized = true;
  VfsOpenMode_READ_instance = new VfsOpenMode('READ', 0, 'rb', false);
  VfsOpenMode_WRITE_instance = new VfsOpenMode('WRITE', 1, 'r+b', true, true);
  VfsOpenMode_APPEND_instance = new VfsOpenMode('APPEND', 2, 'a+b', true, true);
  VfsOpenMode_CREATE_OR_TRUNCATE_instance = new VfsOpenMode('CREATE_OR_TRUNCATE', 3, 'w+b', true, true, true);
  VfsOpenMode_CREATE_instance = new VfsOpenMode('CREATE', 4, 'w+b', true, true);
  VfsOpenMode_CREATE_NEW_instance = new VfsOpenMode('CREATE_NEW', 5, 'w+b', true);
}
var Companion_instance_0;
function Companion_getInstance_5() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function VfsOpenMode_READ_getInstance() {
  VfsOpenMode_initEntries();
  return VfsOpenMode_READ_instance;
}
function withCatalogJail(_this__u8e3s4) {
  return (new CatalogVfs(_this__u8e3s4.f3e())).e2f();
}
function CatalogVfs$open$slambda_0(this$0, $path, $mode, resultContinuation) {
  var i = new CatalogVfs$open$slambda(this$0, $path, $mode, resultContinuation);
  var l = function ($this$withContext, $completion) {
    return i.g3f($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_1;
function Companion_getInstance_6() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
var resourcesVfsDebug;
var Companion_instance_2;
function Companion_getInstance_7() {
  if (Companion_instance_2 === VOID)
    new Companion_2();
  return Companion_instance_2;
}
function UrlVfs_0(url, client, failFromStatus) {
  client = client === VOID ? createHttpClient() : client;
  failFromStatus = failFromStatus === VOID ? true : failFromStatus;
  return (new UrlVfs(url.u3i(VOID, VOID, VOID, VOID, '', null).v3i(), Unit_getInstance(), client, failFromStatus)).fc(url.n3i_1);
}
function _readRangeBase($this, fullUrl, range, $completion) {
  var tmp = new $_readRangeBaseCOROUTINE$109($this, fullUrl, range, $completion);
  tmp.pf_1 = Unit_getInstance();
  tmp.qf_1 = null;
  return tmp.ag();
}
function UrlVfs_1(url, client, failFromStatus) {
  client = client === VOID ? createHttpClient() : client;
  failFromStatus = failFromStatus === VOID ? true : failFromStatus;
  return UrlVfs_0(Companion_getInstance_10().h36(url), client, failFromStatus);
}
var CHARSET_PROVIDERS;
var CHARSET_PROVIDERS_LOCK;
var LATIN1;
var UTF16_LE;
var UTF16_BE;
var ISO_8859_1_instance;
function ISO_8859_1_getInstance() {
  if (ISO_8859_1_instance === VOID)
    new ISO_8859_1();
  return ISO_8859_1_instance;
}
var Companion_instance_3;
function Companion_getInstance_8() {
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function toString_2(_this__u8e3s4, charset, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.length : end;
  _init_properties_Charset_kt__c47y1m();
  var out = StringBuilder.f8(charset.t3n(end - start | 0));
  charset.r3n(out, _this__u8e3s4, start, end);
  return out.toString();
}
var properties_initialized_Charset_kt_dajgec;
function _init_properties_Charset_kt__c47y1m() {
  if (!properties_initialized_Charset_kt_dajgec) {
    properties_initialized_Charset_kt_dajgec = true;
    // Inline function 'kotlin.collections.arrayListOf' call
    CHARSET_PROVIDERS = ArrayList.i4();
    CHARSET_PROVIDERS_LOCK = new NonRecursiveLock();
    LATIN1 = ISO_8859_1_getInstance();
    UTF16_LE = new UTF16Charset(true);
    UTF16_BE = new UTF16Charset(false);
  }
}
var customEnvironments;
var Companion_instance_4;
function Companion_getInstance_9() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function unsupported_0(msg) {
  msg = msg === VOID ? 'unsupported' : msg;
  throw UnsupportedOperationException.j6(msg);
}
function invalidOp(msg) {
  throw InvalidOperationException.e3o(msg);
}
var formatRegex;
var replaceNonPrintableCharactersRegex$delegate;
function substr(_this__u8e3s4, start, length) {
  _init_properties_StringExt_kt__eg42u6();
  var low = clamp(start >= 0 ? start : _this__u8e3s4.length + start | 0, 0, _this__u8e3s4.length);
  var high = clamp(length >= 0 ? low + length | 0 : _this__u8e3s4.length + length | 0, 0, _this__u8e3s4.length);
  var tmp;
  if (high >= low) {
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = _this__u8e3s4.substring(low, high);
  } else {
    tmp = '';
  }
  return tmp;
}
function substringEquals(_this__u8e3s4, a, aIndex, b, bIndex, count) {
  _init_properties_StringExt_kt__eg42u6();
  if (count === 0)
    return true;
  if (aIndex < 0 ? true : bIndex < 0)
    return false;
  if ((aIndex + count | 0) > a.length)
    return false;
  if ((bIndex + count | 0) > b.length)
    return false;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(charSequenceGet(a, aIndex + n | 0) === charSequenceGet(b, bIndex + n | 0)))
        return false;
    }
     while (inductionVariable < count);
  return true;
}
function String_fromCharArray(arrays, offset, size) {
  offset = offset === VOID ? 0 : offset;
  size = size === VOID ? arrays.length - offset | 0 : size;
  _init_properties_StringExt_kt__eg42u6();
  return concatToString(arrays, offset, offset + size | 0);
}
function lastIndexOfOrNull(_this__u8e3s4, char, startIndex) {
  startIndex = startIndex === VOID ? get_lastIndex(_this__u8e3s4) : startIndex;
  _init_properties_StringExt_kt__eg42u6();
  // Inline function 'kotlin.takeIf' call
  var tmp0_takeIf = lastIndexOf(_this__u8e3s4, char, startIndex);
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  // Inline function 'korlibs.io.lang.lastIndexOfOrNull.<anonymous>' call
  if (tmp0_takeIf >= 0) {
    tmp = tmp0_takeIf;
  } else {
    tmp = null;
  }
  return tmp;
}
function replaceNonPrintableCharactersRegex$delegate$lambda() {
  _init_properties_StringExt_kt__eg42u6();
  return Regex.hb('[^ -~]');
}
var properties_initialized_StringExt_kt_sd962o;
function _init_properties_StringExt_kt__eg42u6() {
  if (!properties_initialized_StringExt_kt_sd962o) {
    properties_initialized_StringExt_kt_sd962o = true;
    formatRegex = Regex.hb('%([-]?\\d+)?(\\w)');
    replaceNonPrintableCharactersRegex$delegate = lazy(replaceNonPrintableCharactersRegex$delegate$lambda);
  }
}
var QueryString_instance;
function QueryString_getInstance() {
  if (QueryString_instance === VOID)
    new QueryString();
  return QueryString_instance;
}
var Companion_instance_5;
function Companion_getInstance_10() {
  if (Companion_instance_5 === VOID)
    new Companion_5();
  return Companion_instance_5;
}
function URL$fullUrl$delegate$lambda(this$0) {
  return function () {
    return this$0.b3p().toString();
  };
}
function URL$fullUrlWithoutScheme$delegate$lambda(this$0) {
  return function () {
    return this$0.b3p(false).toString();
  };
}
function URL$pathWithQuery$delegate$lambda(this$0) {
  return function () {
    var tmp;
    if (!(this$0.o3i_1 == null)) {
      tmp = this$0.n3i_1 + '?' + this$0.o3i_1;
    } else {
      tmp = this$0.n3i_1;
    }
    return tmp;
  };
}
function fullUrl$factory() {
  return getPropertyCallableRef('fullUrl', 1, KProperty1, function (receiver) {
    return receiver.v3i();
  }, null);
}
var Methods_ALL_instance;
var Methods_OPTIONS_instance;
var Methods_GET_instance;
var Methods_HEAD_instance;
var Methods_POST_instance;
var Methods_PUT_instance;
var Methods_DELETE_instance;
var Methods_TRACE_instance;
var Methods_CONNECT_instance;
var Methods_PATCH_instance;
var Methods_entriesInitialized;
function Methods_initEntries() {
  if (Methods_entriesInitialized)
    return Unit_getInstance();
  Methods_entriesInitialized = true;
  Methods_ALL_instance = new Methods('ALL', 0);
  Methods_OPTIONS_instance = new Methods('OPTIONS', 1);
  Methods_GET_instance = new Methods('GET', 2);
  Methods_HEAD_instance = new Methods('HEAD', 3);
  Methods_POST_instance = new Methods('POST', 4);
  Methods_PUT_instance = new Methods('PUT', 5);
  Methods_DELETE_instance = new Methods('DELETE', 6);
  Methods_TRACE_instance = new Methods('TRACE', 7);
  Methods_CONNECT_instance = new Methods('CONNECT', 8);
  Methods_PATCH_instance = new Methods('PATCH', 9);
}
var Companion_instance_6;
function Companion_getInstance_11() {
  if (Companion_instance_6 === VOID)
    new Companion_6();
  return Companion_instance_6;
}
var Companion_instance_7;
function Companion_getInstance_12() {
  if (Companion_instance_7 === VOID)
    new Companion_7();
  return Companion_instance_7;
}
var Companion_instance_8;
function Companion_getInstance_13() {
  if (Companion_instance_8 === VOID)
    new Companion_8();
  return Companion_instance_8;
}
function Http$Headers$toListGrouped$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
  // Inline function 'kotlin.text.toLowerCase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = a.ri_1.toLowerCase();
  var tmp$ret$5;
  // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
  // Inline function 'kotlin.text.toLowerCase' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp$ret$5 = b.ri_1.toLowerCase();
  return compareValues(tmp, tmp$ret$5);
}
function Methods_OPTIONS_getInstance() {
  Methods_initEntries();
  return Methods_OPTIONS_instance;
}
function Methods_GET_getInstance() {
  Methods_initEntries();
  return Methods_GET_instance;
}
function Methods_HEAD_getInstance() {
  Methods_initEntries();
  return Methods_HEAD_instance;
}
function Methods_POST_getInstance() {
  Methods_initEntries();
  return Methods_POST_instance;
}
function Methods_PUT_getInstance() {
  Methods_initEntries();
  return Methods_PUT_instance;
}
function Methods_DELETE_getInstance() {
  Methods_initEntries();
  return Methods_DELETE_instance;
}
function Methods_TRACE_getInstance() {
  Methods_initEntries();
  return Methods_TRACE_instance;
}
function Methods_CONNECT_getInstance() {
  Methods_initEntries();
  return Methods_CONNECT_instance;
}
function Methods_PATCH_getInstance() {
  Methods_initEntries();
  return Methods_PATCH_instance;
}
function get__defaultHttpFactory() {
  _init_properties_HttpClient_kt__huy6s3();
  // Inline function 'kotlin.getValue' call
  _defaultHttpFactory$factory();
  return _defaultHttpFactory$delegate.p3();
}
var _defaultHttpFactory$delegate;
var Companion_instance_9;
function Companion_getInstance_14() {
  if (Companion_instance_9 === VOID)
    new Companion_9();
  return Companion_instance_9;
}
function HttpClient$Response$responseCharset$delegate$lambda() {
  return get_UTF8();
}
var Companion_instance_10;
function Companion_getInstance_15() {
  if (Companion_instance_10 === VOID)
    new Companion_10();
  return Companion_instance_10;
}
function mergeUrls($this, base, append) {
  return Companion_getInstance_10().a3p(base, append);
}
var Companion_instance_11;
function Companion_getInstance_16() {
  if (Companion_instance_11 === VOID)
    new Companion_11();
  return Companion_instance_11;
}
function createHttpClient() {
  _init_properties_HttpClient_kt__huy6s3();
  return get_defaultHttpFactory().a3u();
}
var HttpStatusMessage_instance;
function HttpStatusMessage_getInstance() {
  if (HttpStatusMessage_instance === VOID)
    new HttpStatusMessage();
  return HttpStatusMessage_instance;
}
function get_defaultHttpFactory() {
  _init_properties_HttpClient_kt__huy6s3();
  return get__defaultHttpFactory();
}
function _defaultHttpFactory$delegate$lambda() {
  _init_properties_HttpClient_kt__huy6s3();
  return new ProxiedHttpFactory(get_httpFactory());
}
function _defaultHttpFactory$factory() {
  return getPropertyCallableRef('_defaultHttpFactory', 0, KProperty0, function () {
    return get__defaultHttpFactory();
  }, null);
}
function responseCharset$factory() {
  return getPropertyCallableRef('responseCharset', 1, KProperty1, function (receiver) {
    return receiver.e3r();
  }, null);
}
var properties_initialized_HttpClient_kt_t7kzvv;
function _init_properties_HttpClient_kt__huy6s3() {
  if (!properties_initialized_HttpClient_kt_t7kzvv) {
    properties_initialized_HttpClient_kt_t7kzvv = true;
    _defaultHttpFactory$delegate = lazy(_defaultHttpFactory$delegate$lambda);
  }
}
var Companion_instance_12;
function Companion_getInstance_17() {
  if (Companion_instance_12 === VOID)
    new Companion_12();
  return Companion_instance_12;
}
function parseBooleanOrNull($this, s, context) {
  var tmp;
  if (s.i3u('true')) {
    tmp = true;
  } else if (s.i3u('false')) {
    tmp = false;
  } else if (s.i3u('null')) {
    tmp = null;
  } else {
    invalidJson$default($this);
  }
  return tmp;
}
function parseObject($this, s, context) {
  s.j3u(_Char___init__impl__6a9atx(123));
  // Inline function 'kotlin.apply' call
  var tmp0_apply = LinkedHashMap.n8();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.serialization.json.Json.parseObject.<anonymous>' call
  obj: while (true) {
    var tmp0_subject = s.k3u().l3u();
    if (tmp0_subject === _Char___init__impl__6a9atx(125))
      break obj;
    else if (tmp0_subject === _Char___init__impl__6a9atx(44))
      continue obj;
    else {
      s.m3u();
    }
    var tmp = Json_getInstance().n3u(s, context);
    var key = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
    s.k3u().j3u(_Char___init__impl__6a9atx(58));
    var value = Json_getInstance().n3u(s, context);
    // Inline function 'kotlin.collections.set' call
    tmp0_apply.m3(key, value);
  }
  return tmp0_apply;
}
function parseArray($this, s, context) {
  var out = null;
  var outNumber = null;
  s.j3u(_Char___init__impl__6a9atx(91));
  array: while (true) {
    var tmp0_subject = s.k3u().l3u();
    if (tmp0_subject === _Char___init__impl__6a9atx(93))
      break array;
    else if (tmp0_subject === _Char___init__impl__6a9atx(44))
      continue array;
    else {
      s.m3u();
    }
    var v = s.o3u();
    if ((out == null ? context.f3u_1 : false) ? (_Char___init__impl__6a9atx(48) <= v ? v <= _Char___init__impl__6a9atx(57) : false) ? true : v === _Char___init__impl__6a9atx(45) : false) {
      if (outNumber == null) {
        outNumber = new DoubleArrayList();
      }
      outNumber.t33(parseNumber($this, s));
    } else {
      if (out == null)
        out = context.h3u();
      if (!(outNumber == null)) {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var tmp0_fastForEach = outNumber;
        var n = 0;
        while (n < tmp0_fastForEach.o()) {
          // Inline function 'korlibs.io.serialization.json.Json.parseArray.<anonymous>' call
          var tmp0 = n;
          n = tmp0 + 1 | 0;
          var tmp1_anonymous = tmp0_fastForEach.u33(tmp0);
          out.e1(tmp1_anonymous);
        }
        outNumber = null;
      }
      out.e1($this.n3u(s, context));
    }
  }
  var tmp1_elvis_lhs = outNumber;
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? out : tmp1_elvis_lhs;
  return tmp2_elvis_lhs == null ? context.h3u() : tmp2_elvis_lhs;
}
function parseNumber($this, s) {
  var start = s.t3o_1;
  // Inline function 'korlibs.io.util.BaseStrReader.skipWhile' call
  $l$loop: while (true) {
    var tmp;
    if (s.p3u()) {
      // Inline function 'korlibs.io.serialization.json.Json.parseNumber.<anonymous>' call
      var tmp0_anonymous = s.o3u();
      tmp = (((((Char__compareTo_impl_ypi4mb(tmp0_anonymous, _Char___init__impl__6a9atx(48)) >= 0 ? Char__compareTo_impl_ypi4mb(tmp0_anonymous, _Char___init__impl__6a9atx(57)) <= 0 : false) ? true : tmp0_anonymous === _Char___init__impl__6a9atx(46)) ? true : tmp0_anonymous === _Char___init__impl__6a9atx(101)) ? true : tmp0_anonymous === _Char___init__impl__6a9atx(69)) ? true : tmp0_anonymous === _Char___init__impl__6a9atx(45)) ? true : tmp0_anonymous === _Char___init__impl__6a9atx(43);
    } else {
      tmp = false;
    }
    if (!tmp) {
      break $l$loop;
    }
    s.q3u();
  }
  var end = s.t3o_1;
  return NumberParser_getInstance().r3u(s.r3o_1, start, end);
}
function invalidJson($this, msg) {
  throw IOException.l3o(msg);
}
function invalidJson$default($this, msg, $super) {
  msg = msg === VOID ? 'Invalid JSON' : msg;
  return invalidJson($this, msg);
}
var Json_instance;
function Json_getInstance() {
  if (Json_instance === VOID)
    new Json();
  return Json_instance;
}
var EMPTY_BYTE_ARRAY;
function readInternal($this, buffer, offset, len, $completion) {
  var tmp = new $readInternalCOROUTINE$149($this, buffer, offset, len, $completion);
  tmp.pf_1 = Unit_getInstance();
  tmp.qf_1 = null;
  return tmp.ag();
}
function AsyncStream$read$slambda_0(this$0, $buffer, $offset, $len, resultContinuation) {
  var i = new AsyncStream$read$slambda(this$0, $buffer, $offset, $len, resultContinuation);
  var l = function ($completion) {
    return i.s3v($completion);
  };
  l.$arity = 0;
  return l;
}
function buffered(_this__u8e3s4, blockSize, blocksToRead) {
  blockSize = blockSize === VOID ? 2048 : blockSize;
  blocksToRead = blocksToRead === VOID ? 16 : blocksToRead;
  _init_properties_AsyncStream_kt__y7xune();
  return toAsyncStream(new BufferedStreamBase(_this__u8e3s4.r3c_1, blockSize, blocksToRead), _this__u8e3s4.s3c_1);
}
function toAsyncStream(_this__u8e3s4, position) {
  position = position === VOID ? new Long(0, 0) : position;
  _init_properties_AsyncStream_kt__y7xune();
  return new AsyncStream(_this__u8e3s4, position);
}
function readAll(_this__u8e3s4, $completion) {
  var tmp = new $readAllCOROUTINE$154(_this__u8e3s4, $completion);
  tmp.pf_1 = Unit_getInstance();
  tmp.qf_1 = null;
  return tmp.ag();
}
function readBytesExact(_this__u8e3s4, len, $completion) {
  var tmp = new $readBytesExactCOROUTINE$157(_this__u8e3s4, len, $completion);
  tmp.pf_1 = Unit_getInstance();
  tmp.qf_1 = null;
  return tmp.ag();
}
function readExact(_this__u8e3s4, buffer, offset, len, $completion) {
  var tmp = new $readExactCOROUTINE$163(_this__u8e3s4, buffer, offset, len, $completion);
  tmp.pf_1 = Unit_getInstance();
  tmp.qf_1 = null;
  return tmp.ag();
}
function readBytes(_this__u8e3s4, position, count, $completion) {
  var tmp = new $readBytesCOROUTINE$167(_this__u8e3s4, position, count, $completion);
  tmp.pf_1 = Unit_getInstance();
  tmp.qf_1 = null;
  return tmp.ag();
}
function readBytesUpTo(_this__u8e3s4, len, $completion) {
  var tmp = new $readBytesUpToCOROUTINE$169(_this__u8e3s4, len, $completion);
  tmp.pf_1 = Unit_getInstance();
  tmp.qf_1 = null;
  return tmp.ag();
}
function readBytesUpToCopy(_this__u8e3s4, out, $completion) {
  var tmp = new $readBytesUpToCopyCOROUTINE$174(_this__u8e3s4, out, $completion);
  tmp.pf_1 = Unit_getInstance();
  tmp.qf_1 = null;
  return tmp.ag();
}
function getAvailable(_this__u8e3s4, $completion) {
  var tmp = new $getAvailableCOROUTINE$175(_this__u8e3s4, $completion);
  tmp.pf_1 = Unit_getInstance();
  tmp.qf_1 = null;
  return tmp.ag();
}
function readBytesUpTo_0(_this__u8e3s4, out, offset, len, $completion) {
  var tmp = new $readBytesUpToCOROUTINE$176(_this__u8e3s4, out, offset, len, $completion);
  tmp.pf_1 = Unit_getInstance();
  tmp.qf_1 = null;
  return tmp.ag();
}
var properties_initialized_AsyncStream_kt_gaoyh8;
function _init_properties_AsyncStream_kt__y7xune() {
  if (!properties_initialized_AsyncStream_kt_gaoyh8) {
    properties_initialized_AsyncStream_kt_gaoyh8 = true;
    EMPTY_BYTE_ARRAY = new Int8Array(0);
  }
}
function openAsync(_this__u8e3s4, mode) {
  mode = mode === VOID ? 'r' : mode;
  return toAsyncStream(new MemoryAsyncStreamBase(new ByteArrayBuilder(_this__u8e3s4, VOID, true)), new Long(0, 0));
}
function isWhitespaceFast(_this__u8e3s4) {
  return ((_this__u8e3s4 === _Char___init__impl__6a9atx(32) ? true : _this__u8e3s4 === _Char___init__impl__6a9atx(9)) ? true : _this__u8e3s4 === _Char___init__impl__6a9atx(13)) ? true : _this__u8e3s4 === _Char___init__impl__6a9atx(10);
}
var MINUS_ZERO_D;
var NumberParser_instance;
function NumberParser_getInstance() {
  if (NumberParser_instance === VOID)
    new NumberParser();
  return NumberParser_instance;
}
function ctypeAsInt(_this__u8e3s4) {
  return (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(48)) >= 0 ? Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(57)) <= 0 : false) ? Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(48)) : (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(97)) >= 0 ? Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(122)) <= 0 : false) ? Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(97)) + 10 | 0 : (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(65)) >= 0 ? Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(90)) <= 0 : false) ? Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(65)) + 10 | 0 : -1;
}
function get_LONG_ZERO_TO_MAX_RANGE() {
  _init_properties_RangeExt_kt__vz0y4k();
  return LONG_ZERO_TO_MAX_RANGE;
}
var LONG_ZERO_TO_MAX_RANGE;
var properties_initialized_RangeExt_kt_dqkq5i;
function _init_properties_RangeExt_kt__vz0y4k() {
  if (!properties_initialized_RangeExt_kt_dqkq5i) {
    properties_initialized_RangeExt_kt_dqkq5i = true;
    var tmp = new Long(0, 0);
    Companion_getInstance();
    LONG_ZERO_TO_MAX_RANGE = tmp.jd(new Long(-1, 2147483647));
  }
}
var Companion_instance_13;
function Companion_getInstance_18() {
  if (Companion_instance_13 === VOID)
    new Companion_13();
  return Companion_instance_13;
}
function posSkip($this, count) {
  var out = $this.t3o_1;
  $this.t3o_1 = $this.t3o_1 + count | 0;
  return out;
}
function substr_0($this, pos, length) {
  // Inline function 'kotlin.text.substring' call
  var tmp3_substring = $this.r3o_1;
  // Inline function 'kotlin.math.min' call
  var tmp0_min = $this.v3o_1;
  var tmp4_substring = Math.min(pos, tmp0_min);
  // Inline function 'kotlin.math.min' call
  var tmp1_min = pos + length | 0;
  var tmp2_min = $this.v3o_1;
  var tmp5_substring = Math.min(tmp1_min, tmp2_min);
  // Inline function 'kotlin.js.asDynamic' call
  return tmp3_substring.substring(tmp4_substring, tmp5_substring);
}
function quote(_this__u8e3s4) {
  return !(_this__u8e3s4 == null) ? '"' + escape(_this__u8e3s4) + '"' : 'null';
}
function escape(_this__u8e3s4) {
  var out = StringBuilder.qa();
  var inductionVariable = 0;
  var last = _this__u8e3s4.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = charSequenceGet(_this__u8e3s4, n);
      if (c === _Char___init__impl__6a9atx(92)) {
        out.a8('\\\\');
      } else if (c === _Char___init__impl__6a9atx(34)) {
        out.a8('\\"');
      } else if (c === _Char___init__impl__6a9atx(10)) {
        out.a8('\\n');
      } else if (c === _Char___init__impl__6a9atx(13)) {
        out.a8('\\r');
      } else if (c === _Char___init__impl__6a9atx(9)) {
        out.a8('\\t');
      } else if (_Char___init__impl__6a9atx(0) <= c ? c <= _Char___init__impl__6a9atx(31) : false) {
        out.a8('\\x');
        out.b8(Hex_getInstance().g35(extract(Char__toInt_impl_vasixd(c), 4, 4)));
        out.b8(Hex_getInstance().g35(extract(Char__toInt_impl_vasixd(c), 0, 4)));
      } else {
        out.b8(c);
      }
    }
     while (inductionVariable < last);
  return out.toString();
}
function substringAfterOrNull(_this__u8e3s4, delimiter) {
  return contains(_this__u8e3s4, delimiter) ? substringAfter(_this__u8e3s4, delimiter) : null;
}
function substringBeforeOrNull(_this__u8e3s4, delimiter) {
  return contains(_this__u8e3s4, delimiter) ? substringBefore(_this__u8e3s4, delimiter) : null;
}
function get_jsGlobalDynamic() {
  _init_properties_KorioNativeJs_kt__151su();
  return jsGlobalDynamic;
}
var jsGlobalDynamic;
function get_jsGlobal() {
  _init_properties_KorioNativeJs_kt__151su();
  return jsGlobal;
}
var jsGlobal;
function get_isDenoJs() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.getValue' call
  isDenoJs$factory();
  return isDenoJs$delegate.p3();
}
var isDenoJs$delegate;
function get_isWeb() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.getValue' call
  isWeb$factory();
  return isWeb$delegate.p3();
}
var isWeb$delegate;
function get_isWorker() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.getValue' call
  isWorker$factory();
  return isWorker$delegate.p3();
}
var isWorker$delegate;
function get_isNodeJs() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.getValue' call
  isNodeJs$factory();
  return isNodeJs$delegate.p3();
}
var isNodeJs$delegate;
function get_jsRuntime() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.getValue' call
  jsRuntime$factory();
  return jsRuntime$delegate.p3();
}
var jsRuntime$delegate;
function get_isShell() {
  _init_properties_KorioNativeJs_kt__151su();
  return (!get_isWeb() ? !get_isNodeJs() : false) ? !get_isWorker() : false;
}
function jsObjectToMap(obj) {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.collections.associate' call
  var tmp0_associate = jsObjectKeysArray(obj);
  var capacity = coerceAtLeast(mapCapacity(tmp0_associate.length), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var tmp0_associateTo = LinkedHashMap.o8(capacity);
  var inductionVariable = 0;
  var last = tmp0_associate.length;
  while (inductionVariable < last) {
    var element = tmp0_associate[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    // Inline function 'korlibs.io.jsObjectToMap.<anonymous>' call
    var tmp0_plusAssign = to(element, obj[element]);
    tmp0_associateTo.m3(tmp0_plusAssign.ri_1, tmp0_plusAssign.si_1);
  }
  return tmp0_associateTo;
}
function jsEmptyObj() {
  _init_properties_KorioNativeJs_kt__151su();
  return {};
}
function jsEmptyArray() {
  _init_properties_KorioNativeJs_kt__151su();
  return [];
}
function jsToObjectMap(obj) {
  _init_properties_KorioNativeJs_kt__151su();
  if (obj == null)
    return null;
  // Inline function 'kotlin.collections.linkedMapOf' call
  var out = LinkedHashMap.n8();
  var keys = jsObjectKeys(obj);
  var inductionVariable = 0;
  var last = keys.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var key = keys[n];
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = '' + key;
      var tmp1_set = obj[key];
      out.m3(tmp0_set, tmp1_set);
    }
     while (inductionVariable < last);
  return out;
}
function jsToArray(obj) {
  _init_properties_KorioNativeJs_kt__151su();
  var tmp = 0;
  var tmp_0 = obj.length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_1 = fillArrayVal(Array(tmp_0), null);
  while (tmp < tmp_0) {
    var tmp_2 = tmp;
    tmp_1[tmp_2] = obj[tmp_2];
    tmp = tmp + 1 | 0;
  }
  return tmp_1;
}
function jsObjectKeysArray(obj) {
  _init_properties_KorioNativeJs_kt__151su();
  var tmp = jsToArray(jsObjectKeys(obj));
  return isArray(tmp) ? tmp : THROW_CCE();
}
function jsObjectKeys(obj) {
  _init_properties_KorioNativeJs_kt__151su();
  return Object.keys(obj);
}
function isDenoJs$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof Deno === 'object' && Deno.statSync;
}
function isWeb$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof window === 'object';
}
function isWorker$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof importScripts === 'function';
}
function isNodeJs$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof process !== 'undefined' && process.release && process.release.name.search(/node|io.js/) !== -1;
}
function jsRuntime$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  return get_isDenoJs() ? JsRuntimeDeno_getInstance() : get_isNodeJs() ? JsRuntimeNode_getInstance() : JsRuntimeBrowser_getInstance();
}
function isDenoJs$factory() {
  return getPropertyCallableRef('isDenoJs', 0, KProperty0, function () {
    return get_isDenoJs();
  }, null);
}
function isWeb$factory() {
  return getPropertyCallableRef('isWeb', 0, KProperty0, function () {
    return get_isWeb();
  }, null);
}
function isWorker$factory() {
  return getPropertyCallableRef('isWorker', 0, KProperty0, function () {
    return get_isWorker();
  }, null);
}
function isNodeJs$factory() {
  return getPropertyCallableRef('isNodeJs', 0, KProperty0, function () {
    return get_isNodeJs();
  }, null);
}
function jsRuntime$factory() {
  return getPropertyCallableRef('jsRuntime', 0, KProperty0, function () {
    return get_jsRuntime();
  }, null);
}
var properties_initialized_KorioNativeJs_kt_y4p8os;
function _init_properties_KorioNativeJs_kt__151su() {
  if (!properties_initialized_KorioNativeJs_kt_y4p8os) {
    properties_initialized_KorioNativeJs_kt_y4p8os = true;
    jsGlobalDynamic = typeof globalThis !== 'undefined' ? globalThis : typeof global !== 'undefined' ? global : self;
    jsGlobal = get_jsGlobalDynamic();
    isDenoJs$delegate = lazy(isDenoJs$delegate$lambda);
    isWeb$delegate = lazy(isWeb$delegate$lambda);
    isWorker$delegate = lazy(isWorker$delegate$lambda);
    isNodeJs$delegate = lazy(isNodeJs$delegate$lambda);
    jsRuntime$delegate = lazy(jsRuntime$delegate$lambda);
  }
}
var DynamicInternal_instance;
function DynamicInternal_getInstance() {
  if (DynamicInternal_instance === VOID)
    new DynamicInternal();
  return DynamicInternal_instance;
}
var File_separatorChar;
var standardVfs;
function get_applicationVfs() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  // Inline function 'kotlin.getValue' call
  applicationVfs$factory();
  return applicationVfs$delegate.p3();
}
var applicationVfs$delegate;
var applicationDataVfsOrNull;
var cacheVfsOrNull;
var externalStorageVfs$delegate;
var userHomeVfs$delegate;
var tempVfsOrNull;
function localVfs(path, async) {
  async = async === VOID ? true : async;
  _init_properties_LocalVfsJs_kt__kywvdr();
  return get_jsRuntime().g43(path);
}
function standardVfs$o$resourcesVfs$delegate$lambda() {
  return get_applicationVfs().f3e();
}
function standardVfs$o$rootLocalVfs$delegate$lambda() {
  return localVfs('.');
}
function applicationVfs$delegate$lambda() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return localVfs('.');
}
function externalStorageVfs$delegate$lambda() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return localVfs('.');
}
function userHomeVfs$delegate$lambda() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return localVfs('.');
}
function applicationVfs$factory() {
  return getPropertyCallableRef('applicationVfs', 0, KProperty0, function () {
    return get_applicationVfs();
  }, null);
}
var properties_initialized_LocalVfsJs_kt_51m659;
function _init_properties_LocalVfsJs_kt__kywvdr() {
  if (!properties_initialized_LocalVfsJs_kt_51m659) {
    properties_initialized_LocalVfsJs_kt_51m659 = true;
    standardVfs = new standardVfs$1();
    applicationVfs$delegate = lazy(applicationVfs$delegate$lambda);
    applicationDataVfsOrNull = null;
    cacheVfsOrNull = null;
    externalStorageVfs$delegate = lazy(externalStorageVfs$delegate$lambda);
    userHomeVfs$delegate = lazy(userHomeVfs$delegate$lambda);
    tempVfsOrNull = null;
  }
}
function get_portableSimpleName(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4.n9();
  return tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs;
}
var EnvironmentInternal_instance;
function EnvironmentInternal_getInstance() {
  if (EnvironmentInternal_instance === VOID)
    new EnvironmentInternal();
  return EnvironmentInternal_instance;
}
function get_UTF8() {
  _init_properties_UTF8_kt__b4hq3z();
  return UTF8;
}
var UTF8;
var JS_UTF8;
var properties_initialized_UTF8_kt_emb36b;
function _init_properties_UTF8_kt__b4hq3z() {
  if (!properties_initialized_UTF8_kt_emb36b) {
    properties_initialized_UTF8_kt_emb36b = true;
    UTF8 = new UTC8CharsetBase('UTF-8');
    JS_UTF8 = new JS_UTF8$1();
  }
}
function get_httpFactory() {
  _init_properties_HttpFactoryJs_kt__a3ro2v();
  // Inline function 'kotlin.getValue' call
  httpFactory$factory();
  return httpFactory$delegate.p3();
}
var httpFactory$delegate;
function httpFactory$delegate$lambda() {
  _init_properties_HttpFactoryJs_kt__a3ro2v();
  return new httpFactory$2$1();
}
function httpFactory$factory() {
  return getPropertyCallableRef('httpFactory', 0, KProperty0, function () {
    return get_httpFactory();
  }, null);
}
var properties_initialized_HttpFactoryJs_kt_on1x9h;
function _init_properties_HttpFactoryJs_kt__a3ro2v() {
  if (!properties_initialized_HttpFactoryJs_kt_on1x9h) {
    properties_initialized_HttpFactoryJs_kt_on1x9h = true;
    httpFactory$delegate = lazy(httpFactory$delegate$lambda);
  }
}
var Companion_instance_14;
function Companion_getInstance_19() {
  if (Companion_instance_14 === VOID)
    new Companion_14();
  return Companion_instance_14;
}
function _get__envs__kxwcr8($this) {
  // Inline function 'kotlin.getValue' call
  _envs$factory();
  return $this.e43_1.p3();
}
function _get__envsUC__n5sgyq($this) {
  // Inline function 'kotlin.getValue' call
  _envsUC$factory();
  return $this.f43_1.p3();
}
function JsRuntime$_envs$delegate$lambda(this$0) {
  return function () {
    return this$0.p43();
  };
}
function JsRuntime$_envsUC$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$6;
    // Inline function 'kotlin.collections.mapKeys' call
    var tmp0_mapKeys = _get__envs__kxwcr8(this$0);
    var tmp$ret$5;
    // Inline function 'kotlin.collections.mapKeysTo' call
    var tmp0_mapKeysTo = LinkedHashMap.o8(mapCapacity(tmp0_mapKeys.o()));
    var tmp$ret$4;
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_associateByTo = tmp0_mapKeys.l3();
    var tmp0_iterator = tmp0_associateByTo.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$2;
      // Inline function 'korlibs.io.runtime.JsRuntime._envsUC$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$1;
      // Inline function 'kotlin.text.uppercase' call
      var tmp0_uppercase = element.o3();
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_uppercase;
      tmp$ret$1 = tmp$ret$0.toUpperCase();
      tmp$ret$2 = tmp$ret$1;
      var tmp = tmp$ret$2;
      var tmp$ret$3;
      // Inline function 'kotlin.collections.mapKeysTo.<anonymous>' call
      tmp$ret$3 = element.p3();
      tmp0_mapKeysTo.m3(tmp, tmp$ret$3);
    }
    tmp$ret$4 = tmp0_mapKeysTo;
    tmp$ret$5 = tmp$ret$4;
    tmp$ret$6 = tmp$ret$5;
    return toMap_0(tmp$ret$6);
  };
}
function _envs$factory() {
  return getPropertyCallableRef('_envs', 1, KProperty1, function (receiver) {
    return _get__envs__kxwcr8(receiver);
  }, null);
}
function _envsUC$factory() {
  return getPropertyCallableRef('_envsUC', 1, KProperty1, function (receiver) {
    return _get__envsUC__n5sgyq(receiver);
  }, null);
}
function JsRuntimeBrowser$href$delegate$lambda() {
  var tmp0_safe_receiver = document.location;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.href;
  return tmp1_elvis_lhs == null ? '.' : tmp1_elvis_lhs;
}
function JsRuntimeBrowser$baseUrl$delegate$lambda() {
  return endsWith(JsRuntimeBrowser_getInstance().z43(), '/') ? JsRuntimeBrowser_getInstance().z43() : substringBeforeLast(JsRuntimeBrowser_getInstance().z43(), _Char___init__impl__6a9atx(47));
}
var JsRuntimeBrowser_instance;
function JsRuntimeBrowser_getInstance() {
  if (JsRuntimeBrowser_instance === VOID)
    new JsRuntimeBrowser();
  return JsRuntimeBrowser_instance;
}
var Companion_instance_15;
function Companion_getInstance_20() {
  if (Companion_instance_15 === VOID)
    new Companion_15();
  return Companion_instance_15;
}
function HttpClientBrowserJs$requestInternal$lambda($xhr, $deferred) {
  return function (e) {
    var tmp$ret$3;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = $xhr.response;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    var tmp1_unsafeCast = new Int8Array(tmp$ret$1);
    var tmp$ret$2;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$2 = tmp1_unsafeCast;
    tmp$ret$3 = tmp$ret$2;
    var out = tmp$ret$3;
    return $deferred.p2v(new Response($xhr.status, $xhr.statusText, Headers.s3p($xhr.getAllResponseHeaders()), openAsync(out), openAsync(out)));
  };
}
function HttpClientBrowserJs$requestInternal$lambda_0($deferred, $xhr, $url) {
  return function (e) {
    return $deferred.o2v(RuntimeException.u6('Error status=' + $xhr.status + ",'" + $xhr.statusText + "' opening " + $url));
  };
}
function HttpClientBrowserJs$requestInternal$lambda_1($deferred, $xhr) {
  return function (it) {
    var tmp;
    if ($deferred.c2w()) {
      $xhr.abort();
      tmp = Unit_getInstance();
    }
    return Unit_getInstance();
  };
}
function href$factory() {
  return getPropertyCallableRef('href', 1, KProperty1, function (receiver) {
    return receiver.z43();
  }, null);
}
function baseUrl$factory() {
  return getPropertyCallableRef('baseUrl', 1, KProperty1, function (receiver) {
    return receiver.a44();
  }, null);
}
var JsRuntimeDeno_instance;
function JsRuntimeDeno_getInstance() {
  if (JsRuntimeDeno_instance === VOID)
    new JsRuntimeDeno();
  return JsRuntimeDeno_instance;
}
function get_nodeFS() {
  _init_properties_JsRuntimeNode_kt__v0s2kf();
  // Inline function 'kotlin.getValue' call
  nodeFS$factory();
  return nodeFS$delegate.p3();
}
var nodeFS$delegate;
function _get_fs__ndc19a($this) {
  // Inline function 'kotlin.getValue' call
  fs$factory();
  return $this.e45_1.p3();
}
function _get_path__dbvv7q($this) {
  // Inline function 'kotlin.getValue' call
  path$factory();
  return $this.f45_1.p3();
}
function JsRuntimeNode$fs$delegate$lambda() {
  return require_node('fs');
}
function JsRuntimeNode$path$delegate$lambda() {
  return require_node('path');
}
var JsRuntimeNode_instance;
function JsRuntimeNode_getInstance() {
  if (JsRuntimeNode_instance === VOID)
    new JsRuntimeNode();
  return JsRuntimeNode_instance;
}
function require_node(name) {
  _init_properties_JsRuntimeNode_kt__v0s2kf();
  return eval('(' + get_REQ() + "uire('" + name + "'))");
}
function getFullPath($this, path) {
  return normalize(get_pathInfo(path));
}
function NodeJsLocalVfs$stat$lambda($deferred, this$0, $path) {
  return function (err, stats) {
    var tmp$ret$3;
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      var tmp$ret$1;
      // Inline function 'kotlin.Companion.success' call
      var tmp0_success = Companion_getInstance_0();
      var tmp$ret$0;
      // Inline function 'korlibs.io.runtime.node.NodeJsLocalVfs.stat.<anonymous>.<anonymous>' call
      tmp$ret$0 = this$0.g45(stats, $path);
      var tmp1_success = tmp$ret$0;
      tmp$ret$1 = _Result___init__impl__xyqfz8(tmp1_success);
      tmp = tmp$ret$1;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        var tmp$ret$2;
        // Inline function 'kotlin.Companion.failure' call
        var tmp2_failure = Companion_getInstance_0();
        tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(e));
        tmp_0 = tmp$ret$2;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    tmp$ret$3 = tmp;
    completeWith($deferred, tmp$ret$3);
    return Unit_getInstance();
  };
}
function NodeJsLocalVfs$_open$lambda($path, $cmode, $cancellable, $file) {
  return function (err, fd) {
    var tmp;
    if (!(err == null) ? true : fd == null) {
      var tmp$ret$1;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var tmp0_resumeWithException = FileNotFoundException.u3l("Can't open '" + $path + "' with mode '" + $cmode + "': err=" + err);
      var tmp$ret$0;
      // Inline function 'kotlin.Companion.failure' call
      var tmp0_failure = Companion_getInstance_0();
      tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(tmp0_resumeWithException));
      $cancellable.bg(tmp$ret$0);
      tmp$ret$1 = Unit_getInstance();
      tmp = tmp$ret$1;
    } else {
      var tmp$ret$3;
      // Inline function 'kotlin.coroutines.resume' call
      var tmp1_resume = toAsyncStream(new NodeFDStream($file, fd));
      var tmp$ret$2;
      // Inline function 'kotlin.Companion.success' call
      var tmp0_success = Companion_getInstance_0();
      tmp$ret$2 = _Result___init__impl__xyqfz8(tmp1_resume);
      $cancellable.bg(tmp$ret$2);
      tmp$ret$3 = Unit_getInstance();
      tmp = tmp$ret$3;
    }
    return Unit_getInstance();
  };
}
function NodeJsLocalVfs$_open$lambda_0(it) {
  return Unit_getInstance();
}
function HttpClientNodeJs$requestInternal$lambda$lambda($body) {
  return function (d) {
    return $body.push(d);
  };
}
function HttpClientNodeJs$requestInternal$lambda$lambda_0($body, $statusCode, $statusMessage, $jsHeadersObj, $deferred) {
  return function () {
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_asDynamic = get_jsGlobal();
    tmp$ret$0 = tmp0_asDynamic;
    var r = tmp$ret$0.Buffer.concat($body);
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    tmp$ret$1 = r;
    var u8array = new Int8Array(tmp$ret$1);
    var out = new Int8Array(u8array.length);
    var inductionVariable = 0;
    var last = u8array.length;
    var tmp;
    if (inductionVariable < last) {
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$3;
        // Inline function 'org.khronos.webgl.get' call
        var tmp$ret$2;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$2 = u8array;
        tmp$ret$3 = tmp$ret$2[n];
        out[n] = tmp$ret$3;
      }
       while (inductionVariable < last);
      tmp = Unit_getInstance();
    }
    var tmp$ret$8;
    // Inline function 'kotlin.collections.mapValues' call
    var tmp1_elvis_lhs = jsToObjectMap($jsHeadersObj);
    var tmp1_mapValues = tmp1_elvis_lhs == null ? LinkedHashMap.n8() : tmp1_elvis_lhs;
    var tmp$ret$7;
    // Inline function 'kotlin.collections.mapValuesTo' call
    var tmp0_mapValuesTo = LinkedHashMap.o8(mapCapacity(tmp1_mapValues.o()));
    var tmp$ret$6;
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_associateByTo = tmp1_mapValues.l3();
    var tmp0_iterator = tmp0_associateByTo.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$4;
      // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
      tmp$ret$4 = element.o3();
      var tmp_0 = tmp$ret$4;
      var tmp$ret$5;
      // Inline function 'korlibs.io.runtime.node.HttpClientNodeJs.requestInternal.<anonymous>.<anonymous>.<anonymous>' call
      tmp$ret$5 = toString_0(element.p3());
      tmp0_mapValuesTo.m3(tmp_0, tmp$ret$5);
    }
    tmp$ret$6 = tmp0_mapValuesTo;
    tmp$ret$7 = tmp$ret$6;
    tmp$ret$8 = tmp$ret$7;
    var response = new Response($statusCode, $statusMessage, Headers.h3m(tmp$ret$8), openAsync(out), openAsync(out));
    return $deferred.p2v(response);
  };
}
function HttpClientNodeJs$requestInternal$lambda($deferred) {
  return function (res) {
    var statusCode = res.statusCode;
    var tmp0_elvis_lhs = res.statusMessage;
    var statusMessage = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    var jsHeadersObj = res.headers;
    var body = jsEmptyArray();
    res.on('data', HttpClientNodeJs$requestInternal$lambda$lambda(body));
    return res.on('end', HttpClientNodeJs$requestInternal$lambda$lambda_0(body, statusCode, statusMessage, jsHeadersObj, $deferred));
  };
}
function HttpClientNodeJs$requestInternal$lambda_0($deferred) {
  return function (e) {
    return $deferred.o2v(RuntimeException.u6('Error: ' + e));
  };
}
function HttpClientNodeJs$requestInternal$lambda_1($deferred, $r) {
  return function (it) {
    var tmp;
    if ($deferred.c2w()) {
      tmp = $r.abort();
    }
    return Unit_getInstance();
  };
}
function get_REQ() {
  _init_properties_JsRuntimeNode_kt__v0s2kf();
  return 'req';
}
function checkFd($this) {
  if ($this.y46_1 == null) {
    // Inline function 'kotlin.error' call
    var tmp0_error = 'File ' + $this.x46_1 + ' already closed';
    throw IllegalStateException.y1(toString(tmp0_error));
  }
}
function NodeFDStream$read$lambda(this$0, $cancellable) {
  return function (err, bytesRead, buf) {
    var tmp;
    if (!(err == null)) {
      var tmp$ret$1;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var tmp0_resumeWithException = IOException.l3o('Error reading from ' + this$0.x46_1 + ' :: err=' + err);
      var tmp$ret$0;
      // Inline function 'kotlin.Companion.failure' call
      var tmp0_failure = Companion_getInstance_0();
      tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(tmp0_resumeWithException));
      $cancellable.bg(tmp$ret$0);
      tmp$ret$1 = Unit_getInstance();
      tmp = tmp$ret$1;
    } else {
      var tmp$ret$3;
      // Inline function 'kotlin.coroutines.resume' call
      var tmp$ret$2;
      // Inline function 'kotlin.Companion.success' call
      var tmp0_success = Companion_getInstance_0();
      tmp$ret$2 = _Result___init__impl__xyqfz8(bytesRead);
      $cancellable.bg(tmp$ret$2);
      tmp$ret$3 = Unit_getInstance();
      tmp = tmp$ret$3;
    }
    return Unit_getInstance();
  };
}
function NodeFDStream$read$lambda_0(it) {
  return Unit_getInstance();
}
function NodeFDStream$getLength$lambda(this$0, $cancellable) {
  return function (err, stats) {
    var tmp;
    if (!(err == null)) {
      var tmp$ret$1;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var tmp0_resumeWithException = IOException.l3o('Error getting length from ' + this$0.x46_1 + ' :: err=' + err);
      var tmp$ret$0;
      // Inline function 'kotlin.Companion.failure' call
      var tmp0_failure = Companion_getInstance_0();
      tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(tmp0_resumeWithException));
      $cancellable.bg(tmp$ret$0);
      tmp$ret$1 = Unit_getInstance();
      tmp = tmp$ret$1;
    } else {
      var tmp$ret$3;
      // Inline function 'kotlin.coroutines.resume' call
      var tmp1_resume = numberToLong(stats.size);
      var tmp$ret$2;
      // Inline function 'kotlin.Companion.success' call
      var tmp0_success = Companion_getInstance_0();
      tmp$ret$2 = _Result___init__impl__xyqfz8(tmp1_resume);
      $cancellable.bg(tmp$ret$2);
      tmp$ret$3 = Unit_getInstance();
      tmp = tmp$ret$3;
    }
    return Unit_getInstance();
  };
}
function NodeFDStream$getLength$lambda_0(it) {
  return Unit_getInstance();
}
function NodeFDStream$close$lambda(this$0, $cancellable) {
  return function (err) {
    this$0.y46_1 = null;
    var tmp;
    if (!(err == null)) {
      var tmp$ret$1;
      // Inline function 'kotlin.coroutines.resume' call
      var tmp$ret$0;
      // Inline function 'kotlin.Companion.success' call
      var tmp0_success = Companion_getInstance_0();
      tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_getInstance());
      $cancellable.bg(tmp$ret$0);
      tmp$ret$1 = Unit_getInstance();
      tmp = tmp$ret$1;
    } else {
      var tmp$ret$3;
      // Inline function 'kotlin.coroutines.resume' call
      var tmp$ret$2;
      // Inline function 'kotlin.Companion.success' call
      var tmp0_success_0 = Companion_getInstance_0();
      tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_getInstance());
      $cancellable.bg(tmp$ret$2);
      tmp$ret$3 = Unit_getInstance();
      tmp = tmp$ret$3;
    }
    return Unit_getInstance();
  };
}
function NodeFDStream$close$lambda_0(it) {
  return Unit_getInstance();
}
function toNodeJsBuffer(_this__u8e3s4) {
  _init_properties_JsRuntimeNode_kt__v0s2kf();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return asUint8Array(_this__u8e3s4);
}
function asUint8Array(_this__u8e3s4) {
  _init_properties_JsRuntimeNode_kt__v0s2kf();
  var i = asInt8Array(_this__u8e3s4);
  return new Uint8Array(i.buffer, i.byteOffset, i.length);
}
function asInt8Array(_this__u8e3s4) {
  _init_properties_JsRuntimeNode_kt__v0s2kf();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
function nodeFS$delegate$lambda() {
  _init_properties_JsRuntimeNode_kt__v0s2kf();
  return require_node('fs');
}
function nodeFS$factory() {
  return getPropertyCallableRef('nodeFS', 0, KProperty0, function () {
    return get_nodeFS();
  }, null);
}
function fs$factory() {
  return getPropertyCallableRef('fs', 1, KProperty1, function (receiver) {
    return _get_fs__ndc19a(receiver);
  }, null);
}
function path$factory() {
  return getPropertyCallableRef('path', 1, KProperty1, function (receiver) {
    return _get_path__dbvv7q(receiver);
  }, null);
}
var properties_initialized_JsRuntimeNode_kt_f9ymrl;
function _init_properties_JsRuntimeNode_kt__v0s2kf() {
  if (!properties_initialized_JsRuntimeNode_kt_f9ymrl) {
    properties_initialized_JsRuntimeNode_kt_f9ymrl = true;
    nodeFS$delegate = lazy(nodeFS$delegate$lambda);
  }
}
//region block: post-declaration
setMetadataFor(_async$slambda, '_async$slambda', classMeta, VOID, VOID, VOID, VOID, [1]);
setMetadataFor(AsyncThread$sync$slambda, 'AsyncThread$sync$slambda', classMeta, VOID, VOID, VOID, VOID, [0]);
setMetadataFor(AsyncThread, 'AsyncThread', classMeta, VOID, VOID, VOID, VOID, [0, 1]);
setMetadataFor(Companion, 'Companion', objectMeta);
setMetadataFor(Dyn, 'Dyn', classMeta, VOID, [Comparable], VOID, VOID, [2, 1]);
setMetadataFor(VfsNamed, 'VfsNamed', classMeta);
setMetadataFor(Vfs$Proxy$initOnce$slambda, 'Vfs$Proxy$initOnce$slambda', classMeta, VOID, VOID, VOID, VOID, [0]);
setMetadataFor($initOnceCOROUTINE$44, '$initOnceCOROUTINE$44', classMeta);
setMetadataFor($openCOROUTINE$46, '$openCOROUTINE$46', classMeta);
setMetadataFor($readRangeCOROUTINE$47, '$readRangeCOROUTINE$47', classMeta);
setMetadataFor($statCOROUTINE$50, '$statCOROUTINE$50', classMeta);
setMetadataFor(Vfs, 'Vfs', classMeta, VOID, VOID, VOID, VOID, [0, 3, 2, 4, 1]);
setMetadataFor(Proxy, 'Proxy', classMeta, VOID, VOID, VOID, VOID, [1, 0, 4, 2, 3]);
setMetadataFor($readRangeCOROUTINE$34, '$readRangeCOROUTINE$34', classMeta);
setMetadataFor(VfsOpenMode, 'VfsOpenMode', classMeta);
setMetadataFor(VfsStat, 'VfsStat', classMeta);
setMetadataFor(Companion_0, 'Companion', objectMeta);
protoOf(VfsCachedStatContext).vf = get;
protoOf(VfsCachedStatContext).qj = fold;
protoOf(VfsCachedStatContext).pj = minusKey;
protoOf(VfsCachedStatContext).rj = plus;
setMetadataFor(VfsCachedStatContext, 'VfsCachedStatContext', classMeta, VOID, [Element]);
setMetadataFor($readStringCOROUTINE$65, '$readStringCOROUTINE$65', classMeta);
setMetadataFor($statCOROUTINE$68, '$statCOROUTINE$68', classMeta);
setMetadataFor(VfsFile, 'VfsFile', classMeta, VOID, VOID, VOID, VOID, [2, 3, 0, 1, 4, 5]);
setMetadataFor($getLengthCOROUTINE$88, '$getLengthCOROUTINE$88', classMeta);
setMetadataFor(CatalogVfs$open$slambda, 'CatalogVfs$open$slambda', classMeta, VOID, VOID, VOID, VOID, [1]);
setMetadataFor(AsyncGetLengthStream, 'AsyncGetLengthStream', interfaceMeta, VOID, VOID, VOID, VOID, [0]);
protoOf(AsyncStreamBase).i3f = hasLength;
setMetadataFor(AsyncStreamBase, 'AsyncStreamBase', classMeta, VOID, [AsyncGetLengthStream], VOID, VOID, [4, 1, 0]);
protoOf(CatalogVfs$open$2).i3f = hasLength;
setMetadataFor(CatalogVfs$open$2, VOID, classMeta, VOID, VOID, VOID, VOID, [4, 1, 0]);
setMetadataFor($openCOROUTINE$81, '$openCOROUTINE$81', classMeta);
setMetadataFor($statCOROUTINE$82, '$statCOROUTINE$82', classMeta);
setMetadataFor($statOrNullCOROUTINE$83, '$statOrNullCOROUTINE$83', classMeta);
setMetadataFor($cachedListSimpleStatsOrNullCOROUTINE$86, '$cachedListSimpleStatsOrNullCOROUTINE$86', classMeta);
setMetadataFor($listSimpleStatsOrNullCOROUTINE$87, '$listSimpleStatsOrNullCOROUTINE$87', classMeta);
setMetadataFor(CatalogVfs, 'CatalogVfs', classMeta, VOID, VOID, VOID, VOID, [2, 1, 0, 4, 3]);
setMetadataFor(Companion_1, 'Companion', objectMeta);
setMetadataFor(JailVfs, 'JailVfs', classMeta, VOID, VOID, VOID, VOID, [1, 0, 4, 3, 2]);
setMetadataFor(StandardVfs, 'StandardVfs', classMeta);
setMetadataFor(Companion_2, 'Companion', objectMeta);
setMetadataFor(LocalVfs, 'LocalVfs', classMeta, VOID, VOID, VOID, VOID, [1, 0, 3, 4, 2]);
setMetadataFor($readCOROUTINE$113, '$readCOROUTINE$113', classMeta);
setMetadataFor($getLengthCOROUTINE$114, '$getLengthCOROUTINE$114', classMeta);
setMetadataFor(UrlVfs$open$2, VOID, classMeta, VOID, VOID, VOID, VOID, [4, 0, 1]);
setMetadataFor($openCOROUTINE$107, '$openCOROUTINE$107', classMeta);
setMetadataFor($_readRangeBaseCOROUTINE$109, '$_readRangeBaseCOROUTINE$109', classMeta);
setMetadataFor($readRangeCOROUTINE$110, '$readRangeCOROUTINE$110', classMeta);
setMetadataFor($statCOROUTINE$112, '$statCOROUTINE$112', classMeta);
setMetadataFor(UrlVfs, 'UrlVfs', classMeta, VOID, VOID, VOID, VOID, [2, 1, 3, 0, 4]);
setMetadataFor(Charset, 'Charset', classMeta);
setMetadataFor(BaseSingleByteCharset, 'BaseSingleByteCharset', classMeta);
setMetadataFor(SingleByteCharset, 'SingleByteCharset', classMeta);
setMetadataFor(ISO_8859_1, 'ISO_8859_1', objectMeta);
setMetadataFor(UTF16Charset, 'UTF16Charset', classMeta);
setMetadataFor(Companion_3, 'Companion', objectMeta);
setMetadataFor(UTC8CharsetBase, 'UTC8CharsetBase', classMeta);
setMetadataFor(Companion_4, 'Companion', objectMeta);
setMetadataFor(InvalidOperationException, 'InvalidOperationException', classMeta);
setMetadataFor(IOException, 'IOException', classMeta);
setMetadataFor(FileAlreadyExistsException, 'FileAlreadyExistsException', classMeta);
setMetadataFor(QueryString, 'QueryString', objectMeta);
setMetadataFor(Companion_5, 'Companion', objectMeta);
setMetadataFor(URL, 'URL', classMeta);
setMetadataFor(Companion_6, 'Companion', objectMeta);
setMetadataFor(Companion_7, 'Companion', objectMeta);
setMetadataFor(Companion_8, 'Companion', objectMeta);
setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(Methods, 'Methods', classMeta);
setMetadataFor(HttpException, 'HttpException', classMeta);
setMetadataFor(Headers, 'Headers', classMeta, VOID, [Iterable]);
setMetadataFor(Companion_9, 'Companion', objectMeta, VOID, VOID, VOID, VOID, [4]);
setMetadataFor($readAllBytesCOROUTINE$118, '$readAllBytesCOROUTINE$118', classMeta);
setMetadataFor($readAllStringCOROUTINE$119, '$readAllStringCOROUTINE$119', classMeta);
setMetadataFor($checkErrorsCOROUTINE$120, '$checkErrorsCOROUTINE$120', classMeta);
setMetadataFor(Companion_10, 'Companion', objectMeta);
setMetadataFor(Response, 'Response', classMeta, VOID, VOID, VOID, VOID, [0, 1]);
setMetadataFor(CompletedResponse, 'CompletedResponse', classMeta);
setMetadataFor(RequestConfig, 'RequestConfig', classMeta);
setMetadataFor(Companion_11, 'Companion', objectMeta);
setMetadataFor($requestCOROUTINE$123, '$requestCOROUTINE$123', classMeta);
setMetadataFor($requestAsBytesCOROUTINE$125, '$requestAsBytesCOROUTINE$125', classMeta);
setMetadataFor($readBytesCOROUTINE$126, '$readBytesCOROUTINE$126', classMeta);
setMetadataFor(HttpClient, 'HttpClient', classMeta, VOID, VOID, VOID, VOID, [4, 5, 2]);
setMetadataFor(HttpStatusMessage, 'HttpStatusMessage', objectMeta);
setMetadataFor(ProxiedHttpFactory, 'ProxiedHttpFactory', classMeta);
setMetadataFor(Companion_12, 'Companion', objectMeta);
setMetadataFor(Context, 'Context', classMeta);
setMetadataFor(Json, 'Json', objectMeta);
setMetadataFor(AsyncStream$read$slambda, 'AsyncStream$read$slambda', classMeta, VOID, VOID, VOID, VOID, [0]);
setMetadataFor($readCOROUTINE$147, '$readCOROUTINE$147', classMeta);
setMetadataFor($readInternalCOROUTINE$149, '$readInternalCOROUTINE$149', classMeta);
setMetadataFor($getAvailableCOROUTINE$151, '$getAvailableCOROUTINE$151', classMeta);
setMetadataFor(AsyncGetPositionStream, 'AsyncGetPositionStream', interfaceMeta, VOID, VOID, VOID, VOID, [0]);
setMetadataFor(AsyncPositionLengthStream, 'AsyncPositionLengthStream', interfaceMeta, VOID, [AsyncGetPositionStream, AsyncGetLengthStream], VOID, VOID, [1, 0]);
protoOf(AsyncStream).i3f = hasLength;
setMetadataFor(AsyncStream, 'AsyncStream', classMeta, VOID, [AsyncGetPositionStream, AsyncGetLengthStream, AsyncPositionLengthStream], VOID, VOID, [3, 1, 0]);
setMetadataFor($hasLengthCOROUTINE$158, '$hasLengthCOROUTINE$158', classMeta);
setMetadataFor($_readCOROUTINE$162, '$_readCOROUTINE$162', classMeta);
protoOf(BufferedStreamBase).i3f = hasLength;
setMetadataFor(BufferedStreamBase, 'BufferedStreamBase', classMeta, VOID, VOID, VOID, VOID, [4, 1, 0]);
protoOf(MemoryAsyncStreamBase).i3f = hasLength;
setMetadataFor(MemoryAsyncStreamBase, 'MemoryAsyncStreamBase', classMeta, VOID, VOID, VOID, VOID, [1, 0, 4]);
setMetadataFor($readAllCOROUTINE$154, '$readAllCOROUTINE$154', classMeta);
setMetadataFor($readBytesExactCOROUTINE$157, '$readBytesExactCOROUTINE$157', classMeta);
setMetadataFor($readExactCOROUTINE$163, '$readExactCOROUTINE$163', classMeta);
setMetadataFor($readBytesCOROUTINE$167, '$readBytesCOROUTINE$167', classMeta);
setMetadataFor($readBytesUpToCOROUTINE$169, '$readBytesUpToCOROUTINE$169', classMeta);
setMetadataFor($readBytesUpToCopyCOROUTINE$174, '$readBytesUpToCopyCOROUTINE$174', classMeta);
setMetadataFor($getAvailableCOROUTINE$175, '$getAvailableCOROUTINE$175', classMeta);
setMetadataFor($readBytesUpToCOROUTINE$176, '$readBytesUpToCOROUTINE$176', classMeta);
setMetadataFor(NumberParser, 'NumberParser', objectMeta);
setMetadataFor(Companion_13, 'Companion', objectMeta);
setMetadataFor(BaseStrReader, 'BaseStrReader', classMeta);
setMetadataFor(StrReader, 'StrReader', classMeta);
setMetadataFor(DynamicInternal, 'DynamicInternal', objectMeta, VOID, VOID, VOID, VOID, [2, 3]);
setMetadataFor(standardVfs$1, VOID, classMeta);
setMetadataFor(EnvironmentInternal, 'EnvironmentInternal', objectMeta);
setMetadataFor(FileNotFoundException, 'FileNotFoundException', classMeta);
setMetadataFor(EOFException, 'EOFException', classMeta);
setMetadataFor(JS_UTF8$1, VOID, classMeta);
setMetadataFor(httpFactory$2$1, VOID, classMeta);
setMetadataFor(Companion_14, 'Companion', objectMeta);
setMetadataFor(JsRuntime, 'JsRuntime', classMeta, VOID, VOID, VOID, VOID, [1, 4]);
setMetadataFor(JsRuntimeBrowser, 'JsRuntimeBrowser', objectMeta, VOID, VOID, VOID, VOID, [1, 4]);
setMetadataFor(Companion_15, 'Companion', objectMeta);
setMetadataFor($requestInternalCOROUTINE$179, '$requestInternalCOROUTINE$179', classMeta);
setMetadataFor(HttpClientBrowserJs, 'HttpClientBrowserJs', classMeta, VOID, VOID, VOID, VOID, [4, 5, 2]);
setMetadataFor(JsRuntimeDeno, 'JsRuntimeDeno', objectMeta, VOID, VOID, VOID, VOID, [1, 4]);
setMetadataFor(JsRuntimeNode, 'JsRuntimeNode', objectMeta, VOID, VOID, VOID, VOID, [1, 4]);
setMetadataFor($openCOROUTINE$183, '$openCOROUTINE$183', classMeta);
setMetadataFor(NodeJsLocalVfs, 'NodeJsLocalVfs', classMeta, VOID, VOID, VOID, VOID, [2, 1, 4, 0, 3]);
setMetadataFor($requestInternalCOROUTINE$188, '$requestInternalCOROUTINE$188', classMeta);
setMetadataFor(HttpClientNodeJs, 'HttpClientNodeJs', classMeta, VOID, VOID, VOID, VOID, [4, 5, 2]);
setMetadataFor($closeCOROUTINE$191, '$closeCOROUTINE$191', classMeta);
protoOf(NodeFDStream).i3f = hasLength;
setMetadataFor(NodeFDStream, 'NodeFDStream', classMeta, VOID, VOID, VOID, VOID, [4, 1, 0]);
//endregion
//region block: init
resourcesVfsDebug = false;
customEnvironments = null;
MINUS_ZERO_D = -0.0;
File_separatorChar = _Char___init__impl__6a9atx(47);
//endregion
//region block: exports
export {
  asyncImmediately as a,
  localVfs as b,
};
//endregion

//# sourceMappingURL=korge-root-korio.mjs.map
